/// <reference path="../../../teva/htmlhelpers/htmlhelpers.ts" />
/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/accordion/accordion.ts" />
/// <reference path="../../common/common/common.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/forms/forms.ts" />
/// <reference path="../../common/resources/resources.ts" />
/// <reference path="../../common/inputs/corporatenumbervalidation/corporatenumbervalidation.ts" />
/// <reference path="../../common/tableshortcuts/tableshortcuts.ts" />
/// <reference path="../../crm/entitypicker/entitypicker.ts" />
/// <reference path="../../crm/entitieslist/entitieslist.ts" />
/// <reference path="../../layout/sidebar/sidebar.ts" />
/// <reference path="../accounting/accounting.ts" />

namespace OfficeGuy.Apps {
    interface TransactionType {
        ID: number;
        Code: string;
        Name: string;
        Details: string;
        DebitAccount: number;
        CreditAccount: number;
        Value?: number;
        AllowVAT: boolean;
        AllowTaxWithholding: boolean;
        AllowCustomer?: DebitCreditEnum;
        AllowSupplier?: DebitCreditEnum;
        AllowBank?: DebitCreditEnum;
        Debit?: TransactionTypeDetails[];
        Credit?: TransactionTypeDetails[];
    }
    interface TransactionTypeDetails {
        Account: number;
        Value: number;
        AccountType: number;
        IsPrimaryAccount: boolean;
    }
    const enum DebitCreditEnum {
        Debit = 1,
        Credit = 2,
        DebitOrCredit = 3
    }
    const enum AccountTypeEnum {
        Customer = 1,
        Supplier = 2,
        CustomerSupplier = 37,

        Bank = 10,

        Expense = 5,
        ExpenseNonDeductable = 30,
        Asset = 18,
        PropertyNonDeductable = 31,
        BalanceCancellation = 26,

        Income = 3,
        IncomeNoIncomeTax = 14,
        ExemptIncome = 4,
        ExemptIncomeNoIncomeTax = 24,
        ExemptIncomeNoVAT = 35,
        ExemptIncomeNoVATNoIncomeTax = 36,
        AssetIncome = 27,
        ExemptAssetIncome = 28,

        IncomeVAT = 6,
        ExpenseVAT = 7,
        AssetExpenseVAT = 15,
        ExpenseImportVAT = 29,
        ExpenseOtherDocumentVAT = 34,

        TaxWithholdingFromCustomers = 8,
        TaxWithholdingToSuppliers = 9,
    }
    interface Account {
        ID: number;
        Code: string;
        Name: string;
        Type: AccountTypeEnum;
        CompanyNumber: string;
        DefaultTransactionType: string;
        DefaultContraAccountID: number;
    }
    interface Currency {
        ID: number;
        Name: string;
    }
    interface Transaction {
        ID: number;
        Type?: string;
        ReferenceDate?: any;
        ValueDate?: any;
        DebitAccount: number;
        DebitAccountName?: string;
        DebitAccountCompanyNumber?: string;
        DebitAccountType?: AccountTypeEnum;
        CreditAccount: number;
        CreditAccountName?: string;
        CreditAccountCompanyNumber?: string;
        CreditAccountType?: AccountTypeEnum;
        CustomerSupplierAccount?: number;
        BankAccount?: number;
        AmountILS?: number;
        Reference1?: string;
        Reference2?: string;
        Details?: string;
        ForeignCurrency?: number;
        AmountForeign?: number;
        VATAmountILS?: number;
        ProfitAmountILS?: number;
        IncomeExpenseAmountILS?: number;
        TaxWithholdingAmountILS?: number;
        FileID?: number;
        FileGuid?: string;
        FileName?: string;
        FileHTML?: string;
        FilePDF?: boolean;
        FileRotate?: number;
        ImportedTransactionType?: string;
        Reported?: boolean;
        Exported?: boolean;
        DocumentID?: number;
        OCRReferenceDate?: Array<string>;
        OCRReference?: Array<string>;
        OCRAmountILS?: Array<string>;
        OCRCorporateNumber?: Array<number>;
        OCRVATRate?: number;
        OCRCustomersSuppliers?: Array<CustomerSupplierRecord>;
        OCRTransactionType?: Array<string>;
        OCRAbsolute?: boolean;
        ReviewDate?: any;
        DuplicateMessage?: string;
        CompanyNumber?: string;
        TransactionTypeMismatch?: string;
        Remarks?: string;
        BatchTransactionNumber?: number;
        TransactionNumber?: number;
        PagesCount?: number;
        BankSupported?: boolean;

        $Row?: JQuery<any>;
        $Type?: JQuery<any>;
        $Reference1?: JQuery<any>;
        $Reference2?: JQuery<any>;
        $ReferenceDate?: JQuery<any>;
        $AmountILS?: JQuery<any>;
        $DebitAccount?: JQuery<any>;
        $CreditAccount?: JQuery<any>;
        $CustomerSupplierAccount?: JQuery<any>;
        $BankAccount?: JQuery<any>;
        $Details?: JQuery<any>;
        $Remarks?: JQuery<any>;
        $ValueDate?: JQuery<any>;
        $ProfitAmountILS?: JQuery<any>;
        $IncomeExpenseAmountILS?: JQuery<any>;
        $VATAmountILS?: JQuery<any>;
        $TaxWithholdingAmountILS?: JQuery<any>;
        $ForeignCurrency?: JQuery<any>;
        $AmountForeign?: JQuery<any>;
        $CompanyNumber?: JQuery<any>;

        LineNumber?: number;
        SaveReview?: boolean;
        FileSavedToBatch?: boolean;
        SkipFindSimilar?: boolean;
        CreateAccounts?: boolean;
        DetailsPlaceholder?: string;
        InsertDate?: any;
        StatusInformation?: string;
        StatusWarning?: string;
        StatusError?: string;
        StatusDescription?: string;
        IsIncome?: boolean;
        IsExpense?: boolean;
        BatchID?: number;
        CalculatedVATAmountILS?: number;
        DuplicateKeys?: Array<string>;
        DuplicateGroups?: Array<DuplicateGroup>;
    }
    interface DuplicateGroup {
        Transactions: Array<Transaction>;
        TransactionIDs: string;
        DuplicateReason: number;
    };
    interface CustomerSupplierRecord {
        AccountID?: number;
        AccountCode: string;
        CompanyNumber: string;
        Name: string;
    }
    export class Books {
        static readonly BatchID_Expenses = -1;

        static DatabaseID;
        static BatchID;
        static BatchNumber;
        static BatchClosed;
        static BatchClosedEdit;
        static SingleEntryBatchView;
        static ShowForeign;
        static ShowCompanyNumber;
        static ShowReference2;
        static ShowTaxWithholding;
        static ShowProfitAmountILS;
        static ShowIncomeExpenseAmountILS;
        static ShowCustomerSupplier;
        static ShowBank;
        static ShowValueDate;
        static ShowVATAmountILS;
        static ShowRemarks;
        static ShowLineNumber;
        static ShowTransactionNumber;
        static AutomaticDetailsCustomer;
        static AutomaticDetailsExpense;
        static TransactionTypesSchemaID;
        static AccountsSchemaID;
        static DoubleEntrySystem;
        static IsAccountant;
        static IsExpenses;
        static IsReview;
        static ShowReviewed;
        static ExpensesReference2;
        static DefaultCurrency;
        static LastExpensesSavedTransaction;

        static TransactionTypePickerArray;
        static TransactionTypePickerDictionary: { [id: string]: TransactionType; };

        static AccountPickerArray;
        static AccountPickerDictionary: { [id: string]: Account; };

        static CurrenciesArray;
        static CurrenciesDictionary: { [id: string]: Currency; };

        static TransactionsArray: Array<Transaction>;
        static TransactionsArrayWithReviewed: Array<Transaction>;
        static TransactionsDuplicateKeys;
        static TransactionsDuplicateGroups: { [TransactionIDs: string]: DuplicateGroup; };

        static VisibleStartIndex: number;
        static DuplicateSettings;

        static InitBatch(DatabaseID, BatchID, BatchNumber, TransactionTypesSchemaID, AccountsSchemaID, SingleEntryBatchView, BatchClosed, DoubleEntrySystem, IsAccountant, FocusTransactionID, DuplicateSettingsValue) {

            $(document).one("Teva.PageLoad", function () {
                Books.BatchID = null;
                Books.BatchNumber = null;
                Books.BatchClosed = null;
                Books.BatchClosedEdit = null;
                Books.TransactionTypePickerArray = null;
                Books.TransactionTypePickerDictionary = null;
                Books.AccountPickerArray = null;
                Books.AccountPickerDictionary = null;
                Books.CurrenciesArray = null;
                Books.CurrenciesDictionary = null;
                Books.TransactionsDuplicateKeys = null;
                Books.TransactionsDuplicateGroups = null;
                Books.DoubleEntrySystem = null;
                Books.IsAccountant = null;
                Books.IsReview = null;
                Books.IsExpenses = null;
                Books.DuplicateSettings = null;
                Books.LastExpensesSavedTransaction = null;
            });

            Books.DatabaseID = DatabaseID;
            Books.BatchID = BatchID;
            Books.BatchNumber = BatchNumber;
            Books.BatchClosed = BatchClosed;
            Books.BatchClosedEdit = false;
            Books.SingleEntryBatchView = SingleEntryBatchView;
            Books.TransactionTypesSchemaID = TransactionTypesSchemaID;
            Books.AccountsSchemaID = AccountsSchemaID;
            Books.ShowReviewed = false;
            if (Books.IsSystemBatch())
                Books.SingleEntryBatchView = false;
            Books.DoubleEntrySystem = DoubleEntrySystem;
            Books.IsAccountant = IsAccountant;
            Books.IsReview = false;
            Books.IsExpenses = Books.BatchID == -1;

            Books.TransactionTypePickerArray = new Array();
            Books.TransactionTypePickerDictionary = {};
            Books.AccountPickerArray = new Array();
            Books.AccountPickerDictionary = {};
            Books.CurrenciesArray = new Array();
            Books.CurrenciesDictionary = {};
            Books.RefreshToggles(false);
            Books.InitDuplicateSettings(DuplicateSettingsValue);

            var $Table = $(".og-books-batch");
            Navigation.Loading_Show();
            Common.AjaxRequest({
                URL: "/books/fetchdata/?databaseid=" + Books.DatabaseID + "&batchid=" + BatchID + "&includetransactiontypes=true&includecurrencies=true&includeaccounts=true",
                SuccessMethod: function (Response) {
                    Books.InitPopulateTransactionTypes(Response.TransactionTypes);
                    Books.InitPopulateAccounts(Response.Accounts);
                    Books.InitPopulateCurrencies(Response.Currencies);
                    Books.TransactionsDuplicateKeys = new Array();
                    for (var i = 0; i < Books.DuplicateSettings.length; i++)
                        Books.TransactionsDuplicateKeys.push({});

                    Books.TransactionsArrayWithReviewed = null;
                    Books.TransactionsArray = new Array();
                    for (var i = 0; i < Response.Transactions.length; i++)
                        Books.InsertTransactionToTransactionsArray(Response.Transactions[i], -1);
                    $(".og-books-batch-reviewedhide, .og-books-batch-reviewedshow, .og-books-batch-cleanreviewedstate").hide();

                    Books.PopulateTransactionsDuplicateGroups();
                    if (!Books.IsExpenses && !Books.IsReview && !Books.BatchClosed)
                        Books.TransactionsArray.push(Books.GetEmptyTransaction());

                    Books.RenderTransactions(false);

                    for (var i = 0; i < Books.TransactionsArray.length; i++)
                        Books.UpdateTransactionStatus(Books.TransactionsArray[i], true);

                    $Table.show();
                    if (!Books.IsExpenses)
                        Teva.Positioning.StickyTable($Table);
                    Books.InitTableZoom();
                    if (FocusTransactionID != 0) {
                        for (var i = 0; i < Books.TransactionsArray.length; i++)
                            if (Books.TransactionsArray[i].ID == FocusTransactionID) {
                                if (Books.IsExpenses) {
                                    Books.RenderTransactions(false, i);
                                    Teva.Navigation.FocusOnFirstField($Table.find("tbody"));
                                }
                                else {
                                    Teva.Navigation.FocusOnFirstField(Books.TransactionsArray[i].$Row);
                                    if (Books.TransactionsArray[i].$Row) {
                                        Books.TransactionsArray[i].$Row.addClass("og-books-batch-row-highlight");
                                        setTimeout(function () {
                                            Books.TransactionsArray[i].$Row.removeClass("og-books-batch-row-highlight");
                                        }, 3500);
                                    }
                                }
                                break;
                            }
                    }
                    else if (Books.IsExpenses)
                        Teva.Navigation.FocusOnFirstField($Table.find("tbody"));
                    else if (!Books.BatchClosed)
                        Teva.Navigation.FocusOnFirstField($Table.find("tbody tr:last"));
                    Navigation.Loading_Hide();
                },
                ShowLoading: false
            });
            Books.InitBatchHeader();
            Books.BindTableEvents($Table);
            $(".og-books-batch-form").data("og-preventdirtysavetimeout", 5000);
        }
        static InsertTransactionToTransactionsArray(Transaction, Index) {
            if (Transaction.ReferenceDate != null)
                Transaction.ReferenceDate = new Date(Transaction.ReferenceDate);
            if (Transaction.ValueDate != null)
                Transaction.ValueDate = new Date(Transaction.ValueDate);
            if (!Books.ShowForeign && (Transaction.AmountForeign != null || Transaction.ForeignCurrency != 1)) {
                Books.ShowForeign = true;
                $(".og-books-batch-foreign").toggle(Books.ShowForeign);
            }
            if (!Books.ShowCompanyNumber && (Transaction.CompanyNumber != null && Transaction.CompanyNumber != '')) {
                Books.ShowCompanyNumber = true;
                $(".og-books-batch-companynumber").toggle(Books.ShowCompanyNumber);
            }
            if (!Books.ShowTaxWithholding && Transaction.TaxWithholdingAmountILS != null) {
                Books.ShowTaxWithholding = true;
                $(".og-books-batch-taxwithholding").toggle(true);
            }
            Transaction.DuplicateKeys = Books.GetTransactionDuplicateKeys(Transaction);
            if (Index == -1)
                Books.TransactionsArray.push(Transaction);
            else
                Books.TransactionsArray.splice(Index, 0, Transaction);
            Books.AddTransactionToDuplicateKeys(Transaction);
            Transaction.CalculatedVATAmountILS = Books.CalculateAccountTypeAmountFromTransaction(Transaction, Books.IsVATAccount);
        }
        static RotateImageClockwise(Event) {
            var $Image = $(Event.target).closest('.og-books-batch-image-cell').find('.og-books-batch-image-preview').find("img");
            var $Row = $(".og-books-batch tbody tr:not(.og-books-batch-duplicatemessage):first");
            var Transaction = Books.GetTransactionFromRow($Row);
            var Rotate = (Transaction.FileRotate + 90) % 360;
            Transaction.FileRotate = Rotate;
            $Row.addClass("og-books-batch-unsaved");
            Books.SaveTransaction($Row)
            Navigation.Loading_Show();
            $Image.on("load", function () {
                Navigation.Loading_Hide();
            });
            if (Rotate == 0)
                $Image.attr("src", $Image.data("originalsrc"));
            else
                $Image.attr("src", $Image.data("originalsrc") + "?rotate=" + Rotate);

            return false;
        }
        static RotateImageCounterClockwide(Event) {
            Navigation.Loading_Show();
            var $Image = $(Event.target).closest('.og-books-batch-image-cell').find('.og-books-batch-image-preview').find("img");
            var $Row = $(".og-books-batch tbody tr:not(.og-books-batch-duplicatemessage):first");
            var Transaction = Books.GetTransactionFromRow($Row)
            var Rotate = (Transaction.FileRotate + 270) % 360;
            Transaction.FileRotate = Rotate;
            $Row.addClass("og-books-batch-unsaved");
            Books.SaveTransaction($Row)
            $Image.on("load", function () {
                Navigation.Loading_Hide();
            });
            if (Rotate == 0)
                $Image.attr("src", $Image.data("originalsrc"));
            else
                $Image.attr("src", $Image.data("originalsrc") + "?rotate=" + Rotate);
            return false;
        }
        static ImageZoom(Event) {
            $(Event.target)
                .closest('.og-books-batch-image-cell').find('.og-books-batch-image-preview')
                .css("zoom", 1)
                .toggleClass("og-books-batch-image-preview-resize");
            return false;
        }
        static ImageZoomClick(Event) {
            var $Image = $(Event.target);
            $Image.closest('.og-books-batch-image-preview').removeClass("og-books-batch-image-preview-resize");
            var Zoom = <any>$Image.css("zoom");
            if (!Zoom)
                Zoom = 1;
            Zoom = Number(Zoom) + 0.25;
            if (Zoom > 2)
                Zoom = 1;
            $Image.css("zoom", Zoom).css("max-width", Zoom == 1 ? "100%" : "none");
            return false;
        }

        static BindTableEvents($Table) {
            $Table
                .on("change.og-books", "tr input", function (Event) {
                    var $Input = $(Event.target);
                    var $Row = $Input.closest("tr");
                    var Transaction = Books.GetTransactionFromRow($Row);
                    if (Transaction.Reported && Modals.VisibleModals.length == 0) {
                        var Handled = false;
                        var UndoEvent = function () {
                            if (Handled)
                                return false;

                            Handled = true;
                            $Row.empty();
                            Books.RenderTransactionInRow($Row, Transaction);
                            Books.RenderTransactionStatus($Row);
                            OfficeGuy.Common.InitEditors($Row);
                            return false;
                        };

                        Modals.ShowConfirmDialog({
                            Title: "עריכת תנועה שדווחה",
                            Message: "תנועה זו כבר דווחה לרשות אחת או יותר. עריכה של התנועה תגרום לפער בדיווחים.",
                            ConfirmText: "ביטול העריכה",
                            CancelText: "שמירת השינויים",
                            CancelAllowed: true,
                            CancelEvent: function () {
                                if (Handled)
                                    return false;

                                Transaction.Reported = null;
                                Transaction.Exported = null;
                                Transaction.ReviewDate = null;
                                Books.TransactionValueChanged($Input, $Table);
                                $Row.trigger("focusout");
                                return false;
                            },
                            ConfirmEvent: UndoEvent,
                            HideEvent: UndoEvent
                        });
                        return true;
                    }
                    if (Transaction.Exported) {
                        Modals.ShowConfirmDialog({
                            Title: "עריכת תנועה שיוצאה",
                            Message: "תנועה זו כבר יוצאה בפורמט חשבשבת או מבנה אחיד. עריכה של התנועה תגרום לפער בין התוכנות.",
                            ConfirmText: "ביטול העריכה",
                            CancelText: "שמירת השינויים",
                            CancelAllowed: true,
                            CancelEvent: function () {
                                Transaction.Exported = null;
                                Transaction.ReviewDate = null;
                                Books.TransactionValueChanged($Input, $Table);
                                $Row.trigger("focusout");
                                return false;
                            },
                            ConfirmEvent: function () {
                                $Row.empty();
                                Books.RenderTransactionInRow($Row, Transaction);
                                Books.RenderTransactionStatus($Row);
                                OfficeGuy.Common.InitEditors($Row);
                                return true;
                            }
                        });
                        return true;
                    }
                    if (Transaction.ReviewDate && !Books.IsReview) {
                        Modals.ShowConfirmDialog({
                            Title: "עריכת תנועה מבוקרת",
                            Message: "תנועה זו כבר עברה ביקורת. לשמור את השינוי בכל זאת?",
                            ConfirmText: "ביטול העריכה",
                            CancelText: "שמירת השינויים",
                            CancelAllowed: true,
                            CancelEvent: function () {
                                Transaction.ReviewDate = null;
                                Transaction.SaveReview = true;
                                Books.TransactionValueChanged($Input, $Table);
                                $Row.trigger("focusout");
                                return false;
                            },
                            ConfirmEvent: function () {
                                $Row.empty();
                                Books.RenderTransactionInRow($Row, Transaction);
                                Books.RenderTransactionStatus($Row);
                                OfficeGuy.Common.InitEditors($Row);
                                return true;
                            }
                        });
                        return true;
                    }
                    if ($Input.hasClass("og-input-calculator"))
                        Books.FieldCalculator($Input);
                    if ($Input.attr("name") == "VATAmountILS" && $Input.val() != "") {
                        if ((Transaction.AmountILS >= 0 && Number($Input.val()) > Transaction.AmountILS)
                            || (Transaction.AmountILS < 0 && Number($Input.val()) < Transaction.AmountILS))
                            $Input.val(Transaction.AmountILS);
                        else if ((Transaction.AmountILS >= 0 && Number($Input.val()) < 0)
                            || (Transaction.AmountILS < 0 && Number($Input.val()) > 0))
                            $Input.val('0');

                        if ($Input.val() == "0") {
                            if (Transaction.IncomeExpenseAmountILS && Transaction.VATAmountILS && Transaction.AmountILS == OfficeGuy.Common.RoundTwoPoints(Transaction.IncomeExpenseAmountILS + Transaction.VATAmountILS)) {
                                Transaction.ProfitAmountILS = null;
                                Transaction.$ProfitAmountILS.val(Transaction.ProfitAmountILS).trigger('change');

                                Transaction.IncomeExpenseAmountILS = OfficeGuy.Common.RoundTwoPoints(Transaction.IncomeExpenseAmountILS - Number($Input.val()) + Transaction.VATAmountILS);
                                Transaction.$IncomeExpenseAmountILS.val(Transaction.IncomeExpenseAmountILS).trigger('change');
                            }

                            Books.TransactionValueChanged($Input, $Table);
                            $Row.trigger("focusout");
                        }
                        else {
                            var Handled = false;
                            var UndoEvent = function () {
                                if (Handled)
                                    return false;

                                Handled = true;
                                $Row.empty();
                                Books.RenderTransactionInRow($Row, Transaction);
                                Books.RenderTransactionStatus($Row);
                                OfficeGuy.Common.InitEditors($Row);
                                return false;
                            };
                            setTimeout(function () {
                                Modals.ShowConfirmDialog({
                                    Title: "עריכה ידנית של המע\"מ",
                                    Message: "ערכת את המע\"מ ידנית. זה מה שהתכוונת לעשות? <br />בשביל לחזור למע\"מ האוטומטי, אפשר למחוק את התוכן של שדה המע\"מ.",
                                    ConfirmText: "ביטול העריכה",
                                    CancelText: "אישור מע\"מ ידני",
                                    CancelAllowed: true,
                                    CancelEvent: function () {
                                        Handled = true;

                                        var VATAmountILS = Transaction.VATAmountILS;
                                        if (!VATAmountILS)
                                            VATAmountILS = 0;

                                        if (Transaction.IncomeExpenseAmountILS && Transaction.AmountILS == Transaction.IncomeExpenseAmountILS + VATAmountILS) {
                                            Transaction.ProfitAmountILS = null;
                                            Transaction.$ProfitAmountILS.val(Transaction.ProfitAmountILS).trigger('change');

                                            Transaction.IncomeExpenseAmountILS = OfficeGuy.Common.RoundTwoPoints(Transaction.IncomeExpenseAmountILS - Number($Input.val()) + VATAmountILS);
                                            Transaction.$IncomeExpenseAmountILS.val(Transaction.IncomeExpenseAmountILS).trigger('change');
                                        }

                                        Books.TransactionValueChanged($Input, $Table);
                                        $Row.trigger("focusout");
                                        return true;
                                    },
                                    ConfirmEvent: UndoEvent,
                                    HideEvent: UndoEvent
                                });
                            }, navigator.maxTouchPoints > 1 ? 250 : 1);
                            return true;
                        }
                    }
                    return Books.TransactionValueChanged($Input, $Table);
                })
                .on("keypress.og-books", "tr input", function (Event) {
                    if ((Event.ctrlKey || Event.metaKey) && (Event.keyCode == 13 || Event.keyCode == 10)) {
                        var $Row = $(Event.target).closest("tr");
                        if ($Row.next().length == 0 && !Books.IsReview && !Books.IsExpenses && !Books.BatchClosed) {
                            var EmptyTransaction = Books.GetEmptyTransaction();
                            Books.TransactionsArray.push(EmptyTransaction);
                            Books.RenderTransaction($Table.find("tbody"), EmptyTransaction, true, false, false);
                        }
                        Teva.Navigation.FocusOnFirstField($Row.next());
                        return false;
                    }
                    else if (Event.key == "Enter")
                        return Books.BatchEnterKeyEvent(Event);
                    return true;
                })
                .on("keydown.og-books", "tr input, tr .teva-selectbox-label", function (Event) {
                    if (Event.key == "F3") {
                        Event.preventDefault();

                        var $Input = $(Event.target);
                        if ($Input.prop("readonly"))
                            return false;
                        var SelectBox = null;
                        if ($Input.is(".teva-selectbox-label")) {
                            SelectBox = Teva.SelectBox.GetInstance($Input.closest("td").find("input:hidden:last"));
                            if (SelectBox.Disabled)
                                return false;
                        }

                        var $Row = $Input.closest("tr");
                        var PreviousTransaction;
                        var $PreviousRow = $Row.prev();
                        if ($PreviousRow.hasClass("og-books-batch-ocr"))
                            $PreviousRow = $PreviousRow.prev();
                        PreviousTransaction = Books.GetTransactionFromRow($PreviousRow);
                        if (Books.IsExpenses && PreviousTransaction == null) {
                            if (Books.VisibleStartIndex == 0)
                                PreviousTransaction = Books.LastExpensesSavedTransaction;
                            else
                                PreviousTransaction = Books.TransactionsArray[Books.VisibleStartIndex - 1];
                        }
                        if (PreviousTransaction == null)
                            return false;

                        if (SelectBox) {
                            var PreviousValue = Books.GetInputValueFromTransaction(PreviousTransaction, $Input.closest("td").find("input:hidden:last").attr("name"));
                            SelectBox.SetValueFromQueryMethod(PreviousValue);
                        }
                        else {
                            var InputName = $Input.attr("name");
                            var PreviousValue = Books.GetInputValueFromTransaction(PreviousTransaction, InputName);
                            $Input.val(PreviousValue).trigger("change");
                        }

                        return false;
                    }
                    return true;
                })
                .on("focusout", "tr", function (Event) {
                    if ($(Event.relatedTarget).closest(".teva-selectbox-search").length > 0)
                        return;
                    if ($(Event.target).hasClass("teva-selectbox-search-terms-input"))
                        return;

                    var $SelectedRow = $(Event.relatedTarget).closest("tr");
                    var $PreviousRow = $(Event.currentTarget);
                    if ($SelectedRow.length == 1 && $SelectedRow[0] == $PreviousRow[0])
                        return;
                    if ($PreviousRow[0].hasClass("og-books-batch-unsaved"))
                        Books.SaveTransaction($PreviousRow);
                })
                .on("focusin", "td.og-books-batch-status", function () {
                    var $Row = $(this).closest("tr");
                    if ($Row[0].hasClass("og-books-batch-unsaved"))
                        Books.SaveTransaction($Row);
                    if ($Row.next().length == 0 && !Books.IsReview && !Books.IsExpenses && !Books.BatchClosed) {
                        var EmptyTransaction = Books.GetEmptyTransaction();
                        Books.TransactionsArray.push(EmptyTransaction);
                        Books.RenderTransaction($Table.find("tbody"), EmptyTransaction, true, false, false);
                    }
                })
                .on("click", ".og-books-batch-menu-link", Books.ShowMenu);
            $(document)
                .off("keydown.og-books")
                .on("keydown.og-books", ".teva-selectbox-search-terms-input", function (Event) {
                    if ($(".og-books-batch").length == 0) {
                        $(document).off("keydown.og-books");
                        return true;
                    }

                    if (Event.key == "F3") {
                        Event.preventDefault();

                        var SelectBox = $(Event.target).closest(".teva-selectbox-search").data("SelectBox");
                        var $Input = SelectBox.$Input;
                        if ($Input.prop("readonly") || SelectBox.Disabled)
                            return false;

                        var $Row = $Input.closest("tr");
                        var PreviousTransaction;
                        var $PreviousRow = $Row.prev();
                        if ($PreviousRow.hasClass("og-books-batch-ocr"))
                            $PreviousRow = $PreviousRow.prev();
                        PreviousTransaction = Books.GetTransactionFromRow($PreviousRow);
                        if (Books.IsExpenses && PreviousTransaction == null) {
                            if (Books.VisibleStartIndex == 0)
                                PreviousTransaction = Books.LastExpensesSavedTransaction;
                            else
                                PreviousTransaction = Books.TransactionsArray[Books.VisibleStartIndex - 1];
                        }
                        if (PreviousTransaction == null)
                            return false;

                        var PreviousValue = Books.GetInputValueFromTransaction(PreviousTransaction, $Input.closest("td").find("input:hidden:last").attr("name"));
                        SelectBox.HideResults();
                        if (SelectBox.SelectedValue != PreviousValue) {
                            SelectBox.SetValueFromQueryMethod(PreviousValue);
                            $Row.addClass("og-books-batch-unsaved");
                        }
                        SelectBox.$Label.focus();

                        return false;
                    }
                    return true;
                });

            if (Books.IsExpenses) {
                $Table
                    .on("click", ".og-books-batch-image-ocr-transactiontype", function () {
                        var $this = $(this);
                        var Transaction = Books.GetTransactionFromRow($this.closest("tr").prev());
                        var Instance = Teva.SelectBox.GetInstance(Transaction.$Type);
                        Instance.SetValueFromQueryMethod($this.text());
                        Instance.$Label.trigger('focus').trigger('select');
                        return false;
                    })
                    .on("click", ".og-books-batch-image-ocr-referencedate", function () {
                        var Transaction = Books.GetTransactionFromRow($(this).closest("tr").prev());
                        Transaction.$ReferenceDate.val($(this).text()).trigger("change").focus();
                        return false;
                    })
                    .on("click", ".og-books-batch-image-ocr-amountils", function () {
                        var Transaction = Books.GetTransactionFromRow($(this).closest("tr").prev());
                        Transaction.$AmountILS.val($(this).text()).trigger("change").focus();
                        return false;
                    })
                    .on("click", ".og-books-batch-image-ocr-amountforeign", function () {
                        var Transaction = Books.GetTransactionFromRow($(this).closest("tr").prev());
                        Transaction.$AmountILS.val("").trigger("change");
                        Transaction.$AmountForeign.val($(this).text()).trigger("change").focus();
                        return false;
                    })
                    .on("click", ".og-books-batch-image-ocr-reference", function () {
                        var $this = $(this);
                        var Transaction = Books.GetTransactionFromRow($this.closest("tr").prev());
                        var IsReference2 = $this.closest(".og-books-batch-reference2").length > 0;
                        Transaction[IsReference2 ? "$Reference2" : "$Reference1"].val($(this).text()).trigger("change").focus();
                        return false;
                    })
                    .on("click", ".og-books-batch-image-ocr-customersupplier", function () {
                        var $this = $(this);
                        var $Row = $this.closest("tr").prev();
                        var Transaction = Books.GetTransactionFromRow($Row);
                        var CustomerSupplierInstance = Teva.SelectBox.GetInstance(Transaction.$CustomerSupplierAccount);
                        var FocusInstance = CustomerSupplierInstance;
                        if ($this.data("accountid") == "-1") {
                            if (Transaction.Type) {
                                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                                if (TransactionType.AllowCustomer == DebitCreditEnum.Debit || TransactionType.AllowSupplier == DebitCreditEnum.Debit) {
                                    if (Books.DoubleEntrySystem)
                                        FocusInstance = Teva.SelectBox.GetInstance(Transaction.$DebitAccount);
                                    FocusInstance.SetValueFromQueryMethod(TransactionType.DebitAccount);
                                }
                                else if (TransactionType.AllowCustomer == DebitCreditEnum.Credit || TransactionType.AllowSupplier == DebitCreditEnum.Credit) {
                                    if (Books.DoubleEntrySystem)
                                        FocusInstance = Teva.SelectBox.GetInstance(Transaction.$CreditAccount);
                                    FocusInstance.SetValueFromQueryMethod(TransactionType.CreditAccount);
                                }
                            }
                        }
                        else if ($this.data("accountid"))
                            CustomerSupplierInstance.SetValueFromQueryMethod($this.data("accountid"));
                        else {
                            CustomerSupplierInstance.SetValue("", $this.text());
                            if (Transaction.Type) {
                                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                                if (TransactionType.AllowCustomer == DebitCreditEnum.Debit) {
                                    Transaction.DebitAccountName = $this.data("name");
                                    Transaction.DebitAccountType = AccountTypeEnum.Customer;
                                    Transaction.DebitAccountCompanyNumber = $this.data("companynumber");
                                    Transaction.$CompanyNumber.val($this.data("companynumber")).trigger('change');
                                    FocusInstance = Teva.SelectBox.GetInstance(Transaction.$DebitAccount);
                                    FocusInstance.SetValue("", $this.text());
                                }
                                else if (TransactionType.AllowSupplier == DebitCreditEnum.Debit) {
                                    Transaction.DebitAccountName = $this.data("name");
                                    Transaction.DebitAccountType = AccountTypeEnum.Supplier;
                                    Transaction.DebitAccountCompanyNumber = $this.data("companynumber");
                                    Transaction.$CompanyNumber.val($this.data("companynumber")).trigger('change');
                                    FocusInstance = Teva.SelectBox.GetInstance(Transaction.$DebitAccount);
                                    FocusInstance.SetValue("", $this.text());
                                }
                                else if (TransactionType.AllowCustomer == DebitCreditEnum.Credit) {
                                    Transaction.CreditAccountName = $this.data("name");
                                    Transaction.CreditAccountType = AccountTypeEnum.Customer;
                                    Transaction.CreditAccountCompanyNumber = $this.data("companynumber");
                                    Transaction.$CompanyNumber.val($this.data("companynumber")).trigger('change');
                                    FocusInstance = Teva.SelectBox.GetInstance(Transaction.$CreditAccount);
                                    FocusInstance.SetValue("", $this.text());
                                }
                                else if (TransactionType.AllowSupplier == DebitCreditEnum.Credit) {
                                    Transaction.CreditAccountName = $this.data("name");
                                    Transaction.CreditAccountType = AccountTypeEnum.Supplier;
                                    Transaction.CreditAccountCompanyNumber = $this.data("companynumber");
                                    Transaction.$CompanyNumber.val($this.data("companynumber")).trigger('change');
                                    FocusInstance = Teva.SelectBox.GetInstance(Transaction.$CreditAccount);
                                    FocusInstance.SetValue("", $this.text());
                                }
                            }
                        }
                        FocusInstance.$Label.trigger('focus').trigger('select');
                        return false;
                    });
            }
            if (!Books.IsExpenses && !Books.IsReview)
                OfficeGuy.TableShortcuts.Init($Table.find("tbody"));
        }
        static GetInputValueFromTransaction(Transaction, InputFieldName) {
            switch (InputFieldName) {
                case "Reference1": return Transaction.Reference1;
                case "Reference2": return Transaction.Reference2;
                case "ReferenceDate": return Teva.DatePicker.GetDateAsString(Transaction.ReferenceDate);
                case "ValueDate": return Teva.DatePicker.GetDateAsString(Transaction.ValueDate);
                case "AmountILS": return Transaction.AmountILS;
                case "AmountForeign": return Transaction.AmountForeign;
                case "Details": return Transaction.Details ? Transaction.Details : Transaction.DetailsPlaceholder;
                case "Remarks": return Transaction.Remarks;
                case "VATAmountILS": return Transaction.VATAmountILS;
                case "TaxWithholdingAmountILS": return Transaction.TaxWithholdingAmountILS;
                case "CompanyNumber": return Transaction.CompanyNumber;
                case "Type": return Transaction.Type;
                case "CustomerSupplierAccount": return Transaction.CustomerSupplierAccount;
                case "DebitAccount": return Transaction.DebitAccount;
                case "CreditAccount": return Transaction.CreditAccount;
                case "BankAccount": return Transaction.BankAccount;
                case "ForeignCurrency": return Transaction.ForeignCurrency;
                default: return "";
            };
        }

        static InitTableZoom() {
            if (!Common.IsBrowserLowResolution() && $(".og-books-batch").parent().width() - $(".og-books-batch").width() < (Books.IsExpenses ? 393 : 0)) {
                OfficeGuy.Layout.Sidebar.SetMode(false);
                $(".sumit-sidemenu")
                    .addClass("sumit-sidemenu-collapsed sumit-sidemenu-collapsed-stable");
                $("#main-page").addClass("main-page-sidemenucollapsed");

                $(document).one("Teva.PageLoad", function () {
                    if ($(".og-books-batch").length == 0)
                        OfficeGuy.Layout.Sidebar.RefreshSideMenuCollapsed();
                });
            }

            var PreviousZoom = 1;
            var Zoom = 1;
            $(window)
                .off("resize.og-books-batch")
                .on("resize.og-books-batch", function () {
                    var $Table = $(".og-books-batch");
                    if ($Table.length == 0) {
                        $(window).off("resize.og-books-batch");
                        return;
                    }
                    if (!Common.IsBrowserLowResolution()) {
                        Zoom = $(".og-books-batch").parent().width() / $(".og-books-batch").width();
                        if (Zoom > 1)
                            Zoom = 1;
                        else if (Zoom < 0.7)
                            Zoom = 0.7;
                    }
                    if (Zoom == PreviousZoom)
                        return;

                    var NavigationBarHeight = $(".og-navigation-bar").outerHeight();
                    if (!Books.IsExpenses) {
                        let Top = NavigationBarHeight;
                        Top += $Table.find("thead tr").height() * (1 - Zoom);
                        Top -= ($("html")[0].scrollTop - ($Table.offset().top - NavigationBarHeight + 15)) * (1 - 1 / Zoom);
                        $Table.find("thead th").css('top', Math.floor(Top) + "px");
                    }

                    if (!Books.IsExpenses) {
                        if (Zoom == 1 && PreviousZoom != 1)
                            $(window).off("scroll.og-books-batch");
                        if (Zoom != 1 && PreviousZoom == 1) {
                            $(window).on("scroll.og-books-batch", function () {
                                var $Table = $(".og-books-batch");
                                if ($Table.length == 0 || Books.IsExpenses) {
                                    $(window).off("scroll.og-books-batch");
                                    return;
                                }

                                var NavigationBarHeight = $(".og-navigation-bar").outerHeight();
                                let Top = NavigationBarHeight;
                                Top += $Table.find("thead tr").height() * (1 - Zoom);
                                Top -= ($("html")[0].scrollTop - ($Table.offset().top - NavigationBarHeight + 15)) * (1 - 1 / Zoom);
                                $Table.find("thead th").css('top', Math.floor(Top) + "px");
                            });
                        }
                    }

                    //$(".og-books-batch").css("zoom", Zoom);
                    $(".og-books-batch")
                        .css("transform", Zoom == 1 ? "" : "scale(" + Zoom + ")")
                        .css("transform-origin", Zoom == 1 ? "" : "right top");
                    $(".og-books-batch-container")
                        .css("margin-bottom", ($(".og-books-batch").innerHeight() * (Zoom - 1)) + "px");

                    PreviousZoom = Zoom;
                })
                .trigger("resize.og-books-batch");
        }
        static ParseInputNumber(Value: string) {
            Value = Value.replace(/[,‎]/g, '');
            if (Value == "")
                return null;

            var NumberValue = Number(Value);
            if (isNaN(NumberValue))
                return null;
            else
                return NumberValue;
        }
        static ParseInputNumberRoundTwoPoints(Value: string) {
            Value = Value.replace(/[,‎]/g, '');
            if (Value == "")
                return null;

            var NumberValue = Number(Value);
            if (isNaN(NumberValue))
                return null;
            else
                return Common.RoundTwoPoints(NumberValue);
        }

        static TransactionValueChanged($Input, $Table) {
            var $Row = $Input.closest("tr");
            var Row = $Row[0];
            var InputName = $Input.attr("name");
            var Transaction = Books.GetTransactionFromRow($Row);
            if (Transaction.TransactionTypeMismatch)
                return;

            var DelayedSave = true;
            if (InputName == "AmountILS") {
                Transaction.SkipFindSimilar = false;
                Transaction.DuplicateMessage = null;
                Transaction.AmountILS = Books.ParseInputNumberRoundTwoPoints($Input.val());
                if (Transaction.AmountILS != null && Transaction.ForeignCurrency && !Transaction.AmountForeign)
                    DelayedSave = false;
                Books.UpdateTransactionAmounts($Row);
            }
            else if (InputName == "ReferenceDate") {
                Transaction.SkipFindSimilar = false;
                Transaction.DuplicateMessage = null;
                $Input.trigger("change.datepicker");
                Transaction.ReferenceDate = Teva.DatePicker.GetDateFromString(<any>$Input.val(), Teva.DatePickerMode.Date);

                var PreviousTransaction = Books.GetTransactionFromRow($Row.prev());
                if (PreviousTransaction && PreviousTransaction.ReferenceDate && Transaction.ReferenceDate && Math.abs(PreviousTransaction.ReferenceDate.getTime() - Transaction.ReferenceDate.getTime()) > 1000 * 60 * 60 * 24 * 365)
                    Modals.ShowMessageDialog("התאריך נכון?", "המערכת זיהתה תאריך חריג. מומלץ לוודא שהוא נכון.");
            }
            else if (InputName == "ValueDate") {
                $Input.trigger("change.datepicker");
                Transaction.ValueDate = Teva.DatePicker.GetDateFromString(<any>$Input.val(), Teva.DatePickerMode.Date);
            }
            else if (InputName == "Reference1") {
                Transaction.DuplicateMessage = null;
                Transaction.Reference1 = $Input.val();
            }
            else if (InputName == "Reference2")
                Transaction.Reference2 = $Input.val();
            else if (InputName == "Details")
                Transaction.Details = $Input.val();
            else if (InputName == "Remarks")
                Transaction.Remarks = $Input.val();
            else if (InputName == "CompanyNumber")
                Transaction.CompanyNumber = $Input.val();
            else if (InputName == "Type") {
                Transaction.Type = $Input.val();
                Teva.SelectBox.GetInstance(Transaction.$CustomerSupplierAccount).Toggle(Books.TransactionTypeSupportsCustomerSupplier(Transaction.Type));
                //Teva.SelectBox.GetInstance(Transaction.$BankAccount).Toggle(Books.TransactionTypeSupportsBank(Transaction.Type));
                Books.RefreshTransactionColor($Row);
            }
            else if (InputName == "ForeignCurrency") {
                Transaction.ForeignCurrency = $Input.val();
                Transaction.$AmountForeign.attr("readonly", Books.BatchClosed || Transaction.ForeignCurrency == 1 || Transaction.TransactionTypeMismatch ? "readonly" : null);
                if (Transaction.ForeignCurrency == 1) {
                    Transaction.AmountILS = Transaction.AmountForeign;
                    Transaction.AmountForeign = null;
                }
                else {
                    if (Transaction.AmountForeign == null)
                        Transaction.AmountForeign = Transaction.AmountILS;
                    Transaction.AmountILS = null;
                }
                if (Books.IsExpenses) {
                    $Row.next().find(".og-books-batch-image-ocr-amountils").toggle(Transaction.ForeignCurrency == 1);
                    $Row.next().find(".og-books-batch-image-ocr-amountforeign").toggle(Transaction.ForeignCurrency != 1);
                }
                Transaction.$AmountForeign.val(Transaction.AmountForeign);
                Transaction.$AmountILS.val(Transaction.AmountILS).attr("placeholder", Transaction.ForeignCurrency == 1 ? null : "אוטומטי");
                if (Transaction.ForeignCurrency != 1)
                    DelayedSave = false;
            }
            else if (InputName == "AmountForeign") {
                Transaction.SkipFindSimilar = false;
                Transaction.AmountForeign = Books.ParseInputNumberRoundTwoPoints($Input.val());
                if (Transaction.AmountForeign != null) {
                    Transaction.AmountILS = null;
                    Transaction.$AmountILS.val('');
                }
                if (Transaction.AmountForeign != null || Transaction.AmountILS != null)
                    DelayedSave = false;
                Books.UpdateTransactionAmounts($Row);
            }
            else if (InputName == "DebitAccount") {
                Transaction.SkipFindSimilar = false;
                Transaction.DuplicateMessage = null;
                var PreviousAccount = Transaction.DebitAccount;
                Transaction.DebitAccount = Number($Input.val());
                if (isNaN(Transaction.DebitAccount))
                    Transaction.DebitAccount = 0;
                if (Transaction.DebitAccount != 0) {
                    Transaction.DebitAccountName = null;
                    Transaction.DebitAccountType = null;
                    Transaction.DebitAccountCompanyNumber = null;
                    // Clear value should also support this somehow
                }

                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                if (TransactionType != null) {
                    if (TransactionType.AllowCustomer == DebitCreditEnum.Debit || TransactionType.AllowSupplier == DebitCreditEnum.Debit) {
                        var CustomerSupplierAccountSelectBox = Teva.SelectBox.GetInstance(Transaction.$CustomerSupplierAccount);
                        if (Transaction.DebitAccount == 0 && !Transaction.DebitAccountName) {
                            Transaction.CustomerSupplierAccount = 0;
                            CustomerSupplierAccountSelectBox.ClearValue();
                        }
                        else {
                            Transaction.CustomerSupplierAccount = Transaction.DebitAccount;
                            CustomerSupplierAccountSelectBox.SetValueFromQueryMethod(Transaction.DebitAccount);
                        }
                    }
                    //else if (TransactionType.AllowBank == DebitCreditEnum.Debit) {
                    //    var BankAccountSelectBox = Teva.SelectBox.GetInstance(Transaction.$BankAccount);
                    //    if (Transaction.DebitAccount == 0 && !Transaction.DebitAccountName) {
                    //        Transaction.BankAccount = 0;
                    //        BankAccountSelectBox.ClearValue();
                    //    }
                    //    else {
                    //        Transaction.BankAccount = Transaction.DebitAccount;
                    //        BankAccountSelectBox.SetValueFromQueryMethod(Transaction.DebitAccount);
                    //    }
                    //}
                }

                //var Transaction = Books.GetTransactionFromRow($Row);

                Books.RefreshBankAccountFromAccounts(Transaction, PreviousAccount && PreviousAccount == Transaction.BankAccount, true, false);

                Books.RefreshTransactionBankSupport($Row);
                Books.RefreshTransactionDetailsPlaceholder($Row);
                Books.RefreshTransactionColor($Row);

                Transaction.ProfitAmountILS = null;
                Transaction.$ProfitAmountILS.val(Transaction.ProfitAmountILS).trigger('change');
                Transaction.IncomeExpenseAmountILS = null;
                Transaction.$IncomeExpenseAmountILS.val(Transaction.IncomeExpenseAmountILS).trigger('change');
            }
            else if (InputName == "CreditAccount") {
                Transaction.SkipFindSimilar = false;
                Transaction.DuplicateMessage = null;
                var PreviousAccount = Transaction.CreditAccount;
                Transaction.CreditAccount = Number($Input.val());
                if (isNaN(Transaction.CreditAccount))
                    Transaction.CreditAccount = 0;
                if (Transaction.CreditAccount != 0) {
                    Transaction.CreditAccountName = null;
                    Transaction.CreditAccountType = null;
                    Transaction.CreditAccountCompanyNumber = null;
                }

                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                if (TransactionType != null) {
                    if (TransactionType.AllowCustomer == DebitCreditEnum.Credit || TransactionType.AllowSupplier == DebitCreditEnum.Credit) {
                        var CustomerSupplierAccountSelectBox = Teva.SelectBox.GetInstance(Transaction.$CustomerSupplierAccount);
                        if (Transaction.CreditAccount == 0 && !Transaction.CreditAccountName) {
                            Transaction.CustomerSupplierAccount = 0;
                            CustomerSupplierAccountSelectBox.ClearValue();
                        }
                        else {
                            Transaction.CustomerSupplierAccount = Transaction.CreditAccount;
                            CustomerSupplierAccountSelectBox.SetValueFromQueryMethod(Transaction.CreditAccount);
                        }
                    }
                    //else if (TransactionType.AllowBank == DebitCreditEnum.Credit) {
                    //    var BankAccountSelectBox = Teva.SelectBox.GetInstance(Transaction.$BankAccount);
                    //    if (Transaction.CreditAccount == 0 && !Transaction.CreditAccountName) {
                    //        Transaction.BankAccount = 0;
                    //        BankAccountSelectBox.ClearValue();
                    //    }
                    //    else {
                    //        Transaction.BankAccount = Transaction.CreditAccount;
                    //        BankAccountSelectBox.SetValueFromQueryMethod(Transaction.CreditAccount);
                    //    }
                    //}
                }
                Books.RefreshBankAccountFromAccounts(Transaction, PreviousAccount && PreviousAccount == Transaction.BankAccount, false, true);

                Books.RefreshTransactionBankSupport($Row);
                Books.RefreshTransactionDetailsPlaceholder($Row);
                Books.RefreshTransactionColor($Row);
                Transaction.ProfitAmountILS = null;
                Transaction.$ProfitAmountILS.val(Transaction.ProfitAmountILS).trigger('change');
                Transaction.IncomeExpenseAmountILS = null;
                Transaction.$IncomeExpenseAmountILS.val(Transaction.IncomeExpenseAmountILS).trigger('change');
            }
            else if (InputName == "CustomerSupplierAccount") {
                Transaction.SkipFindSimilar = false;
                Transaction.DuplicateMessage = null;
                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                var Account = Number($Input.val());
                var BankSelectBox = Teva.SelectBox.GetInstance($Input);
                if (isNaN(Account))
                    Account = 0;
                Transaction.CustomerSupplierAccount = Account;
                if (Account != 0 || !BankSelectBox.SelectedText) {
                    if (TransactionType != null && (TransactionType.AllowCustomer == DebitCreditEnum.Debit || TransactionType.AllowSupplier == DebitCreditEnum.Debit)) {
                        Books.SetAccount(Teva.SelectBox.GetInstance(Transaction.$DebitAccount), Account);
                        if (Account != 0) {
                            var ContraAccount = Books.AccountPickerDictionary[Account].DefaultContraAccountID;
                            if (ContraAccount != 0 && Transaction.CreditAccount == 0)
                                Teva.SelectBox.GetInstance(Transaction.$CreditAccount).SetValueFromQueryMethod(ContraAccount);
                        }
                    }
                    else if (TransactionType != null && (TransactionType.AllowCustomer == DebitCreditEnum.Credit || TransactionType.AllowSupplier == DebitCreditEnum.Credit)) {
                        Books.SetAccount(Teva.SelectBox.GetInstance(Transaction.$CreditAccount), Account);
                        if (Account != 0) {
                            Teva.SelectBox.GetInstance(Transaction.$CreditAccount).SetValueFromQueryMethod(Account);
                            var ContraAccount = Books.AccountPickerDictionary[Account].DefaultContraAccountID;
                            if (ContraAccount != 0 && Transaction.DebitAccount == 0)
                                Teva.SelectBox.GetInstance(Transaction.$DebitAccount).SetValueFromQueryMethod(ContraAccount);
                        }
                    }
                }
                Books.RefreshTransactionColor($Row);
            }
            else if (InputName == "BankAccount") {
                Transaction.SkipFindSimilar = false;
                Transaction.DuplicateMessage = null;
                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                var Account = Number($Input.val());
                var BankSelectBox = Teva.SelectBox.GetInstance($Input);
                if (isNaN(Account))
                    Account = 0;
                var PreviousAccount = Transaction.BankAccount;
                Transaction.BankAccount = Account;
                //if (Account != 0 || !BankSelectBox.SelectedText) {
                //    if (TransactionType != null && TransactionType.AllowBank == DebitCreditEnum.Debit)
                //        Books.SetAccount(Teva.SelectBox.GetInstance(Transaction.$DebitAccount), Account);
                //    else if (TransactionType != null && TransactionType.AllowBank == DebitCreditEnum.Credit)
                //        Books.SetAccount(Teva.SelectBox.GetInstance(Transaction.$CreditAccount), Account);
                //}
                if ((Account != 0 || !BankSelectBox.SelectedText) && !$Input.data("PreventEvent")) {
                    if (Transaction.DebitAccount == PreviousAccount)
                        Books.SetAccount(Teva.SelectBox.GetInstance(Transaction.$DebitAccount), Account);
                    else if (Transaction.CreditAccount == PreviousAccount)
                        Books.SetAccount(Teva.SelectBox.GetInstance(Transaction.$CreditAccount), Account);
                }
                Books.RefreshTransactionColor($Row);
            }
            else if (InputName == "VATAmountILS") {
                var InputValue = $Input.val();
                if (InputValue === "") {
                    Transaction.CalculatedVATAmountILS = Books.CalculateAccountTypeAmountFromTransaction(Transaction, Books.IsVATAccount);
                    Transaction.VATAmountILS = Transaction.CalculatedVATAmountILS;
                }
                else {
                    Transaction.VATAmountILS = Books.ParseInputNumber(InputValue);
                    if (Transaction.VATAmountILS != null)
                        Transaction.VATAmountILS = Common.RoundTwoPoints(Math.abs(Transaction.VATAmountILS) * (Transaction.AmountILS > 0 ? 1 : -1));
                }
                $Input.val(Books.FormatNumber(Transaction.VATAmountILS));

                Transaction.ProfitAmountILS = null;
                Transaction.$ProfitAmountILS.val(Transaction.ProfitAmountILS).trigger('change');
                Transaction.IncomeExpenseAmountILS = null;
                Transaction.$IncomeExpenseAmountILS.val(Transaction.IncomeExpenseAmountILS).trigger('change');
            }
            else if (InputName == "TaxWithholdingAmountILS") {
                var InputValue = $Input.val();
                if (InputValue === "")
                    Transaction.TaxWithholdingAmountILS = Books.CalculateAccountTypeAmountFromTransaction(Transaction, Books.IsTaxWithholdingAccount);
                else if (InputValue[InputValue.length - 1] == '%')
                    Transaction.TaxWithholdingAmountILS = Common.RoundTwoPoints(Transaction.AmountILS * Books.ParseInputNumberRoundTwoPoints(InputValue.substring(0, InputValue.length - 1)) / 100)
                else {
                    Transaction.TaxWithholdingAmountILS = Books.ParseInputNumberRoundTwoPoints(InputValue);
                    if (Transaction.TaxWithholdingAmountILS != null) {
                        if ((Transaction.AmountILS >= 0 && Transaction.TaxWithholdingAmountILS > Transaction.AmountILS)
                            || (Transaction.AmountILS < 0 && Transaction.TaxWithholdingAmountILS < Transaction.AmountILS)) {
                            Transaction.TaxWithholdingAmountILS = Transaction.AmountILS;
                            $Input.val(Transaction.AmountILS);
                        }
                        else if ((Transaction.AmountILS >= 0 && Transaction.TaxWithholdingAmountILS < 0)
                            || (Transaction.AmountILS < 0 && Transaction.TaxWithholdingAmountILS > 0)) {
                            Transaction.TaxWithholdingAmountILS = 0;
                            $Input.val('0');
                        }
                    }
                }
                $Input.val(Books.FormatNumber(Transaction.TaxWithholdingAmountILS));
            }

            var Timeout = $Row.data("Timeout");
            if (Timeout != null)
                clearTimeout(Timeout);

            if (DelayedSave) {
                $Row.data("Timeout", setTimeout(function () {
                    Books.SaveTransaction($Row);
                }, 1000 * 10));
                Row.addClass("og-books-batch-unsaved");
            }
            else {
                Row.addClass("og-books-batch-unsaved");
                Books.SaveTransaction($Row);
            }

            Books.RefreshTransactionDuplicateKeys($Row, false);

            if (Row.hasClass("og-books-batch-saving")) {
                Row.addClass("og-books-batch-pendingresave");
                return;
            }

            Forms.SetDirty($(".og-books-batch-form"));

            Books.UpdateTransactionStatus(Transaction, true);
            Books.RefreshTransactionColor($Row);

            if ($Row.next().length == 0 && $Input.val() != null && (<string>$Input.val()).length > 0 && !Books.IsReview && !Books.IsExpenses && !Books.BatchClosed) {
                var EmptyTransaction = Books.GetEmptyTransaction();
                Books.TransactionsArray.push(EmptyTransaction);
                Books.RenderTransaction($Table.find("tbody"), EmptyTransaction, true, false, false);
            }
            return true;
        }

        static RefreshBankAccountFromAccounts(Transaction: Transaction, ClearIfEmpty: boolean, DebitChanged: boolean, CreditChanged: boolean) {
            var DebitAccountType: AccountTypeEnum = null;
            var CreditAccountType: AccountTypeEnum = null;
            if (Transaction.DebitAccountType)
                DebitAccountType = Transaction.DebitAccountType;
            else if (Transaction.DebitAccount != 0)
                DebitAccountType = Books.AccountPickerDictionary[Transaction.DebitAccount].Type;
            if (Transaction.CreditAccountType)
                CreditAccountType = Transaction.CreditAccountType;
            else if (Transaction.CreditAccount != 0)
                CreditAccountType = Books.AccountPickerDictionary[Transaction.CreditAccount].Type;

            Transaction.$BankAccount.data("PreventEvent", true);
            if (DebitAccountType == AccountTypeEnum.Bank && CreditAccountType == AccountTypeEnum.Bank)
                Teva.SelectBox.GetInstance(Transaction.$BankAccount).ClearValue();
            else if (DebitAccountType == AccountTypeEnum.Bank && DebitChanged)
                Teva.SelectBox.GetInstance(Transaction.$BankAccount).SetValueFromQueryMethod(Transaction.DebitAccount);
            else if (CreditAccountType == AccountTypeEnum.Bank && CreditChanged)
                Teva.SelectBox.GetInstance(Transaction.$BankAccount).SetValueFromQueryMethod(Transaction.CreditAccount);
            else if (DebitAccountType == AccountTypeEnum.Bank)
                Teva.SelectBox.GetInstance(Transaction.$BankAccount).SetValueFromQueryMethod(Transaction.DebitAccount);
            else if (CreditAccountType == AccountTypeEnum.Bank)
                Teva.SelectBox.GetInstance(Transaction.$BankAccount).SetValueFromQueryMethod(Transaction.CreditAccount);
            else if (ClearIfEmpty)
                Teva.SelectBox.GetInstance(Transaction.$BankAccount).ClearValue();
            Transaction.$BankAccount.removeData("PreventEvent");
        }

        static SetAccount(SelectBoxInstance, AccountID) {
            if (AccountID == 0)
                SelectBoxInstance.ClearValue();
            else
                SelectBoxInstance.SetValueFromQueryMethod(AccountID);
        }

        static BatchEnterKeyEvent(Event) {
            var $Cell = $(Event.target).closest("td");
            if ($Cell.length == 0) {
                var $SelectBox = $(Event.target).closest(".teva-selectbox-search").data("SelectBox");
                if ($SelectBox)
                    $Cell = $SelectBox.$Input.closest("td");
            }

            if ($Cell.length == 0)
                return;

            var $Input = $Cell.nextAll("td:visible").find("input:not([disabled]):not([readonly]):not(.teva-selectbox-search-terms-input), a.teva-selectbox-label, a.og-button-ui-action:not([disabled=disabled])");
            if ($Input.length > 0)
                $Input.first().trigger('focus').trigger('select');
            else if (Books.IsExpenses) {
                var $Button = $Cell.nextAll("td:visible").find("a.og-button-ui-action:not([disabled=disabled]):first");
                if ($Button.length == 0) {
                    var $Row = $Cell.closest("tr");
                    Teva.Navigation.FocusOnFirstField($Row.nextAll(":not(.og-books-batch-ocr)").first());
                }
                else
                    $Button.trigger("click");
            }
            else if (Books.IsReview)
                Books.RenderTransactions(true, Books.VisibleStartIndex + 1);
            else if (!Books.BatchClosed) {
                var $Row = $Cell.closest("tr");
                if ($Row.next().length == 0 && !Books.IsReview && !Books.IsExpenses) {
                    var EmptyTransaction = Books.GetEmptyTransaction();
                    Books.TransactionsArray.push(EmptyTransaction);
                    Books.RenderTransaction($(".og-books-batch tbody"), EmptyTransaction, true, false, false);
                }
                Teva.Navigation.FocusOnFirstField($Row.next());
            }
            return false;
        }

        static GetEmptyTransaction() {
            return <Transaction>{
                ID: 0,
                DebitAccount: 0,
                CreditAccount: 0,
                ForeignCurrency: Books.DefaultCurrency,
                LineNumber: Books.TransactionsArray.length == 0 ? 1 : (Books.TransactionsArray[Books.TransactionsArray.length - 1].LineNumber + 1),
                ImportedTransactionType: null,
            };
        }
        static InitColumnResize($Table) {
            $Table.find("th").each(function () {
                var $this = $(this);
                var Width = $this.data("columnresize-default");
                if (!Width)
                    return;
                var Key = $this.data("columnresize-key");
                if (Key) {
                    var StoredWidth = Teva.Storage.LocalStorage_Get("Books.ColumnSize." + Key);
                    if (StoredWidth)
                        Width = StoredWidth;
                }

                $this
                    .css("width", Width + "px")
                    .addClass("og-columnresize")
                    .append(document.createElement("div").addClass("og-books-batch-columnresize"));
            });
            var $Element;
            var StartPosition;
            var StartWidth;

            var MouseDown = function (Event) {
                StartPosition = Event.clientX;
                $Element = $(Event.currentTarget);
                StartWidth = $Element.closest("th").width();
                $(document).on("mousemove.columnresize", MouseMove).on("mouseup.columnresize", MouseUp);

                Event.preventDefault();
                Event.stopPropagation();
            };

            var MouseMove = function (Event) {
                var NewWidth = StartPosition - Event.clientX + StartWidth;
                $Element.closest("th").width(NewWidth);
            };

            var MouseUp = function (Event) {
                $(document)
                    .off("mousemove.columnresize")
                    .off("mouseup.columnresize");
                var Key = $Element.closest("th").data("columnresize-key");
                if (Key)
                    Teva.Storage.LocalStorage_Set("Books.ColumnSize." + Key, $Element.closest("th").outerWidth());
                Event.preventDefault();
                Event.stopPropagation();
            };

            var DoubleClick = function (Event) {
                var $TH = $(Event.target).closest("th");
                var Key = $TH.data("columnresize-key");
                if (Key)
                    Teva.Storage.LocalStorage_Set("Books.ColumnSize." + Key, null);
                $TH.innerWidth($TH.data("columnresize-default"));
                Event.preventDefault();
                Event.stopPropagation();
            };

            $(".og-books-batch-columnresize")
                .on("mousedown", MouseDown)
                .on("click", function () {
                    return false;
                })
                .on("dblclick", DoubleClick);
        }
        static InitBatchHeader() {
            var $Row = $(document.createElement('tr'));
            if (Books.IsReview)
                $Row.append($(document.createElement('th')).css("width", "231px"));
            $Row.append($
                (document.createElement('th')
                    .setText('סוג תנועה'))
                .data("columnresize-default", 180)
                .data("columnresize-key", "TransactionType")
                .data("PropertyName", "Type")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('אסמכתא 1'))
                .data("columnresize-default", 126)
                .data("columnresize-key", "Reference1")
                .data("PropertyName", "Reference1")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('אסמכתא 2')
                    .addClass("og-books-batch-reference2"))
                .toggle(Books.ShowReference2)
                .data("columnresize-default", 126)
                .data("columnresize-key", "Reference2")
                .data("PropertyName", "Reference2")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('ת. אסמכתא'))
                .data("columnresize-default", 129)
                .data("columnresize-key", "ReferenceDate")
                .data("PropertyName", "ReferenceDate")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('סכום'))
                .data("columnresize-default", 126)
                .data("columnresize-key", "AmountILS")
                .data("PropertyName", "AmountILS")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('חשבון חובה ראשי')
                    .addClass("og-books-batch-full"))
                .toggle(!Books.SingleEntryBatchView)
                .data("columnresize-default", 180)
                .data("columnresize-key", "DebitAccount")
                .data("PropertyName", "DebitAccount")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('חשבון זכות ראשי')
                    .addClass("og-books-batch-full"))
                .toggle(!Books.SingleEntryBatchView)
                .data("columnresize-default", 180)
                .data("columnresize-key", "CreditAccount")
                .data("PropertyName", "CreditAccount")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('חשבון לקוח/ספק')
                    .addClass("og-books-batch-customersupplier"))
                .toggle(Books.ShowCustomerSupplier)
                .data("columnresize-default", 180)
                .data("columnresize-key", "CustomerSupplier")
                .data("PropertyName", "CustomerSupplierAccount")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('חשבון קופה/בנק')
                    .addClass("og-books-batch-bank"))
                .toggle(Books.ShowBank)
                .data("columnresize-default", 180)
                .data("columnresize-key", "Bank")
                .data("PropertyName", "BankAccount")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('פרטים'))
                .data("columnresize-default", 126)
                .data("columnresize-key", "Details")
                .data("PropertyName", "Details")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('הערות')
                    .addClass("og-books-batch-remarks"))
                .toggle(Books.ShowRemarks)
                .data("columnresize-default", 150)
                .data("columnresize-key", "Remarks")
                .data("PropertyName", "Remarks")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('תאריך ערך')
                    .addClass("og-books-batch-valuedate"))
                .toggle(Books.ShowValueDate)
                .data("columnresize-default", 126)
                .data("columnresize-key", "ValueDate")
                .data("PropertyName", "ValueDate")
            );
            $Row.append($
                (document.createElement('th')
                    .addClass("og-books-batch-profitamountils")
                    .setText('סכום לרווח והפסד'))
                .data("columnresize-default", 162)
                .data("columnresize-key", "ProfitAmountILS")
                .toggle(Books.ShowProfitAmountILS)
            );
            $Row.append($
                (document.createElement('th')
                    .addClass("og-books-batch-incomeexpenseamountils")
                    .setText('סכום לפני מע"מ'))
                .data("columnresize-default", 162)
                .data("columnresize-key", "IncomeExpenseAmountILS")
                .toggle(Books.ShowIncomeExpenseAmountILS)
            );
            $Row.append($
                (document.createElement('th')
                    .addClass("og-books-batch-vatamountils")
                    .setText('סכום מע"מ'))
                .data("PropertyName", "VATAmountILS")
                .data("columnresize-default", 126)
                .data("columnresize-key", "VATAmountILS")
                .toggle(Books.ShowVATAmountILS)
            );
            $Row.append($
                (document.createElement('th')
                    .setText('ניכוי במקור')
                    .addClass("og-books-batch-taxwithholding"))
                .toggle(Books.ShowTaxWithholding)
                .data("columnresize-default", 126)
                .data("columnresize-key", "TaxWithholding")
                .data("PropertyName", "TaxWithholdingAmountILS")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('מטבע')
                    .addClass("og-books-batch-foreign"))
                .toggle(Books.ShowForeign)
                .data("columnresize-default", 115)
                .data("columnresize-key", "ForeignCurrency")
                .data("PropertyName", "ForeignCurrency")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('סכום מט"ח')
                    .addClass("og-books-batch-foreign"))
                .toggle(Books.ShowForeign)
                .data("columnresize-default", 126)
                .data("columnresize-key", "ForeignAmount")
                .data("PropertyName", "AmountForeign")
            );
            $Row.append($
                (document.createElement('th')
                    .setText('מספר עוסק')
                    .addClass("og-books-batch-companynumber"))
                .toggle(Books.ShowCompanyNumber)
                .data("columnresize-default", 126)
                .data("columnresize-key", "CompanyNumber")
                .data("PropertyName", "CompanyNumber")
            );
            if (Books.IsExpenses) {
                $Row.append(document.createElement('th').addClass("og-books-batch-expensebuttons"));
            }
            $Row.append($(document.createElement('th')
                .addClass("og-books-batch-status"))
                .css("width", "39px")
            );
            $Row.append($
                (document.createElement('th')
                    .setText("תנועה")
                    .addClass("og-books-batch-transactionnumber"))
                .toggle(Books.ShowTransactionNumber)
                .data("columnresize-default", 80)
                .data("columnresize-key", "TransactionNumber")
                .data("PropertyName", "TransactionNumber")
            );
            $Row.append($(document.createElement('th')
                .addClass("og-books-batch-linenumber"))
                .toggle(Books.ShowLineNumber)
                .data("columnresize-default", 52)
                .data("columnresize-key", "LineNumber")
            );
            $Row.append($(document.createElement('th'))
                .css('padding-left', '0')
                .css('padding-right', '0')
                .css("width", Books.IsExpenses || Books.IsReview ? "126px" : "42px")
                .append($('<a class="entities-table-addfield using-tooltip" href="#" onclick="return OfficeGuy.Apps.Books.ShowColumnsMenu();" title="בחירת שדות לתצוגה"><span class="icon-sumit-cog"></span><span class="icon-angle-down"></span></a>'))
            );

            $(".og-books-batch thead").empty().append($Row);
            Books.InitColumnResize($(".og-books-batch"));

            if (!Books.IsExpenses && !Books.IsReview) {
                $Row.on("click", "th", function () {
                    Navigation.Loading_Show(true);
                    var $HeaderCell = $(this);
                    setTimeout(function () {
                        Books.Sort($HeaderCell);
                        Navigation.Loading_Hide();
                    }, 1);
                    return false;
                });
            }
        }
        static Sort($HeaderCell) {
            var PropertyName = $HeaderCell.data("PropertyName");
            if (PropertyName == null)
                return;
            if ($HeaderCell.find(".icon-down").length > 0)
                PropertyName = "ID";

            var Descending = $HeaderCell.find(".icon-up").length > 0;
            $(".og-books-batch thead th span.icon-down").remove();
            $(".og-books-batch thead th span.icon-up").remove();
            if (PropertyName != "ID") {
                $HeaderCell.append($(document.createElement('span'))
                    .addClass(Descending ? "icon-down" : "icon-up")
                );
            }

            var EmptyTransaction = Books.BatchClosed || Books.IsExpenses || Books.IsReview ? null : Books.TransactionsArray.splice(Books.TransactionsArray.length - 1)[0];
            Books.TransactionsArray.sort(function (a, b) {
                var Value_A = a[PropertyName];
                var Value_B = b[PropertyName];
                if (PropertyName == 'AmountILS' || PropertyName == 'AmountForeign') {
                    Value_A = Number(Value_A);
                    Value_B = Number(Value_B);
                }
                else if (PropertyName == 'DebitAccount' || PropertyName == 'CreditAccount') {
                    if (Value_A != 0)
                        Value_A = (<any>Books.AccountPickerDictionary[Value_A].Code).padStart(15, '0');
                    if (Value_B != 0)
                        Value_B = (<any>Books.AccountPickerDictionary[Value_B].Code).padStart(15, '0');
                }
                else if (PropertyName == "Reference1" || PropertyName == "Reference2") {
                    if (Value_A != null)
                        Value_A = Value_A.padStart(15, '0');
                    if (Value_B != null)
                        Value_B = Value_B.padStart(15, '0');
                }
                if (Value_A < Value_B)
                    return Descending ? 1 : -1;
                if (Value_A > Value_B)
                    return Descending ? -1 : 1;
                if (a.ID < b.ID)
                    return Descending ? 1 : -1;
                if (a.ID > b.ID)
                    return Descending ? -1 : 1;
                return 0;
            });
            if (EmptyTransaction != null)
                Books.TransactionsArray.push(EmptyTransaction);
            Books.RenderTransactions(true);
        }
        static InitPopulateTransactionTypes(TransactionTypes) {
            Books.TransactionTypePickerArray = new Array();
            Books.TransactionTypePickerDictionary = {};
            for (var i = 0; i < TransactionTypes.length; i++) {
                var TransactionType = TransactionTypes[i];
                Books.TransactionTypePickerArray.push({
                    id: TransactionType.Code,
                    text: Books.GetTransactionTypeText(TransactionType),
                    data: TransactionType
                });
                Books.TransactionTypePickerDictionary[TransactionType.Code] = TransactionType;
            }
        }
        static InitPopulateAccounts(Accounts) {
            for (var i = 0; i < Accounts.length; i++)
                Books.AppendAccount(Accounts[i], null, false);
        }
        static UpdateTransactionsAccountID(CompanyNumber: string, AccountID: number, AccountCode: string) {
            for (var i = 0; i < Books.TransactionsArray.length; i++) {
                var Transaction = Books.TransactionsArray[i];
                if (Transaction.OCRCustomersSuppliers) {
                    for (var j = 0; j < Transaction.OCRCustomersSuppliers.length; j++)
                        if (Transaction.OCRCustomersSuppliers[j].AccountID == null && Transaction.OCRCustomersSuppliers[j].CompanyNumber == CompanyNumber) {
                            Transaction.OCRCustomersSuppliers[j].AccountID = AccountID;
                            Transaction.OCRCustomersSuppliers[j].AccountCode = AccountCode;
                        }
                }
            }
            $(".og-books-batch-image-ocr-customersupplier").each(function () {
                var $this = $(this);
                if ($this.data("accountid") == null && $this.data("companynumber") == CompanyNumber) {
                    $this.data("accountid", AccountID);
                    $this.data("accountcode", AccountCode);
                    $this.text(AccountCode + " - " + $this.text());
                    var Transaction = Books.GetTransactionFromRow($this.closest("tr").prev());
                    if ((Transaction.DebitAccount == null || Transaction.DebitAccount == 0) && Transaction.DebitAccountCompanyNumber == CompanyNumber)
                        $this.trigger("click");
                    else if ((Transaction.CreditAccount == null || Transaction.CreditAccount == 0) && Transaction.CreditAccountCompanyNumber == CompanyNumber)
                        $this.trigger("click");
                }
            });
            for (var i = 0; i < Books.TransactionsArray.length; i++) {
                var Transaction = Books.TransactionsArray[i];
                if ((Transaction.DebitAccount == null || Transaction.DebitAccount == 0) && Transaction.DebitAccountCompanyNumber == CompanyNumber) {
                    Transaction.DebitAccount = AccountID;
                    Transaction.CustomerSupplierAccount = AccountID;
                }
                else if ((Transaction.CreditAccount == null || Transaction.CreditAccount == 0) && Transaction.CreditAccountCompanyNumber == CompanyNumber) {
                    Transaction.CreditAccount = AccountID;
                    Transaction.CustomerSupplierAccount = AccountID;
                }
            }
        }
        static AppendAccount(Account, CompanyNumber, Sort) {
            Books.AccountPickerDictionary[Account.ID] = Account;
            if (CompanyNumber)
                Books.UpdateTransactionsAccountID(CompanyNumber, Account.ID, Account.Code);
            var ArrayAccount = {
                id: Account.ID,
                text: Books.GetAccountText(Account),
                data: Account
            };
            if (Sort) {
                for (var i = 0; i < Books.AccountPickerArray.length; i++) {
                    if (Account.text < Books.AccountPickerArray[i].text) {
                        Books.AccountPickerArray.splice(i, 0, ArrayAccount);
                        return;
                    }
                }
            }
            Books.AccountPickerArray.push(ArrayAccount);
        }
        static InitPopulateCurrencies(Currencies) {
            for (var i = 0; i < Currencies.length; i++) {
                var Currency = Currencies[i];
                Books.CurrenciesArray.push({
                    id: Currency.ID,
                    text: Currency.Name
                });
                Books.CurrenciesDictionary[Currency.ID] = Currency;
            }
        }
        static GetTransactionDuplicateKeys(Transaction): Array<string> {
            var DuplicateKeys = new Array<string>();
            for (var i = 0; i < Books.DuplicateSettings.length; i++)
                DuplicateKeys.push(Books.PopulateTransactionDuplicateKeys(Transaction, Books.DuplicateSettings[i].Fields));

            return DuplicateKeys;
        }
        static GetTransactionDuplicateReason(DuplicateReason) {
            switch (DuplicateReason) {
                case 0: return "תאריך אסמכתא + אסמכתא 1 + סכום";
                case 1: return "תאריך אסמכתא + אסמכתא 2 + סכום";
                case 2: return "תאריך אסמכתא + חשבון חובה + 4 ספרות של אסמכתא 1";
                case 3: return "תאריך אסמכתא + חשבון חובה + 4 ספרות של אסמכתא 2";
                case 4: return "תאריך אסמכתא + חשבון זכות + 4 ספרות של אסמכתא 1";
                case 5: return "תאריך אסמכתא + חשבון זכות + 4 ספרות של אסמכתא 2";
                default: return "";
            }
        }

        static InitDuplicateSettings(Value) {
            Books.DuplicateSettings = new Array();
            if (Value & 1) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 1 + סכום בש"ח', //ReferenceDate_Last4Reference1_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'AmountILS' }
                    ]
                });
            }

            if (Value & 2) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 2 + סכום בש"ח', //ReferenceDate_Last4Reference2_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2', Type: 'Last4Chars' },
                        { Name: 'AmountILS' }
                    ]
                });
            }

            if (Value & 4) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 1 + חשבון חובה + סכום בש"ח', //ReferenceDate_Last4Reference1_DebitAccount_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'DebitAccount' },
                        { Name: 'AmountILS' }
                    ]
                });
            }

            if (Value & 8) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 2 + חשבון חובה + סכום בש"ח', //ReferenceDate_Last4Reference2_DebitAccount_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2', Type: 'Last4Chars' },
                        { Name: 'DebitAccount' },
                        { Name: 'AmountILS' }
                    ]
                });
            }

            if (Value & 16) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 1 + חשבון זכות + סכום בש"ח', //ReferenceDate_Last4Reference1_CreditAccount_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'CreditAccount' },
                        { Name: 'AmountILS' }
                    ]
                });
            }

            if (Value & 32) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 2 + חשבון זכות + סכום בש"ח', //ReferenceDate_Last4Reference2_CreditAccount_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2', Type: 'Last4Chars' },
                        { Name: 'CreditAccount' },
                        { Name: 'AmountILS' }
                    ]
                });
            }



            if (Value & 262144) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 1 + סכום בש"ח + תאריך ערך', //ReferenceDate_Last4Reference1_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'AmountILS' },
                        { Name: 'ValueDate' }
                    ]
                });
            }

            if (Value & 524288) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 2 + סכום בש"ח + תאריך ערך', //ReferenceDate_Last4Reference2_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2', Type: 'Last4Chars' },
                        { Name: 'AmountILS' },
                        { Name: 'ValueDate' }
                    ]
                });
            }

            if (Value & 1048576) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 1 + חשבון חובה + סכום בש"ח + תאריך ערך', //ReferenceDate_Last4Reference1_DebitAccount_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'DebitAccount' },
                        { Name: 'AmountILS' },
                        { Name: 'ValueDate' }
                    ]
                });
            }

            if (Value & 2097152) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 2 + חשבון חובה + סכום בש"ח + תאריך ערך', //ReferenceDate_Last4Reference2_DebitAccount_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2', Type: 'Last4Chars' },
                        { Name: 'DebitAccount' },
                        { Name: 'AmountILS' },
                        { Name: 'ValueDate' }
                    ]
                });
            }

            if (Value & 4194304) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 1 + חשבון זכות + סכום בש"ח + תאריך ערך', //ReferenceDate_Last4Reference1_CreditAccount_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'CreditAccount' },
                        { Name: 'AmountILS' },
                        { Name: 'ValueDate' }
                    ]
                });
            }

            if (Value & 8388608) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 2 + חשבון זכות + סכום בש"ח + תאריך ערך', //ReferenceDate_Last4Reference2_CreditAccount_AmountILS',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2', Type: 'Last4Chars' },
                        { Name: 'CreditAccount' },
                        { Name: 'AmountILS' },
                        { Name: 'ValueDate' }
                    ]
                });
            }



            if (Value & 64) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 1 + חשבון חובה', //ReferenceDate_Last4Reference1_DebitAccount',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'DebitAccount' }
                    ]
                });
            }

            if (Value & 128) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 2 + חשבון חובה', //ReferenceDate_Last4Reference2_DebitAccount',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2', Type: 'Last4Chars' },
                        { Name: 'DebitAccount' }
                    ]
                });
            }

            if (Value & 256) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 1 + חשבון זכות', //ReferenceDate_Last4Reference1_CreditAccount',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'CreditAccount' }
                    ]
                });
            }

            if (Value & 512) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + 4 ספרות אחרונות של אסמכתא 2 + חשבון זכות', //ReferenceDate_Last4Reference2_CreditAccount',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2', Type: 'Last4Chars' },
                        { Name: 'CreditAccount' }
                    ]
                });
            }

            if (Value & 1024) {
                Books.DuplicateSettings.push({
                    Message: 'אסמכתא 1 + סכום בש"ח', //AmountILS_Reference1',
                    Fields: [
                        { Name: 'AmountILS' },
                        { Name: 'Reference1' }
                    ]
                });
            }

            if (Value & 2048) {
                Books.DuplicateSettings.push({
                    Message: 'אסמכתא 2 + סכום בש"ח', //AmountILS_Reference2',
                    Fields: [
                        { Name: 'AmountILS' },
                        { Name: 'Reference2' }
                    ]
                });
            }

            if (Value & 4096) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + אסמכתא 1', //ReferenceDate_Reference1',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference1' }
                    ]
                });
            }

            if (Value & 8192) {
                Books.DuplicateSettings.push({
                    Message: 'תאריך אסמכתא + אסמכתא 2', //ReferenceDate_Reference2',
                    Fields: [
                        { Name: 'ReferenceDate' },
                        { Name: 'Reference2' }
                    ]
                });
            }

            if (Value & 16384) {
                Books.DuplicateSettings.push({
                    Message: 'חשבון חובה + אסמכתא 1', //DebitAccount_Reference1',
                    Fields: [
                        { Name: 'DebitAccount' },
                        { Name: 'Reference1' }
                    ]
                });
            }

            if (Value & 32768) {
                Books.DuplicateSettings.push({
                    Message: 'חשבון זכות + אסמכתא 1', //CreditAccount_Reference1',
                    Fields: [
                        { Name: 'CreditAccount' },
                        { Name: 'Reference1' }
                    ]
                });
            }

            if (Value & 65536) {
                Books.DuplicateSettings.push({
                    Message: 'חשבון חובה + 4 ספרות אחרונות של אסמכתא 1 + שנה', //DebitAccount_Last4Reference1_Year',
                    Fields: [
                        { Name: 'DebitAccount' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'ReferenceDate', Type: 'Year' }
                    ]
                });
            }

            if (Value & 131072) {
                Books.DuplicateSettings.push({
                    Message: 'חשבון זכות + 4 ספרות אחרונות של אסמכתא 1 + שנה', //CreditAccount_Last4Reference1_Year',
                    Fields: [
                        { Name: 'CreditAccount' },
                        { Name: 'Reference1', Type: 'Last4Chars' },
                        { Name: 'ReferenceDate', Type: 'Year' }
                    ]
                });
            }
        }

        static AddTransactionToDuplicateKeys(Transaction) {
            if (Books.IsExpenses || Books.IsReview)
                return;

            for (var i = 0; i < Transaction.DuplicateKeys.length; i++) {
                var Dictionary = Books.TransactionsDuplicateKeys[i];
                var Key = Transaction.DuplicateKeys[i];
                if (Key == null)
                    continue;

                var ExistingList = Dictionary[Key];
                if (ExistingList == null) {
                    ExistingList = new Array();
                    Dictionary[Key] = ExistingList;
                }
                ExistingList.push(Transaction);
                // Perhaps Should sort ExistingList by Transaction.ID to avoid sorting on GetTransactionsIDsString
            }
        }
        static RefreshTransactionDuplicateKeys($Row, IsRemove) {
            if (Books.IsExpenses || Books.IsReview)
                return;

            var Transaction = Books.GetTransactionFromRow($Row);
            var NewDuplicateKeys = IsRemove ? null : Books.GetTransactionDuplicateKeys(Transaction);
            if (!IsRemove && Books.EqualArrays(Transaction.DuplicateKeys, NewDuplicateKeys))
                return;

            // Remove from DuplicateKeys
            if (Transaction.DuplicateKeys != null) {
                for (var i = 0; i < Transaction.DuplicateKeys.length; i++) {
                    var DuplicateKey = Transaction.DuplicateKeys[i];
                    if (DuplicateKey != null) {
                        var ExistingKeys = Books.TransactionsDuplicateKeys[i][DuplicateKey];
                        if (ExistingKeys.length == 1)
                            Books.TransactionsDuplicateKeys[i][DuplicateKey] = null;
                        else
                            Books.SpliceSingleValueFromArray(ExistingKeys, Transaction);
                    }
                }
            }

            // Remove existing DuplicateGroups
            if (Transaction.DuplicateGroups != null) {
                for (var i = 0; i < Transaction.DuplicateGroups.length; i++) {
                    var DuplicateGroup = Transaction.DuplicateGroups[i];
                    Books.TransactionsDuplicateGroups[DuplicateGroup.TransactionIDs] = null;
                    for (var j = 0; j < DuplicateGroup.Transactions.length; j++) {
                        Books.SpliceSingleValueFromArray(DuplicateGroup.Transactions[j].DuplicateGroups, DuplicateGroup);
                        if (DuplicateGroup.Transactions[j].DuplicateGroups.length == 0)
                            DuplicateGroup.Transactions[j].DuplicateGroups = null;
                        Books.RenderTransactionStatus(DuplicateGroup.Transactions[j].$Row);
                    }

                    if (DuplicateGroup.Transactions.length == 2) {
                        // Remove duplicate group
                    }
                    else {
                        // Remove transaction from duplicate group
                        Books.SpliceSingleValueFromArray(DuplicateGroup.Transactions, Transaction);
                        DuplicateGroup.TransactionIDs = Books.GetTransactionsIDsString(DuplicateGroup.Transactions);
                        Books.TransactionsDuplicateGroups[DuplicateGroup.TransactionIDs] = DuplicateGroup;
                    }
                }
                Transaction.DuplicateGroups = null;
            }

            if (IsRemove)
                return;

            // Add to DuplicateKeys
            Transaction.DuplicateKeys = NewDuplicateKeys;
            Books.AddTransactionToDuplicateKeys(Transaction);

            // Add to DuplicateGroups
            for (var i = 0; i < Transaction.DuplicateKeys.length; i++)
                Books.PopulateTransactionsDuplicateGroupsByDuplicateKey(i, Transaction.DuplicateKeys[i]);

            if (Transaction.DuplicateGroups != null) {
                // Make sure not to render the same transaction status more than once?
                var RenderedTransactions = {};
                for (var i = 0; i < Transaction.DuplicateGroups.length; i++) {
                    var DuplicateGroup = Transaction.DuplicateGroups[i];
                    for (var j = 0; j < DuplicateGroup.Transactions.length; j++) {
                        var Transaction = DuplicateGroup.Transactions[j];
                        if (RenderedTransactions[Transaction.ID] == null) {
                            RenderedTransactions[Transaction.ID] = true;
                            Books.RenderTransactionStatus(Transaction.$Row);
                        }
                    }
                }
            }
        }
        static PopulateTransactionsDuplicateGroups() {
            Books.TransactionsDuplicateGroups = {};
            for (var i = 0; i < Books.TransactionsDuplicateKeys.length; i++) {
                var Dictionary = Books.TransactionsDuplicateKeys[i];
                var DuplicateKeys = Object.keys(Dictionary);
                for (var j = 0; j < DuplicateKeys.length; j++)
                    Books.PopulateTransactionsDuplicateGroupsByDuplicateKey(i, DuplicateKeys[j]);
            }
        }
        static PopulateTransactionsDuplicateGroupsByDuplicateKey(TransactionsDuplicateKeysIndex: number, DuplicateKey: string) {
            if (DuplicateKey == null)
                return;

            var Dictionary = Books.TransactionsDuplicateKeys[TransactionsDuplicateKeysIndex];
            var Transactions = Dictionary[DuplicateKey];
            if (Transactions.length > 1) {
                var TransactionIDs = Books.GetTransactionsIDsString(Transactions);
                if (Books.TransactionsDuplicateGroups[TransactionIDs] == null) {
                    var DuplicateGroup = <DuplicateGroup>{
                        Transactions: Transactions,
                        TransactionIDs: TransactionIDs,
                        DuplicateReason: TransactionsDuplicateKeysIndex
                    };
                    Books.TransactionsDuplicateGroups[TransactionIDs] = DuplicateGroup;
                    for (var i = 0; i < Transactions.length; i++) {
                        if (Transactions[i].DuplicateGroups == null)
                            Transactions[i].DuplicateGroups = new Array();
                        Transactions[i].DuplicateGroups.push(DuplicateGroup);
                    }
                }
            }
        }

        static CleanReviewedState() {
            Modals.ShowConfirmDialog({
                Title: "ניקוי סימון ביקורת",
                Message: "האם ברצונך לנקות את סימון התנועות שעברו ביקורת?",
                ConfirmEvent: function () {
                    Common.AjaxRequest({
                        URL: "/books/cleanreviewedstate/?databaseid=" + Books.DatabaseID,
                        Data: {
                            BatchID: Books.BatchID
                        },
                        SuccessMethod: function (Response) {
                            if (Response.Success) {
                                if (Books.TransactionsArrayWithReviewed)
                                    Books.TransactionsArray = Books.TransactionsArrayWithReviewed.filter(T => true);
                                for (var i = 0; i < Books.TransactionsArray.length; i++) {
                                    Books.TransactionsArray[i].ReviewDate = null;
                                    Books.TransactionsArray[i].SaveReview = false;
                                }

                                Books.ToggleReview();
                            }
                            return false;
                        },
                        ShowLoading: false
                    });
                }
            });
            return false;
        }

        static SpliceSingleValueFromArray(Array, Value) {
            var Index = Array.indexOf(Value);
            if (Index != -1)
                Array.splice(Index, 1);
        }
        static EqualArrays(Array1, Array2) {
            if (Array1 == null && Array2 == null)
                return true;

            if (Array1 == null || Array2 == null || Array1.length != Array2.length)
                return false;

            for (var i = 0; i < Array1.length; i++)
                if (Array1[i] != Array2[i])
                    return false;

            return true;
        }

        static GetTransactionsIDsString(Transactions) {
            Transactions.sort(function (a, b) {
                if (a.ID < b.ID)
                    return -1;
                if (a.ID > b.ID)
                    return 1;
                return 0;
            });

            var ToReturn = "";
            for (var i = 0; i < Transactions.length; i++) {
                if (i != 0)
                    ToReturn += ",";
                ToReturn += Transactions[i].ID;
            }
            return ToReturn;
        }
        static PopulateTransactionDuplicateKeys(Transaction, Fields): string {
            var ToReturn = null;
            for (var i = 0; i < Fields.length; i++) {
                var Field = Fields[i];
                var Value = Transaction[Field.Name];
                if (Field.Name == 'ValueDate' && (Value == null || Value == ""))
                    Value = Transaction.ReferenceDate;

                if (Value == null || Value == "")
                    return null;
                if (Field.Type == "Last4Chars")
                    Value = Value.substring(Value.length - 4).padStart(4, '0');
                else if (Field.Type == "Year")
                    Value = Value.getFullYear();

                if (i == 0)
                    ToReturn = "";
                else
                    ToReturn += ",";
                ToReturn += Value;
            }
            return ToReturn;
        }

        static GetFileGuidGroupedTransactionsArray() {
            var Dictionary = {};
            var ToReturn = new Array<Array<Transaction>>();
            for (var i = 0; i < Books.TransactionsArray.length; i++) {
                var InnerArray = Dictionary[Books.TransactionsArray[i].FileGuid];
                if (!InnerArray) {
                    InnerArray = new Array<Transaction>();
                    Dictionary[Books.TransactionsArray[i].FileGuid] = InnerArray;
                    ToReturn.push(InnerArray);
                }
                InnerArray.push(Books.TransactionsArray[i]);
            }
            return ToReturn;
        }

        static RenderTransactions(RenderTransactionsStatus, StartIndex?) {
            var $Table = $(".og-books-batch");
            var $TableBody = $Table.find("tbody").hide();

            var NextLineNumber = 1;
            for (var i = 0; i < Books.TransactionsArray.length; i++)
                Books.TransactionsArray[i].LineNumber = NextLineNumber++;

            var $TempContainer = $("<div>");
            $TempContainer.append($TableBody.children());

            if (Books.IsExpenses) {
                Books.VisibleStartIndex = StartIndex == null ? 0 : StartIndex;

                var Groups = Books.GetFileGuidGroupedTransactionsArray();
                NextLineNumber = 1;
                for (var i = 0; i < Groups.length; i++) {
                    for (var j = 0; j < Groups[i].length; j++)
                        Groups[i][j].LineNumber = NextLineNumber;
                    NextLineNumber++;
                }

                if (Books.VisibleStartIndex < 0)
                    Books.VisibleStartIndex = Groups.length - 1;
                else if (Books.VisibleStartIndex > Groups.length - 1)
                    Books.VisibleStartIndex = 0;
                if (Groups.length != 0) {
                    var Group = Groups[Books.VisibleStartIndex];
                    for (var i = 0; i < Group.length; i++) {
                        var Transaction = Group[i];
                        Books.RenderTransaction($TableBody, Transaction, false, RenderTransactionsStatus, false);
                        if (Transaction.FileSavedToBatch)
                            Transaction.$Row.find("input, .og-books-transactiontypepicker, .og-books-accountpicker, .og-books-currencypicker").attr("readonly", "readonly");
                    }
                    if (Groups.length > Books.VisibleStartIndex + 1) {
                        var $HiddenDiv = $(document.createElement("span")).html(Groups[Books.VisibleStartIndex + 1][0].FileHTML).css('overflow', 'hidden').css('position', 'absolute').css('display', 'inline-block').css('width', '1px').css('height', '1px').css('visibility', 'hidden').appendTo(document.body);
                        setTimeout(function () {
                            $HiddenDiv.remove();
                        }, 30000);
                    }
                }
                Books.BatchRefreshFileStatus();
            }
            else if (Books.IsReview) {
                Books.VisibleStartIndex = StartIndex == null ? 0 : StartIndex;

                if (Books.VisibleStartIndex < 0)
                    Books.VisibleStartIndex = Books.TransactionsArray.length - 1;
                else if (Books.VisibleStartIndex > Books.TransactionsArray.length - 1)
                    Books.VisibleStartIndex = 0;
                if (Books.TransactionsArray.length != 0) {
                    var Transaction = Books.TransactionsArray[Books.VisibleStartIndex];
                    Books.RenderTransaction($TableBody, Transaction, false, RenderTransactionsStatus, false);
                    if (Transaction.FileSavedToBatch)
                        Transaction.$Row.find("input, .og-books-transactiontypepicker, .og-books-accountpicker, .og-books-currencypicker").attr("readonly", "readonly");
                    if (Books.VisibleStartIndex < Books.TransactionsArray.length - 1) {
                        var $HiddenDiv = $(document.createElement("span")).html(Books.TransactionsArray[Books.VisibleStartIndex + 1].FileHTML).css('overflow', 'hidden').css('position', 'absolute').css('display', 'inline-block').css('width', '1px').css('height', '1px').css('visibility', 'hidden').appendTo(document.body);
                        setTimeout(function () {
                            $HiddenDiv.remove();
                        }, 30000);
                    }
                }
                Books.BatchRefreshFileStatus();
            }
            else {
                Books.VisibleStartIndex = 0;
                if (Books.TransactionsArray.length > 200)
                    Books.VisibleStartIndex = Books.TransactionsArray.length - 200;
                if (Books.VisibleStartIndex > 0)
                    Books.RenderSpace(Books.VisibleStartIndex);

                for (var i = Books.VisibleStartIndex; i < Books.TransactionsArray.length; i++)
                    Books.RenderTransaction($TableBody, Books.TransactionsArray[i], false, RenderTransactionsStatus, false);
            }
            OfficeGuy.Common.InitEditors($TableBody);
            $TableBody.show();
            Teva.Positioning.StickyTable($Table);
            if (Books.IsExpenses || Books.IsReview) {
                if (Books.TransactionsArray.length == 0) {
                    $(".og-books-batch-image").remove();
                    $(".og-books-batch-emptyhide").hide();
                    //
                    $Table.find("tbody").empty().append($
                        (document.createElement('tr')
                            .addClass("og-books-batch-ocr"))
                        .append($(document.createElement('td')
                            .addClass("og-books-batch-ocr-empty")
                            .attr("colspan", 20))
                            .html("מסך תיוק הוצאות מאפשר העלאת צילומים, הזנת פרטים על צילום שהועלו על ידך ועל ידי הלקוחות שלך, ושמירתם לתוך " + (Books.DoubleEntrySystem ? "מנת קליטת הוצאות" : "המנה הפתוחה") + ".<br />חלק מהפרטים מוזנים בצורה חכמה על פי סריקת הצילום. יש לעבור על כל הפרטים ולוודא שהם נכונים. ניתן להיעזר בחלופות המופיעות בבועות מתחת לכל שדה.")));

                }
                else
                    Teva.Navigation.FocusOnFirstField($TableBody);
            }
            if (Books.IsReview)
                $TableBody.find("a:first").trigger("focus");
            return false;
        }
        static BatchRefreshFileStatus() {
            $(".og-books-batch-renderprevioustransaction").attr("disabled", Books.TransactionsArray.length > 0 ? null : "disabled").show();
            $(".og-books-batch-rendernexttransaction").attr("disabled", Books.TransactionsArray.length > 0 ? null : "disabled");
            if (Books.IsReview)
                $(".og-navigation-bar h1").text("ביקורת צילומי הוצאות (" + Books.TransactionsArray.length + " צילומים ממתינים)");
            else {
                var FileGuids = {};
                for (var i = 0; i < Books.TransactionsArray.length; i++)
                    FileGuids[Books.TransactionsArray[i].FileGuid] = 1;

                $(".og-navigation-bar h1").text("תיוק צילומי הוצאות (" + Object.keys(FileGuids).length + " צילומים ממתינים)");
            }
        }

        static RenderAdditionalTransactions() {
            var $Container = $(".og-books-batch tbody");
            $Container.find(".og-books-batch-space").remove();
            var PreviousVisibleStartIndex = Books.VisibleStartIndex;
            Books.VisibleStartIndex = 0;//Math.max(PreviousVisibleStartIndex - 200, 0);

            for (var i = PreviousVisibleStartIndex - 1; i >= Books.VisibleStartIndex; i--)
                Books.RenderTransaction($Container, Books.TransactionsArray[i], false, true, true);

            if (Books.VisibleStartIndex > 0)
                Books.RenderSpace(Books.VisibleStartIndex);

            OfficeGuy.Common.InitEditors($Container);
            return false;
        }
        static RenderSpace(TransactionsCount) {
            var $Row = $
                (document.createElement('tr')
                    .addClass("og-books-batch-space"))
                .append($
                    (document.createElement('td')
                        .addClass("og-books-batch-space")
                        .attr("colspan", 20))
                    .html("קיימות במנה " + TransactionsCount + " תנועות נוספות. <a href=\"#\" onclick=\"return OfficeGuy.Apps.Books.RenderAdditionalTransactions();\">להצגת כל התנועות »</a>")
                );
            $(".og-books-batch tbody").prepend($Row);

            return $Row;
        }
        static RenderTransaction($Container, Transaction, InitEditors?, RenderTransactionStatus?, Prepend?) {
            var $Row;
            if (Transaction.$Row != null) {
                $Row = Transaction.$Row;
                $Row.data("Transaction", Transaction);
                if (Books.IsExpenses) {
                    $Row.empty();
                    Books.RenderTransactionInRow($Row, Transaction);
                }
            }
            else {
                $Row = $(document.createElement('tr'))
                    .data("Transaction", Transaction);

                Books.RenderTransactionInRow($Row, Transaction);
            }
            Transaction.$Row = $Row;
            if (Prepend == true)
                $Row.prependTo($Container);
            else
                $Row.appendTo($Container);

            if ((Books.IsExpenses && $Container.children("tr:not(.og-books-batch-duplicatemessage):not(.og-books-batch-ocr)").length == 1) || Books.IsReview)
                $(".og-books-batch-image").remove();
            if (((Books.IsExpenses && $Container.children("tr:not(.og-books-batch-duplicatemessage):not(.og-books-batch-ocr)").length == 1) || Books.IsReview) && Transaction.FileHTML) {
                var $BatchPreview;
                $(document.createElement("div"))
                    .addClass("og-books-batch-image")
                    .addClass(Books.IsExpenses && Transaction.OCRAbsolute == null ? "og-books-batch-image-emptyocr" : null)
                    .append(
                        $(document.createElement("div").addClass("og-books-batch-image-cell"))
                            .append($BatchPreview = $(document.createElement("div")
                                .addClass("og-books-batch-image-preview")
                            )
                                .html(Transaction.FileHTML)
                            )
                    ).insertAfter(".og-books-batch-container");
                if (Transaction.PagesCount && Transaction.PagesCount > 1) {
                    $BatchPreview.append(
                        $(document.createElement("div")
                            .addClass("og-books-batch-image-preview-multiplepages-container")
                        )
                            .append($(document.createElement("div")
                                .addClass("og-books-batch-image-preview-multiplepages"))
                                .html("לתשומת הלב, הצילום מכיל " + Transaction.PagesCount + " דפים. <a href=\"/books/fileexpensesplitpdfpages/?databaseid=" + Books.DatabaseID + "&fileid=" + Transaction.ID + "\">פיצול הקובץ לעמודים »</a>")
                            ));
                }

                $(".og-books-batch-image-cell img")
                    .click(Books.ImageZoomClick)
                    .each(function () {
                        var $Image = $(this);

                        var $Buttons = $(document.createElement('div')
                            .addClass("og-books-batch-image-preview-buttons"))
                            .appendTo($Image.parent().parent());

                        $(document.createElement('div')
                            .addClass("og-books-batch-image-preview-buttons-button", "og-books-batch-image-preview-buttons-button-clockwise"))
                            .on("click", Books.RotateImageClockwise)
                            .appendTo($Buttons);
                        $(document.createElement('div')
                            .addClass("og-books-batch-image-preview-buttons-button", "og-books-batch-image-preview-buttons-button-counterclockwise"))
                            .on("click", Books.RotateImageCounterClockwide)
                            .appendTo($Buttons);
                        $(document.createElement('div')
                            .addClass("og-books-batch-image-preview-buttons-button", "og-books-batch-image-preview-buttons-button-resize"))
                            .on("click", Books.ImageZoom)
                            .appendTo($Buttons);
                    });
            }
            if (Transaction.DuplicateMessage) {
                $(document.createElement("tr")
                    .addClass("og-books-batch-duplicatemessage"))
                    .append(
                        $(document.createElement("td")
                            .attr("colspan", 20))
                            .append($('<div>')
                                .addClass('og-notification-fixed og-notification-fixed-color-warning')
                                .html("המערכת איתרה תנועת יומן דומה. מומלץ לוודא כי לא בוצע רישום כפול! " + Transaction.DuplicateMessage)
                            )
                    ).insertBefore($Row);
            }
            if (Books.IsExpenses && $(".og-books-batch-ocr").length == 0) {
                var $OCRTransactionType, $OCRReferenceDate, $OCRAmountILS, $OCRAmountForeign, $OCRReference, $OCRCustomerSupplier, $OCRDebit, $OCRCredit, $OCRRow;
                if (Transaction.OCRAbsolute == null) {
                    var TD = document.createElement('td').addClass("og-books-batch-ocr-empty").attr("colspan", 20);
                    var ReloadLink = "<a style=\"color: #1976D2;\" href=\"/books/fileexpenses/?databaseid=" + Books.DatabaseID + "&transactionid=" + Transaction.ID + "\">לרענן את הדף »</a>";
                    TD.innerHTML = "הצילום נמצא בתהליך סריקה וזיהוי. יש לחכות <span class=\"og-books-batch-ocr-empty-counter\">5</span> שניות ו" + ReloadLink;
                    $OCRRow = $(document.createElement('tr').addClass("og-books-batch-ocr")).append(TD);
                    Books.VisibleStartIndex
                    var Counter = setInterval(function () {
                        var $Element = $(".og-books-batch-ocr-empty-counter");
                        var Num = parseInt($Element.text());
                        var NextNum = Num - 1;
                        $Element.text(NextNum);
                        if (NextNum < 1) {
                            clearInterval(Counter);
                            $(".og-books-batch-ocr-empty").html("הצילום עבר תהליך סריקה וזיהוי, יש " + ReloadLink)
                        }
                    }, 1000);
                }
                else {
                    var $Reference1 = $(document.createElement('td').addClass("og-books-batch-reference"));
                    var $Reference2 = $(document.createElement('td').addClass("og-books-batch-reference2"));
                    $OCRReference = $(document.createElement('div').addClass("og-books-batch-reference-ocr"));

                    var IsReference2 = Books.ExpensesReference2;
                    if (IsReference2 && Transaction.Type) {
                        var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                        if (TransactionType && TransactionType.AllowCustomer)
                            IsReference2 = false;
                    }

                    (IsReference2 ? $Reference2 : $Reference1).append($OCRReference);
                    $OCRRow = $
                        (document.createElement('tr')
                            .addClass("og-books-batch-ocr"))
                        .append($OCRTransactionType = $(document.createElement('td')))
                        .append($Reference1)
                        .append($Reference2.toggle(Books.ShowReference2))
                        .append($OCRReferenceDate = $(document.createElement('td')))
                        .append($OCRAmountILS = $(document.createElement('td')))
                        .append($OCRDebit = $(document.createElement('td').addClass("og-books-batch-full", "og-books-batch-debit"))
                            .toggle(!Books.SingleEntryBatchView)
                        )
                        .append($OCRCredit = $(document.createElement('td').addClass("og-books-batch-full", "og-books-batch-credit"))
                            .toggle(!Books.SingleEntryBatchView)
                        )
                        .append($(document.createElement('td').addClass("og-books-batch-customersupplier"))
                            .append($OCRCustomerSupplier = $(document.createElement('div').addClass("og-books-batch-customersupplier-ocr")))
                            .toggle(Books.ShowCustomerSupplier)
                        )
                        .append($(document.createElement('td').addClass("og-books-batch-bank"))
                            .toggle(Books.ShowBank)
                        )

                        .append(document.createElement('td'))
                        .append($(document.createElement('td').addClass("og-books-batch-remarks"))
                            .toggle(Books.ShowRemarks)
                        )
                        .append($(document.createElement('td').addClass("og-books-batch-valuedate"))
                            .toggle(Books.ShowValueDate)
                        )
                        .append($(document.createElement('td').addClass("og-books-batch-profitamountils"))
                            .toggle(Books.ShowProfitAmountILS)
                        )
                        .append($(document.createElement('td').addClass("og-books-batch-incomeexpenseamountils"))
                            .toggle(Books.ShowIncomeExpenseAmountILS)
                        )
                        .append($(document.createElement('td').addClass("og-books-batch-vatamountils"))
                            .toggle(Books.ShowVATAmountILS)
                        )
                        .append($(document.createElement('td').addClass("og-books-batch-taxwithholding"))
                            .toggle(Books.ShowTaxWithholding)
                        )
                        .append($(document.createElement('td').addClass('og-books-batch-foreign'))
                            .toggle(Books.ShowForeign)
                        )
                        .append($OCRAmountForeign = $(document.createElement('td').addClass('og-books-batch-foreign'))
                            .toggle(Books.ShowForeign)
                        )
                        .append($(document.createElement('td').addClass("og-books-batch-companynumber"))
                            .toggle(Books.ShowCompanyNumber)
                        )
                        .append(document.createElement('td').attr("colspan", 4))

                    var OCRClass = (Transaction.OCRAbsolute == true) ? "og-button-color-submit" : "og-button-color-default";
                    if (Transaction.OCRReferenceDate)
                        for (var i = 0; i < Transaction.OCRReferenceDate.length; i++)
                            $OCRReferenceDate.append($(document.createElement("div")
                                .addClass("og-books-batch-image-ocr", "og-books-batch-image-ocr-referencedate", OCRClass)
                                .setText(Transaction.OCRReferenceDate[i])));

                    if (Transaction.OCRAmountILS)
                        for (var i = 0; i < Transaction.OCRAmountILS.length; i++) {
                            $OCRAmountILS.append($
                                (document.createElement("div")
                                    .addClass("og-books-batch-image-ocr", "og-books-batch-image-ocr-amountils", OCRClass)
                                    .setText(Books.FormatNumber(Number(Transaction.OCRAmountILS[i]))))
                                .toggle(Transaction.ForeignCurrency == 1));
                            $OCRAmountForeign.append($
                                (document.createElement("div")
                                    .addClass("og-books-batch-image-ocr", "og-books-batch-image-ocr-amountforeign", OCRClass)
                                    .setText(Books.FormatNumber(Number(Transaction.OCRAmountILS[i]))))
                                .toggle(Transaction.ForeignCurrency != 1));
                        }


                    if (Transaction.OCRReference)
                        for (var i = 0; i < Transaction.OCRReference.length; i++)
                            $OCRReference.append($(document.createElement("div")
                                .addClass("og-books-batch-image-ocr", "og-books-batch-image-ocr-reference", OCRClass)
                                .setText(Transaction.OCRReference[i])));
                    if (Transaction.OCRCustomersSuppliers) {
                        for (var i = 0; i < Transaction.OCRCustomersSuppliers.length; i++) {
                            $OCRCustomerSupplier.append($
                                (document.createElement("div")
                                    .addClass("og-books-batch-image-ocr", "og-books-batch-image-ocr-customersupplier", OCRClass)
                                    .setText((Transaction.OCRCustomersSuppliers[i].AccountCode ? Transaction.OCRCustomersSuppliers[i].AccountCode + ' - ' : null) + Transaction.OCRCustomersSuppliers[i].CompanyNumber + (Transaction.OCRCustomersSuppliers[i].Name ? ' (' + Transaction.OCRCustomersSuppliers[i].Name + ')' : null))
                                )
                                .data("accountid", Transaction.OCRCustomersSuppliers[i].AccountID)
                                .data("accountcode", Transaction.OCRCustomersSuppliers[i].AccountCode)
                                .data("name", Transaction.OCRCustomersSuppliers[i].Name)
                                .data("companynumber", Transaction.OCRCustomersSuppliers[i].CompanyNumber));
                        }

                        $OCRCustomerSupplier.append($
                            (document.createElement("div")
                                .addClass("og-books-batch-image-ocr", "og-books-batch-image-ocr-customersupplier", OCRClass)
                                .setText("בהתאם לסוג התנועה")
                            )
                            .data("accountid", "-1"));

                        if (Books.DoubleEntrySystem) {
                            var TransactionTypeCode = Transaction.Type;
                            if (!TransactionTypeCode) {
                                var Account = Books.AccountPickerDictionary[Transaction.OCRCustomersSuppliers[0].AccountID];
                                if (Account)
                                    TransactionTypeCode = Account.DefaultTransactionType;
                            }
                            if (TransactionTypeCode) {
                                var TransactionType = Books.TransactionTypePickerDictionary[TransactionTypeCode];
                                if (TransactionType && (TransactionType.AllowCustomer == DebitCreditEnum.Debit || TransactionType.AllowSupplier == DebitCreditEnum.Debit))
                                    $OCRDebit.append($OCRCustomerSupplier);
                                else if (TransactionType && (TransactionType.AllowCustomer == DebitCreditEnum.Credit || TransactionType.AllowSupplier == DebitCreditEnum.Credit))
                                    $OCRCredit.append($OCRCustomerSupplier);
                            }
                        }
                    }

                    if (Transaction.OCRTransactionType) {
                        for (var i = 0; i < Transaction.OCRTransactionType.length; i++) {
                            $OCRTransactionType.append($(document.createElement("div")
                                .addClass("og-books-batch-image-ocr", "og-books-batch-image-ocr-transactiontype", OCRClass)
                                .setText(Transaction.OCRTransactionType[i])));
                        }
                    }

                    if ((IsReference2 && !Transaction.Reference2) || (!IsReference2 && !Transaction.Reference1)) {
                        var Text = $OCRRow.find(".og-books-batch-image-ocr-reference").first().text()
                        if (IsReference2) {
                            Transaction.$Reference2.val(Text); // Don't trigger change to avoid server save here
                            Transaction.Reference2 = Text;
                        }
                        else {
                            Transaction.$Reference1.val(Text); // Don't trigger change to avoid server save here
                            Transaction.Reference1 = Text;
                        }
                    }
                }
                $OCRRow.insertAfter($Row);
            }

            if (RenderTransactionStatus)
                Books.RenderTransactionStatus($Row);

            if (InitEditors)
                OfficeGuy.Common.InitEditors($Row);
            if (Books.IsExpenses && Transaction.OCRTransactionType && Transaction.OCRTransactionType.length > 0 && Transaction.Type == null) {
                if (!InitEditors)
                    OfficeGuy.Common.InitEditors($Row);
                var Instance = Teva.SelectBox.GetInstance(Transaction.$Type);
                Instance.SetValueFromQueryMethod(Transaction.OCRTransactionType[0]);
            }
            return $Row;
        }

        static RenderTransactionInRow($Row, Transaction: Transaction) {
            var TransactionTypeText = Transaction.Type;
            if (TransactionTypeText != "") {
                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                if (TransactionType != null)
                    TransactionTypeText = Books.GetTransactionTypeText(TransactionType);
            }

            var Readonly = Transaction.FileSavedToBatch || (Books.BatchClosed && !Books.BatchClosedEdit) || Transaction.TransactionTypeMismatch ? "readonly" : null;

            if (Books.IsReview) {
                $Row.append($(document.createElement('td'))
                    .append($
                        (document.createElement("a")
                            .addClass("og-button-ui-action", "og-button-color-submit", "og-books-batch-rendernexttransaction")
                            .attr("href", "#")
                            .setText("אישור ומעבר לצילום הבא"))
                        .on("click", function () {
                            if (!Transaction.ReviewDate) {
                                Transaction.ReviewDate = new Date();
                                Transaction.SaveReview = true;
                                $Row.addClass("og-books-batch-unsaved");
                                Books.SaveTransaction($Row);
                            }
                            return Books.RenderTransactions(true, Books.VisibleStartIndex + 1);
                        })
                    )
                );
            }

            $Row.append($(document.createElement('td'))
                .append(Transaction.$Type = $
                    (document.createElement('input')
                        .attr("type", "hidden")
                        .attr("name", "Type")
                        .val(Transaction.Type)
                        .addClass("og-books-transactiontypepicker", "og-books-batch-transactiontype", "teva-selectbox-container-allowsearch"))
                    .attr("data-text", TransactionTypeText)
                )
            );
            $Row.append($(document.createElement('td'))
                .append(Transaction.$Reference1 = $
                    (document.createElement('input')
                        .attr("type", "text")
                        .attr("autocomplete", "off")
                        .attr("name", "Reference1")
                        .attr("readonly", Readonly)
                        .val(Transaction.Reference1)
                        .addClass("og-books-batch-reference"))
                )
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-reference2"))
                .toggle(Books.ShowReference2)
                .append(Transaction.$Reference2 = $
                    (document.createElement('input')
                        .attr("type", "text")
                        .attr("autocomplete", "off")
                        .attr("name", "Reference2")
                        .attr("readonly", Readonly)
                        .val(Transaction.Reference2)
                        .addClass("og-books-batch-reference2"))
                )
            );
            $Row.append($(document.createElement('td'))
                .append(Transaction.$ReferenceDate = $
                    (document.createElement('input')
                        .attr("type", "text")
                        .attr("autocomplete", "off")
                        .attr("name", "ReferenceDate")
                        .attr("readonly", Readonly)
                        .val(Teva.DatePicker.GetDateAsString(Transaction.ReferenceDate))
                        .addClass("og-books-batch-date", "datepicker"))
                )
            );
            $Row.append($(document.createElement('td'))
                .append(Transaction.$AmountILS = $
                    (document.createElement('input')
                        .attr("type", "text")
                        .attr("step", "0.01")
                        .attr("name", "AmountILS")
                        .attr("autocomplete", "off")
                        .attr("readonly", Books.BatchClosed || Transaction.TransactionTypeMismatch ? "readonly" : null)
                        .attr("placeholder", Transaction.ForeignCurrency == 1 ? null : "אוטומטי")
                        .val(Books.FormatNumber(Transaction.AmountILS))
                        .addClass("og-books-batch-amount", "og-input-calculator"))
                )
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-full")
                )
                .toggle(!Books.SingleEntryBatchView)
                .append(Transaction.$DebitAccount = $
                    (document.createElement('input')
                        .attr("type", "hidden")
                        .attr("name", "DebitAccount")
                        .val(Transaction.DebitAccount == 0 ? '' : Transaction.DebitAccount)
                        .addClass("og-books-accountpicker", "og-books-batch-account", "teva-selectbox-container-allowsearch")
                    )
                    .attr("data-text", Transaction.DebitAccount == 0 ? (Transaction.DebitAccountName ? Transaction.DebitAccountCompanyNumber + " (" + Transaction.CreditAccountName + ")" : "") : Books.GetAccountText(Books.AccountPickerDictionary[Transaction.DebitAccount]))
                )

            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-full")
                )
                .toggle(!Books.SingleEntryBatchView)
                .append(Transaction.$CreditAccount = $
                    (document.createElement('input')
                        .attr("type", "hidden")
                        .attr("name", "CreditAccount")
                        .val(Transaction.CreditAccount == 0 ? '' : Transaction.CreditAccount)
                        .addClass("og-books-accountpicker", "og-books-batch-account", "teva-selectbox-container-allowsearch"))
                    .attr("data-text", Transaction.CreditAccount == 0 ? (Transaction.CreditAccountName ? Transaction.CreditAccountCompanyNumber + " (" + Transaction.CreditAccountName + ")" : "") : Books.GetAccountText(Books.AccountPickerDictionary[Transaction.CreditAccount]))
                )
            );

            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-customersupplier")
                )
                .toggle(Books.ShowCustomerSupplier)
                .append(Transaction.$CustomerSupplierAccount = $
                    (document.createElement('input')
                        .attr("type", "hidden")
                        .attr("name", "CustomerSupplierAccount")
                        .val(Transaction.CustomerSupplierAccount == 0 ? '' : Transaction.CustomerSupplierAccount)
                        .addClass("og-books-accountpicker", "og-books-batch-account", "teva-selectbox-container-allowsearch")
                        .attr("readonly", Books.BatchClosed || Transaction.TransactionTypeMismatch || !Books.TransactionTypeSupportsCustomerSupplier(Transaction.Type) ? "readonly" : null))
                    .attr("data-text", Transaction.CustomerSupplierAccount == 0 ? null : Books.GetAccountText(Books.AccountPickerDictionary[Transaction.CustomerSupplierAccount]))
                )
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-bank")
                )
                .toggle(Books.ShowBank)
                .append(Transaction.$BankAccount = $
                    (document.createElement('input')
                        .attr("type", "hidden")
                        .attr("name", "BankAccount")
                        .val(Transaction.BankAccount == 0 ? '' : Transaction.BankAccount)
                        .addClass("og-books-accountpicker", "og-books-batch-account", "teva-selectbox-container-allowsearch")
                        .attr("readonly", Books.BatchClosed || Transaction.TransactionTypeMismatch || (!Transaction.BankSupported) ? "readonly" : null))
                    .attr("data-text", Transaction.BankAccount == 0 ? null : Books.GetAccountText(Books.AccountPickerDictionary[Transaction.BankAccount]))
                )
            );

            $Row.append($(document.createElement('td'))
                .append(Transaction.$Details = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("autocomplete", "off")
                    .attr("name", "Details")
                    .attr("readonly", Readonly)
                    .val(Transaction.Details)
                    .addClass("og-books-batch-reference")))
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-remarks"))
                .toggle(Books.ShowRemarks)
                .append(Transaction.$Remarks = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("autocomplete", "off")
                    .attr("name", "Remarks")
                    .attr("readonly", Readonly)
                    .val(Transaction.Remarks)
                    .addClass("og-books-batch-remarks")))
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-valuedate"))
                .toggle(Books.ShowValueDate)
                .append(Transaction.$ValueDate = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("autocomplete", "off")
                    .attr("name", "ValueDate")
                    .attr("readonly", Readonly)
                    .val(Teva.DatePicker.GetDateAsString(Transaction.ValueDate))
                    .addClass("og-books-batch-date", "datepicker")))
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-profitamountils"))
                .toggle(Books.ShowProfitAmountILS)
                .append(Transaction.$ProfitAmountILS = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("autocomplete", "off")
                    .attr("name", "ProfitAmountILS")
                    .attr("step", "0.01")
                    .attr("readonly", "readonly")
                    .val(Books.FormatNumber(Transaction.ProfitAmountILS))
                    .addClass("og-books-batch-amount", "ltr_near")))
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-incomeexpenseamountils"))
                .toggle(Books.ShowIncomeExpenseAmountILS)
                .append(Transaction.$IncomeExpenseAmountILS = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("autocomplete", "off")
                    .attr("name", "IncomeExpenseAmountILS")
                    .attr("step", "0.01")
                    .attr("readonly", "readonly")
                    .val(Books.FormatNumber(Transaction.IncomeExpenseAmountILS))
                    .addClass("og-books-batch-amount", "ltr_near")))
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-vatamountils"))
                .toggle(Books.ShowVATAmountILS)
                .append(Transaction.$VATAmountILS = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("autocomplete", "off")
                    .attr("name", "VATAmountILS")
                    .attr("step", "0.01")
                    .attr("readonly", Books.BatchClosed || Transaction.TransactionTypeMismatch || !Books.TransactionTypeSupportsVAT(Transaction.Type) ? "readonly" : null)
                    .val(Books.FormatNumber(Transaction.VATAmountILS))
                    .addClass("og-books-batch-amount", "ltr_near", "og-input-calculator")))
            );
            $Row.append($
                (document.createElement('td')
                    .addClass("og-books-batch-taxwithholding"))
                .toggle(Books.ShowTaxWithholding)
                .append(Transaction.$TaxWithholdingAmountILS = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("autocomplete", "off")
                    .attr("name", "TaxWithholdingAmountILS")
                    .attr("step", "0.01")
                    .attr("readonly", Books.BatchClosed || Transaction.TransactionTypeMismatch || (!Transaction.BankSupported && !Books.TransactionTypeSupportsTaxWithholding(Transaction.Type)) ? "readonly" : null)
                    .val(Books.FormatNumber(Transaction.TaxWithholdingAmountILS))
                    .addClass("og-books-batch-amount", "ltr_near", "og-input-calculator")))
            );

            $Row.append($
                (document.createElement('td')
                    .addClass('og-books-batch-foreign'))
                .toggle(Books.ShowForeign)
                .append(Transaction.$ForeignCurrency = $
                    (document.createElement('input')
                        .attr("type", "hidden")
                        .attr("name", "ForeignCurrency")
                        .attr("readonly", Books.BatchClosed || Transaction.TransactionTypeMismatch ? "readonly" : null)
                        .val(Transaction.ForeignCurrency)
                        .addClass("og-books-currencypicker", "teva-selectbox-container-allowsearch"))
                    .attr("data-text", Transaction.ForeignCurrency == null || Transaction.ForeignCurrency == 0 ? null : Books.CurrenciesDictionary[Transaction.ForeignCurrency].Name)
                )
            );
            $Row.append($
                (document.createElement('td')
                    .addClass('og-books-batch-foreign'))
                .toggle(Books.ShowForeign)
                .append(Transaction.$AmountForeign = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("autocomplete", "off")
                    .attr("step", "0.01")
                    .attr("name", "AmountForeign")
                    .attr("readonly", Books.BatchClosed || Transaction.ForeignCurrency == 1 || Transaction.TransactionTypeMismatch ? "readonly" : null)
                    .val(Books.FormatNumber(Transaction.AmountForeign))
                    .addClass("og-books-batch-amount", "og-input-calculator")))
            );
            $Row.append($
                (document.createElement('td')
                    .addClass('og-books-batch-companynumber'))
                .toggle(Books.ShowCompanyNumber)
                .append(Transaction.$CompanyNumber = $(document.createElement('input')
                    .attr("type", "text")
                    .attr("name", "CompanyNumber")
                    .attr("readonly", Readonly)
                    .val(Transaction.CompanyNumber))
                )
            );
            var IsAdditionalExpense = Books.IsExpenses;
            if (IsAdditionalExpense) {
                var $TransactionsRows = $(".og-books-batch tbody tr:not(.og-books-batch-duplicatemessage):not(.og-books-batch-ocr)");
                IsAdditionalExpense = $TransactionsRows.length != 0 && $TransactionsRows[0] != $Row[0];
            }
            if (Books.IsExpenses) {
                var $Cell = $(document.createElement('td').addClass("og-books-batch-expensebuttons")).css('white-space', 'nowrap');

                var SavedTransactions = new Array();
                var ShowDuplicateMessage = false;
                for (var i = 0; i < Books.TransactionsArray.length; i++) {
                    if (Books.TransactionsArray[i].FileGuid == Transaction.FileGuid) {
                        SavedTransactions.push(Books.TransactionsArray[i]);
                        if (Books.TransactionsArray[i].DuplicateMessage)
                            ShowDuplicateMessage = true;
                    }
                }

                if (ShowDuplicateMessage) {
                    for (var i = 0; i < SavedTransactions.length; i++)
                        SavedTransactions[i].SkipFindSimilar = true;
                }

                if (IsAdditionalExpense) {
                    var $PreviousCell = $("td.og-books-batch-expensebuttons:not(:empty)");
                    $Cell.append($PreviousCell.children());
                }
                else {
                    var $Save = $
                        (document.createElement("a")
                            .addClass("og-button-ui-action", "og-button-color-submit")
                            .attr("href", "#")
                            .attr("disabled", Transaction.FileSavedToBatch ? "disabled" : "")
                            .setText("שמירה למנה")
                        )
                        .on("click", function () {
                            var SavedTransactions = new Array();
                            for (var i = 0; i < Books.TransactionsArray.length; i++) {
                                if (Books.TransactionsArray[i].FileGuid == Transaction.FileGuid) {
                                    SavedTransactions.push(Books.TransactionsArray[i]);
                                    Books.LastExpensesSavedTransaction = Books.TransactionsArray[i];
                                }
                            }

                            var NextVisibleStartIndex = Books.VisibleStartIndex + 1; //Books.VisibleStartIndex == Books.TransactionsArray.length - 1 ? Books.VisibleStartIndex - 1 : 
                            for (var i = 0; i < SavedTransactions.length; i++) {
                                var SavedTransaction = SavedTransactions[i];
                                if (!SavedTransaction.FileSavedToBatch && SavedTransaction.StatusError) {
                                    Modals.ShowMessageDialog("השמירה נכשלה", SavedTransaction.StatusDescription);
                                    return false;
                                }
                            }

                            for (var i = 0; i < SavedTransactions.length; i++) {
                                var SavedTransaction = SavedTransactions[i];
                                var $SavedRow = SavedTransaction.$Row;
                                if ($SavedRow.hasClass("og-books-batch-saving") && !SavedTransaction.FileSavedToBatch) {
                                    SavedTransaction.FileSavedToBatch = true;
                                    SavedTransaction.CreateAccounts = true;
                                    $SavedRow.addClass("og-books-batch-pendingresave");
                                }
                                else if (!SavedTransaction.FileSavedToBatch) {
                                    SavedTransaction.FileSavedToBatch = true;
                                    SavedTransaction.CreateAccounts = true;
                                    $SavedRow.addClass("og-books-batch-unsaved");
                                    Books.SaveTransaction($SavedRow);
                                }
                            }
                            return Books.RenderTransactions(true, NextVisibleStartIndex);
                        });

                    //og-books-batch-expensebuttons
                    var Width; // Save

                    if (ShowDuplicateMessage) {
                        Width = 525;
                        var $Next = $
                            (document.createElement("a")
                                .addClass("og-button-ui-action", "og-button-color-default", "og-books-batch-rendernexttransaction")
                                .attr("href", "#")
                                .setText("מעבר לצילום הבא"))
                            .on("click", function () {
                                return Books.RenderTransactions(true, Books.VisibleStartIndex + 1);
                            });
                        $Cell
                            .append($Next)
                            .append($Save)
                            .append($(document.createElement("a"))
                                .addClass("og-button-ui-action og-button-color-danger")
                                .attr("href", "#")
                                .text("מחיקת התנועה הכפולה")
                                .on("click", function () {
                                    var RowsToDelete = new Array();
                                    for (var i = 0; i < SavedTransactions.length; i++)
                                        RowsToDelete.push(SavedTransactions[i].$Row);
                                    Books.ShowDeleteTransaction(RowsToDelete);
                                    return false;
                                }));
                    }
                    else {
                        Width = 132;
                        $Cell
                            .append($Save);
                    }
                    $("th.og-books-batch-expensebuttons").css("width", Width + "px");
                }
                $Row.append($Cell);

            }
            $Row.append($(document.createElement('td')
                .addClass('og-books-batch-status')
                .attr("tabindex", "0")
            ).append(document.createElement('span'))
            );
            $Row.append($
                (document.createElement('td')
                    .addClass('og-books-batch-transactionnumber')
                    .setText(!IsAdditionalExpense && Transaction.TransactionNumber ? Transaction.TransactionNumber : ""))
                .toggle(Books.ShowTransactionNumber)
            );
            $Row.append($
                (document.createElement('td')
                    .addClass('og-books-batch-linenumber')
                    .setText(!IsAdditionalExpense ? Transaction.LineNumber : ""))
                .toggle(Books.ShowLineNumber)
            );
            var $MenuCell = $(document.createElement('td')
                .addClass("og-books-batch-actions"));
            if (Books.IsExpenses || Books.IsReview) {
                if (IsAdditionalExpense) {
                    var $Previous = $
                        (document.createElement("span")
                            .addClass("og-button-ui-tableicon")
                        )
                        .css("cursor", "default")
                        .append($(document.createElement('span').addClass('icon-sumit-arrow-right-small')).css("visibility", "hidden"));
                    $MenuCell.append($Previous);

                    var $Next = $
                        (document.createElement("span")
                            .addClass("og-button-ui-tableicon")
                        )
                        .css("cursor", "default")
                        .append($(document.createElement('span').addClass('icon-sumit-arrow-left-small')).css("visibility", "hidden"));
                    $MenuCell.append($Next);
                }
                else {
                    var $Previous = $
                        (document.createElement("a")
                            .addClass("og-button-ui-tableicon", "og-books-batch-renderprevioustransaction", "using-tooltip")
                            .attr("href", "#")
                            .attr('title', 'מעבר לצילום הקודם')
                        )
                        .append(document.createElement('span').addClass('icon-sumit-arrow-right-small'))
                        .on("click", function () {
                            return Books.RenderTransactions(true, Books.VisibleStartIndex - 1);
                        });
                    $MenuCell.append($Previous);

                    var $Next = $
                        (document.createElement("a")
                            .addClass("og-button-ui-tableicon", "og-books-batch-rendernexttransaction", "using-tooltip")
                            .attr("href", "#")
                            .attr('title', 'מעבר לצילום הבא')
                        )
                        .append(document.createElement('span').addClass('icon-sumit-arrow-left-small'))
                        .on("click", function () {
                            return Books.RenderTransactions(true, Books.VisibleStartIndex + 1);
                        });
                    $MenuCell.append($Next);
                }
            }

            $MenuCell.append($(document.createElement('span')
                .addClass("teva-dropdown"))
                .data("dropdown-menu", ".og-books-batch-menu")
                .append($
                    (document.createElement('a')
                        .attr("href", "#")
                        .attr('title', 'פעולות נוספות')
                        .addClass("og-button-ui-tableicon", "teva-dropdown-link", "using-tooltip", "og-books-batch-menu-link"))
                    .append(document.createElement('span')
                        .addClass('icon-sumit-more')
                    )
                )
            );
            $Row.append($MenuCell);
        }

        static RefreshFormModified() {
            Forms.ToggleDirty($(".og-books-batch-form"), $(".og-books-batch tbody tr.og-books-batch-unsaved").length > 0);
        }
        static ExitBatch() {
            Navigation.Loading_Show();
            Books.SaveTransactions(function () {
                Navigation.Redirect("/books/database/?databaseid=" + Books.DatabaseID);
            });
            Navigation.Loading_Hide();
            return false;
        }
        static SaveTransactions(SuccessMethod) {
            var $Unsaved = $(".og-books-batch tbody tr.og-books-batch-unsaved");
            if ($Unsaved.length == 0) {
                if (SuccessMethod != null)
                    SuccessMethod();
                return;
            }

            $Unsaved.each(function () {
                var $Row = $(this);
                Books.SaveTransaction($Row, function () {
                    if ($(".og-books-batch tbody tr.og-books-batch-unsaved").length == 0) {
                        if (SuccessMethod != null)
                            SuccessMethod();
                    }
                });
            });
        }
        static SaveTransaction($Row, SuccessMethod?) {
            var Row = $Row[0];
            if (!Row.hasClass("og-books-batch-unsaved"))
                return;

            var Timeout = $Row.data("Timeout");
            if (Timeout != null)
                clearTimeout(Timeout);

            var Transaction = Books.GetTransactionFromRow($Row);
            if (Transaction == null || Transaction.TransactionTypeMismatch)
                return;

            if (Row.hasClass("og-books-batch-saving")) {
                if (!Transaction.FileSavedToBatch)
                    Row.addClass("og-books-batch-pendingresave");
                return;
            }

            if (Transaction.Type && Transaction.Type.length != 0 && Books.TransactionTypePickerDictionary[Transaction.Type] == null) {
                Modals.ShowMessageDialog("צריך לעדכן את סוג התנועה", "סוג התנועה לא קיים במערכת. זה קורה בדרך כלל שמייבאים תנועות.<br />על מנת לערוך את התנועה, יש ליצור את סוג התנועה תחת <a target=\"_blank\" href=\"/f" + Books.TransactionTypesSchemaID + "/\">סוגי תנועות</a> או לבחור סוג תנועה אחר.");
                Row.removeClass("og-books-batch-unsaved");
                $Row.find(".og-books-batch-status")[0]
                    .removeClass("og-books-batch-status-valid")
                    .addClass("og-books-batch-status-error");
                Books.RefreshFormModified();
                return;
            }

            Row.addClass("og-books-batch-saving");

            Transaction = Books.GetTransactionFromRow($Row)
            Transaction.BatchID = Books.BatchID;

            var SerializedTransaction = $.extend({}, Transaction);
            SerializedTransaction.$Row = undefined;
            SerializedTransaction.$Type = undefined;
            SerializedTransaction.$Reference1 = undefined;
            SerializedTransaction.$Reference2 = undefined;
            SerializedTransaction.$ReferenceDate = undefined;
            SerializedTransaction.$AmountILS = undefined;
            SerializedTransaction.$DebitAccount = undefined;
            SerializedTransaction.$CreditAccount = undefined;
            SerializedTransaction.$CustomerSupplierAccount = undefined;
            SerializedTransaction.$BankAccount = undefined;
            SerializedTransaction.$Details = undefined;
            SerializedTransaction.$Remarks = undefined;
            SerializedTransaction.$ValueDate = undefined;
            SerializedTransaction.$ProfitAmountILS = undefined;
            SerializedTransaction.$IncomeExpenseAmountILS = undefined;
            SerializedTransaction.$VATAmountILS = undefined;
            SerializedTransaction.$TaxWithholdingAmountILS = undefined;
            SerializedTransaction.$ForeignCurrency = undefined;
            SerializedTransaction.$AmountForeign = undefined;
            SerializedTransaction.$CompanyNumber = undefined;
            SerializedTransaction.DuplicateGroups = undefined;

            if (SerializedTransaction.ReferenceDate)
                SerializedTransaction.ReferenceDate = Teva.DatePicker.GetDateAsJSONString(SerializedTransaction.ReferenceDate);
            if (SerializedTransaction.ValueDate)
                SerializedTransaction.ValueDate = Teva.DatePicker.GetDateAsJSONString(SerializedTransaction.ValueDate);

            Common.AjaxRequest({
                URL: "/books/savetransaction/?databaseid=" + Books.DatabaseID,
                Data: SerializedTransaction,
                SuccessMethod: function (Response) {
                    if (Response.DebitAccountCode && Transaction.DebitAccountCompanyNumber) {
                        Common.AjaxRequest({
                            URL: "/books/fetchdataaccount/?databaseid=" + Books.DatabaseID + "&accountid=" + Response.DebitAccountID,
                            SuccessMethod: function (Response) {
                                Books.AppendAccount(Response.Accounts[0], Transaction.DebitAccountCompanyNumber, true);
                            }
                        });
                    }
                    if (Response.CreditAccountCode && Transaction.CreditAccountCompanyNumber) {
                        Common.AjaxRequest({
                            URL: "/books/fetchdataaccount/?databaseid=" + Books.DatabaseID + "&accountid=" + Response.CreditAccountID,
                            SuccessMethod: function (Response) {
                                Books.AppendAccount(Response.Accounts[0], Transaction.CreditAccountCompanyNumber, true);
                            }
                        });
                    }
                    if (Response.DuplicateMessage) {
                        Transaction.DuplicateMessage = Response.DuplicateMessage;
                        Transaction.FileSavedToBatch = false;
                        Row.removeClass("og-books-batch-saving");

                        Books.RenderTransactions(true, Books.VisibleStartIndex - 1);
                        var $Modal = Modals.ShowConfirmDialog({
                            Title: "חשד לכפילות",
                            Message: "אנחנו חושדים שתנועה שנשמרה למנה היא תנועה כפולה.<br />אנחנו מחזירים אותך אליה, כדי לאפשר לך להחליט אם לשמור אותה למנה, או למחוק אותה.",
                            ConfirmText: "אישור",
                            ConfirmEvent: function () {
                                Modals.Hide($Modal);
                            },
                        });
                        return;
                    }
                    Transaction.ID = Response.EntityID;
                    if (Response.BatchTransactionNumber)
                        Transaction.BatchTransactionNumber = Response.BatchTransactionNumber;
                    if (Response.TransactionNumber && !Transaction.TransactionNumber) {
                        Transaction.TransactionNumber = Response.TransactionNumber;
                        $Row.find(".og-books-batch-transactionnumber").text(Transaction.TransactionNumber);
                    }

                    Row.removeClass("og-books-batch-saving");

                    if (Row.hasClass("og-books-batch-pendingresave")) {
                        Row.removeClass("og-books-batch-pendingresave");
                        Books.SaveTransaction($Row, SuccessMethod);
                    }
                    else {
                        if (Transaction.FileSavedToBatch || (Books.IsReview && Transaction.ReviewDate)) {
                            Books.RemoveTransactionFromArray($Row, Books.TransactionsArray.length <= 1);
                            Books.RefreshFormModified();
                            return;
                        }

                        if (Response.AmountILS == null)
                            Response.AmountILS = "";
                        if (Response.AmountForeign == null)
                            Response.AmountForeign = "";
                        if (Response.AmountILS != "" && Response.AmountILS != Transaction.AmountILS) {
                            Transaction.AmountILS = Response.AmountILS;
                            Transaction.$AmountILS.val(Response.AmountILS).trigger("change");
                        }
                        if (Response.AmountForeign != "" && Response.AmountForeign != Transaction.AmountForeign) {
                            Transaction.AmountForeign = Response.AmountForeign;
                            Transaction.$AmountForeign.val(Response.AmountForeign);
                        }
                        if (Response.ProfitAmountILS != "" && Response.ProfitAmountILS != Transaction.ProfitAmountILS) {
                            Transaction.ProfitAmountILS = Response.ProfitAmountILS;
                            Transaction.$ProfitAmountILS.val(Response.ProfitAmountILS);
                        }
                        if (Response.IncomeExpenseAmountILS != "" && Response.IncomeExpenseAmountILS != Transaction.IncomeExpenseAmountILS) {
                            Transaction.IncomeExpenseAmountILS = Response.IncomeExpenseAmountILS;
                            Transaction.$IncomeExpenseAmountILS.val(Response.IncomeExpenseAmountILS);
                        }

                        Row.removeClass("og-books-batch-unsaved");
                        Books.RefreshFormModified();
                        Books.UpdateTransactionStatus(Transaction, true);
                        if (SuccessMethod != null)
                            SuccessMethod();
                    }
                },
                SkipAjaxErrorMethod: true,
                ErrorMethod: function () {
                    if (Transaction.FileSavedToBatch)
                        Transaction.FileSavedToBatch = false;

                    Row.removeClass("og-books-batch-saving");
                    $Row.find(".og-books-batch-status").addClass("og-books-batch-status-error");

                    if (Row.hasClass("og-books-batch-pendingresave")) {
                        Row.removeClass("og-books-batch-pendingresave");
                        Books.SaveTransaction($Row, SuccessMethod);
                    }
                    else {
                        Books.UpdateTransactionStatus(Books.GetTransactionFromRow($Row), true);
                        if ($(".modal").length == 0) {
                            Modals.ShowConfirmDialog({
                                Title: "בעיה באינטרנט?",
                                Message: "לפחות אחת מהתנועות במנה לא נשמרה. לרוב זה קורה כי הייתה הפרעה כלשהי בחיבור לאינטרנט.<br />ניתן לנסות לשמור מחדש באמצעות כפתור השמירה, או להמשיך להקליד, והמערכת תנסה לשמור שוב בהמשך.<br /><br />במידת הצורך, ניתן <a href=\"#\" onclick=\"return OfficeGuy.Intercom.Show();\">ליצור קשר</a> עם צוות התמיכה",
                                ConfirmText: "שמירה",
                                ConfirmEvent: function () {
                                    Books.SaveTransaction($Row, SuccessMethod);
                                    return false;
                                }
                            });
                        }
                    }
                },
                ShowLoading: false
            });
        }
        static RemoveTransactionFromArray($Row?, RenderTransactions?) {
            if ($Row == null)
                $Row = $(".og-books-batch tbody tr:first");

            var Transaction = Books.GetTransactionFromRow($Row);
            Books.RefreshTransactionDuplicateKeys($Row, true);
            $Row.remove();
            Books.SpliceSingleValueFromArray(Books.TransactionsArray, Transaction);
            Books.BatchReindexNumbers();

            if (Transaction.LineNumber <= Books.VisibleStartIndex)
                Books.VisibleStartIndex--;

            if (RenderTransactions)
                Books.RenderTransactions(true, Books.VisibleStartIndex);
            else if (Books.IsExpenses || Books.IsReview)
                Books.BatchRefreshFileStatus();
            return false;
        }
        static DeleteTransaction($Row) {
            var Transaction = Books.GetTransactionFromRow($Row);
            if (Transaction.ID == null || Transaction.ID == 0) {
                Books.RemoveTransactionFromArray($Row, Books.IsExpenses || Books.IsReview);
                return;
            }

            Common.AjaxRequest({
                URL: "/books/deletetransaction/?databaseid=" + Books.DatabaseID,
                Data: {
                    ID: Transaction.ID,
                    BatchID: Books.BatchID
                },
                SuccessMethod: function () {
                    Books.RemoveTransactionFromArray($Row, Books.IsExpenses || Books.IsReview);
                    return false;
                },
                ShowLoading: false
            });
        }
        static BatchReindexNumbers() {
            var NextLineNumber = 1;
            for (var i = 0; i < Books.TransactionsArray.length; i++)
                Books.TransactionsArray[i].LineNumber = NextLineNumber++;

            $("tbody .og-books-batch-linenumber").each(function () {
                var Transaction = Books.GetTransactionFromRow($(this).closest("tr"));
                this.setText(Transaction.LineNumber);
            });
        }

        static GetAccountText(Account) {
            if (Account == null)
                return "";
            return Account.Code + ' - ' + Account.Name;
        }
        static GetTransactionTypeText(TransactionType) {
            return TransactionType.Code + ' - ' + TransactionType.Name;
        }
        static RefreshToggles(Save: boolean) {
            $(".og-books-batch-quick").toggle(Books.SingleEntryBatchView);
            $(".og-books-batch-full").toggle(!Books.SingleEntryBatchView);

            $(".og-books-batch-customersupplier").toggle(Books.ShowCustomerSupplier);
            $(".og-books-batch-bank").toggle(Books.ShowBank);
            $(".og-books-batch-foreign").toggle(Books.ShowForeign);
            $(".og-books-batch-companynumber").toggle(Books.ShowCompanyNumber);
            $(".og-books-batch-taxwithholding").toggle(Books.ShowTaxWithholding);
            $(".og-books-batch-profitamountils").toggle(Books.ShowProfitAmountILS);
            $(".og-books-batch-incomeexpenseamountils").toggle(Books.ShowIncomeExpenseAmountILS);
            $(".og-books-batch-valuedate").toggle(Books.ShowValueDate);
            $(".og-books-batch-vatamountils").toggle(Books.ShowVATAmountILS);
            $(".og-books-batch-remarks").toggle(Books.ShowRemarks);
            $(".og-books-batch-transactionnumber").toggle(Books.ShowTransactionNumber);
            $(".og-books-batch-linenumber").toggle(Books.ShowLineNumber);
            $(".og-books-batch-reference2").toggle(Books.ShowReference2);

            $(".og-books-batch-reviewedshow").toggle(Books.IsReview && Books.ShowReviewed);
            $(".og-books-batch-reviewedhide").toggle(Books.IsReview && !Books.ShowReviewed);

            if (Save) {
                Common.AjaxRequest({
                    URL: "/books/togglebatchview/?databaseid=" + Books.DatabaseID,
                    Data: {
                        SingleEntry: Books.SingleEntryBatchView,
                        ShowCustomerSupplier: Books.ShowCustomerSupplier,
                        ShowBank: Books.ShowBank,
                        ShowForeign: Books.ShowForeign,
                        ShowTaxWithholding: Books.ShowTaxWithholding,
                        ShowProfitAmountILS: Books.ShowProfitAmountILS,
                        ShowIncomeExpenseAmountILS: Books.ShowIncomeExpenseAmountILS,
                        ShowCompanyNumber: Books.ShowCompanyNumber,
                        ShowReference2: Books.ShowReference2,
                        ShowValueDate: Books.ShowValueDate,
                        ShowVATAmountILS: Books.ShowVATAmountILS,
                        ShowRemarks: Books.ShowRemarks,
                        ShowTransactionNumber: Books.IsExpenses || Books.IsReview ? null : Books.ShowTransactionNumber,
                        ShowLineNumber: Books.IsExpenses || Books.IsReview ? null : Books.ShowLineNumber
                    },
                    ShowLoading: false
                });
            }
        }
        static IsSystemBatch() {
            return Books.BatchNumber > 10000;
        }
        static ToggleSingleEntryBatchView(Value: boolean) {
            if (Books.SingleEntryBatchView == Value)
                return false;
            Books.SingleEntryBatchView = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleForeign(Value: boolean) {
            if (Books.ShowForeign == Value)
                return false;
            Books.ShowForeign = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleCompanyNumber(Value: boolean) {
            if (Books.ShowCompanyNumber == Value)
                return false;
            Books.ShowCompanyNumber = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleReference2(Value: boolean) {
            if (Books.ShowReference2 == Value)
                return false;
            Books.ShowReference2 = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleTaxWithholding(Value: boolean) {
            if (Books.ShowTaxWithholding == Value)
                return false;
            Books.ShowTaxWithholding = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleVATAmountILS(Value: boolean) {
            if (Books.ShowVATAmountILS == Value)
                return false;
            Books.ShowVATAmountILS = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleRemarks(Value: boolean) {
            if (Books.ShowRemarks == Value)
                return false;
            Books.ShowRemarks = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleValueDate(Value: boolean) {
            if (Books.ShowValueDate == Value)
                return false;
            Books.ShowValueDate = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleProfitAmountILS(Value: boolean) {
            if (Books.ShowProfitAmountILS == Value)
                return false;
            Books.ShowProfitAmountILS = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleIncomeExpenseAmountILS(Value: boolean) {
            if (Books.ShowIncomeExpenseAmountILS == Value)
                return false;
            Books.ShowIncomeExpenseAmountILS = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleReview() {
            Books.IsReview = true;
            $('.og-books-batch').addClass("og-books-batch-review");
            //$(".og-books-batch tbody").empty();
            $(".og-books-batch-cleanreviewedstate").show();
            $(".og-books-batch-closebatch, .og-books-batch-batchsummary, .og-books-batch-editbatchdescription, .og-books-batch-findduplicates, .og-books-batch-deletebatch, .og-books-batch-stornobatch, .og-books-batch-duplicatebatch").hide();
            $(".og-books-batch-reviewedshow").toggle(Books.ShowReviewed);
            $(".og-books-batch-reviewedhide").toggle(!Books.ShowReviewed);
            Books.InitBatchHeader();

            if (Books.TransactionsArrayWithReviewed == null)
                Books.TransactionsArrayWithReviewed = Books.TransactionsArray;
            else
                Books.TransactionsArray = Books.TransactionsArrayWithReviewed;

            if (!Books.ShowReviewed)
                Books.TransactionsArray = Books.TransactionsArray.filter(T => !T.ReviewDate);

            for (var i = 0; i < Books.TransactionsArray.length; i++) {
                Books.TransactionsArray[i].$Row = null;
                if (!Books.TransactionsArray[i].FileGuid)
                    Books.TransactionsArray.splice(i--, 1);
            }

            Modals.HideAll();
            Books.RenderTransactions(true);
            Books.RefreshToggles(false);
            $(window).trigger("resize.og-books-batch");
            return false;
        }
        static ToggleCustomerSupplierAccount(Value: boolean) {
            if (Books.ShowCustomerSupplier == Value)
                return false;
            Books.ShowCustomerSupplier = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleBankAccount(Value: boolean) {
            if (Books.ShowBank == Value)
                return false;
            Books.ShowBank = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleLineNumber(Value: boolean) {
            if (Books.ShowLineNumber == Value)
                return false;
            Books.ShowLineNumber = Value;
            Books.RefreshToggles(true);
            return false;
        }
        static ToggleTransactionNumber(Value: boolean) {
            if (Books.ShowTransactionNumber == Value)
                return false;
            Books.ShowTransactionNumber = Value;
            Books.RefreshToggles(true);
            return false;
        }

        static UpdateTransactionStatus(Transaction, RenderIfChanged: boolean) {
            var $Row = Transaction.$Row;
            var ReferenceDateOffsetIssue = false;
            if ($Row != null) {
                var PreviousTransaction = Books.GetTransactionFromRow($Row.prev());
                if (PreviousTransaction && PreviousTransaction.ReferenceDate && Transaction.ReferenceDate)
                    ReferenceDateOffsetIssue = Math.abs(PreviousTransaction.ReferenceDate.getTime() - Transaction.ReferenceDate.getTime()) > 1000 * 60 * 60 * 24 * 180;
                $Row.toggleClass("og-books-batch-row-referencedateissue", ReferenceDateOffsetIssue);
            }
            if (!Books.BatchClosed && !Books.IsExpenses && Transaction.ID == 0)
                return;

            var IsIncome = false, IsExpense = false, StatusError = false, StatusWarning = false, StatusInformation = false, Description = "";
            if ($Row != null) {
                if ($Row[0].hasClass("og-books-batch-unsaved"))
                    Description += "התנועה ממתינה לשמירה";
                $Row[0].removeClass("og-books-batch-invalidcompanynumber");
            }
            if (Transaction.TransactionTypeMismatch) {
                if (Description != "")
                    Description += ", ";
                Description += Transaction.TransactionTypeMismatch;
                StatusError = true;
            }
            if (Transaction.ReferenceDate == null || Transaction.ReferenceDate == "") {
                if (Description != "")
                    Description += ", ";
                Description += "לא הוזן תאריך אסמכתא";
                StatusError = true;
            }
            if ((Transaction.AmountILS == null || Transaction.AmountILS === "")) {
                if (Description != "")
                    Description += ", ";
                Description += "לא הוזן סכום";
                StatusError = true;
            }
            if (Transaction.VATAmountILS
                && Transaction.IncomeExpenseAmountILS
                && Transaction.AmountILS
                && Transaction.AmountILS != Common.RoundTwoPoints(Transaction.VATAmountILS + Transaction.IncomeExpenseAmountILS)) {

                var MultipleAccounts = false;
                if (Transaction.Type) {
                    var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                    if (TransactionType != null)
                        MultipleAccounts = (TransactionType.Debit != null && TransactionType.Debit.length > 1) || (TransactionType.Credit != null && TransactionType.Credit.length > 1);
                }
                if (MultipleAccounts) {
                    if (Description != "")
                        Description += ", ";
                    Description += "תנועה שגויה, סכום לפני מע\"מ + סכום מע\"מ אינו תואם לסכום התנועה";
                    StatusError = true;
                }
            }
            var AccountsIssue = false;
            var DebitAccountEntered = (Transaction.DebitAccount != "" && Transaction.DebitAccount != "0") || Transaction.DebitAccountCompanyNumber;
            var CreditAccountEntered = (Transaction.CreditAccount != "" && Transaction.CreditAccount != "0") || Transaction.CreditAccountCompanyNumber;
            if (!DebitAccountEntered && !CreditAccountEntered)
                AccountsIssue = true;
            else if (!DebitAccountEntered && Transaction.Type) {
                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                if (TransactionType != null)
                    AccountsIssue = TransactionType.Debit != null && TransactionType.Debit.length > 0;
            }
            else if (!CreditAccountEntered && Transaction.Type) {
                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                if (TransactionType != null)
                    AccountsIssue = TransactionType.Credit != null && TransactionType.Credit.length > 0;
            }
            if (DebitAccountEntered && (Transaction.DebitAccount != "" && Transaction.DebitAccount != "0")) {
                var DebitAccount = Books.AccountPickerDictionary[Transaction.DebitAccount];
                if (DebitAccount) {
                    if (Books.IsIncomeAccount(DebitAccount.Type))
                        IsIncome = true;
                    else if (Books.IsExpenseAccount(DebitAccount.Type))
                        IsExpense = true;
                }
            }
            if (CreditAccountEntered && (Transaction.CreditAccount != "" && Transaction.CreditAccount != "0")) {
                var CreditAccount = Books.AccountPickerDictionary[Transaction.CreditAccount];
                if (CreditAccount) {
                    if (Books.IsIncomeAccount(CreditAccount.Type))
                        IsIncome = true;
                    else if (Books.IsExpenseAccount(CreditAccount.Type))
                        IsExpense = true;
                }
            }

            if (AccountsIssue) {
                if (Description != "")
                    Description += ", ";
                if (Books.DoubleEntrySystem)
                    Description += "לא הוזן בתנועה מפתח חשבון חובה/זכות";
                else if (Transaction.Type)
                    Description += "לא הוזן בתנועה מפתח חשבון חובה/זכות";
                else
                    Description += "לא הוזן סוג תנועה";
                StatusError = true;
            }
            if (!StatusError && Transaction.CreditAccount != "" && Transaction.CreditAccount == Transaction.DebitAccount) {
                if (Description != "")
                    Description += ", ";
                Description += "לא ניתן ליצור תנועה עם חשבון חובה זהה לחשבון זכות";
                StatusError = true;
            }
            if (!StatusError) {
                if ((Transaction.AmountForeign == null || Transaction.AmountForeign == "") && Transaction.ForeignCurrency != "1") {
                    if (Description != "")
                        Description += ", ";
                    Description += "לא הוזן סכום במט\"ח";
                    StatusWarning = true;
                }
                if (Transaction.AmountForeign != null && Transaction.AmountForeign != "" && (Transaction.ForeignCurrency == null || Transaction.ForeignCurrency == "" || Transaction.ForeignCurrency == "1")) {
                    if (Description != "")
                        Description += ", ";
                    Description += "לא הוזן מטבע";
                    StatusWarning = true;
                }
                if (Transaction.CompanyNumber != null && Transaction.CompanyNumber != '' && !OfficeGuy.Inputs.CorporateNumberValidation.IsValid(Transaction.CompanyNumber)) {
                    if (Description != "")
                        Description += ", ";
                    Description += "מספר עוסק שגוי";
                    StatusWarning = true;
                    if ($Row != null)
                        $Row[0].addClass("og-books-batch-invalidcompanynumber");
                }

                if ((Transaction.AmountILS == 0)) {
                    if (Description != "")
                        Description += ", ";
                    Description += "סכום התנועה שהוזן הינו 0";
                    StatusInformation = true;
                }
                if (Transaction.VATAmountILS != Transaction.CalculatedVATAmountILS
                    && Math.abs(Transaction.VATAmountILS - Transaction.CalculatedVATAmountILS) > 0.02
                    && !((Transaction.VATAmountILS == "" || Transaction.VATAmountILS == 0 || Transaction.VATAmountILS == null) && (Transaction.CalculatedVATAmountILS == "" || Transaction.CalculatedVATAmountILS == 0 || Transaction.CalculatedVATAmountILS == null))) {
                    if (Description != "")
                        Description += ", ";
                    if (!Transaction.CalculatedVATAmountILS)
                        Transaction.CalculatedVATAmountILS = 0;
                    Description += "סכום המע\"מ המחושב לפי סוג התנועה אינו תואם לסכום המע\"מ שהוזן ידנית בתנועה (מע\"מ מחושב: " + Transaction.CalculatedVATAmountILS + ")";
                    StatusInformation = true;
                }
                if (Transaction.DuplicateGroups != null) {
                    if (Description != "")
                        Description += ", ";
                    Description += "תנועה כפולה (" + Books.DuplicateSettings[Transaction.DuplicateGroups[0].DuplicateReason].Message + ")";
                    StatusInformation = true;
                }
                if (ReferenceDateOffsetIssue) {
                    if (Description != "")
                        Description += ", ";
                    Description += "המערכת מסמנת באדום תאריכים שגדולים ביותר מחצי שנה מהתאריכים בתנועה שמעליהם. אם התאריך נכון, אפשר להתעלם ולהמשיך בעבודה הרגילה.";
                    StatusInformation = true;
                }
            }
            if (Description == "")
                Description = "תנועה תקינה";

            RenderIfChanged = RenderIfChanged && (Transaction.StatusDescription != Description);
            Transaction.IsIncome = IsIncome;
            Transaction.IsExpense = IsExpense;
            Transaction.StatusError = StatusError;
            Transaction.StatusWarning = StatusWarning;
            Transaction.StatusInformation = StatusInformation;
            Transaction.StatusDescription = Description;
            if (RenderIfChanged && $Row != null)
                Books.RenderTransactionStatus($Row);
        }
        static GetTransactionFromRow($Row) {
            return <Transaction>$Row.data("Transaction");
        }
        static RefreshTransactionColor($Row) {
            var Transaction = Books.GetTransactionFromRow($Row);
            $Row
                .toggleClass("og-books-batch-row-income", Transaction.IsIncome == true && Transaction.IsExpense == false)
                .toggleClass("og-books-batch-row-expense", Transaction.IsExpense == true && Transaction.IsIncome == false);
        }
        static RenderTransactionStatus($Row) {
            var Transaction = Books.GetTransactionFromRow($Row);
            Books.RefreshTransactionColor($Row);
            if (Transaction.StatusError == null)
                return;

            var $Status = $Row.find(".og-books-batch-status");
            $Status.closest("td")
                .attr("title", Transaction.StatusDescription)
                .toggleClass("using-tooltip", Transaction.StatusDescription != "")
                .toggleClass("og-books-batch-status-error", Transaction.StatusError)
                .toggleClass("og-books-batch-status-warning", !Transaction.StatusError && Transaction.StatusWarning)
                .toggleClass("og-books-batch-status-information", !Transaction.StatusError && !Transaction.StatusWarning && Transaction.StatusInformation)
                .toggleClass("og-books-batch-status-valid", !Transaction.StatusError && !Transaction.StatusWarning && !Transaction.StatusInformation)
                .parent().toggleClass("og-books-batch-duplicate", Transaction.DuplicateGroups != null);
        }
        static ShowMenu() {
            var Link = <any>this;
            var $Link = $(Link);
            var $Row = $Link.closest("tr");
            var Row = $Row[0];
            var Transaction = Books.GetTransactionFromRow($Row);

            var $Menu = $(document.createElement('ul'))
                .addClass("teva-dropdown-menu teva-dropdown-menu-single og-books-batch-menu");

            var IsEmptyRow = $Row.next().length == 0 && Transaction.ID == 0;

            var IsAdditionalExpense = Books.IsExpenses && $Row.prev(":not(.og-books-batch-duplicatemessage)").length != 0;

            if (!Books.IsExpenses && !Books.IsReview && !Books.BatchClosed && !Transaction.TransactionTypeMismatch) {
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "#")
                    .attr("disabled", IsEmptyRow ? "disabled" : null)
                    .append('<span class="menu-icon icon-sumit-duplicate"></span>שכפול')
                    .on("click", function () {
                        Books.TransactionsArray[Books.TransactionsArray.length - 1].$Row.remove();

                        var Transaction = jQuery.extend({}, Books.GetTransactionFromRow($Row), {
                            ID: 0,
                            //FileGuid: 0,
                            DuplicateKeys: null,
                            DuplicateGroups: null,
                            Row: null,
                            StatusDescription: null,
                            StatusError: null,
                            StatusWarning: null,
                            Reported: null,
                            Exported: null,
                            DocumentID: null,
                            LineNumber: Books.TransactionsArray[Books.TransactionsArray.length - 1].LineNumber,
                            BatchTransactionNumber: null,
                            TransactionNumber: null,
                            $Row: null,
                            $Type: null,
                            $Reference1: null,
                            $Reference2: null,
                            $ReferenceDate: null,
                            $AmountILS: null,
                            $DebitAccount: null,
                            $CreditAccount: null,
                            $CustomerSupplierAccount: null,
                            $BankAccount: null,
                            $Details: null,
                            $Remarks: null,
                            $ValueDate: null,
                            $ProfitAmountILS: null,
                            $IncomeExpenseAmountILS: null,
                            $VATAmountILS: null,
                            $TaxWithholdingAmountILS: null,
                            $ForeignCurrency: null,
                            $AmountForeign: null,
                            $CompanyNumber: null,
                        });

                        Books.TransactionsArray[Books.TransactionsArray.length - 1] = Transaction;
                        var $NewRow = Books.RenderTransaction($(".og-books-batch tbody"), Transaction, true, false, false);
                        Teva.Navigation.FocusOnFirstField($NewRow);
                        $NewRow.addClass("og-books-batch-unsaved");
                        Books.SaveTransaction($NewRow);

                        var EmptyTransaction = Books.GetEmptyTransaction();
                        Books.TransactionsArray.push(EmptyTransaction);
                        Books.RenderTransaction($(".og-books-batch tbody"), EmptyTransaction, true, false, false);

                        $Menu.remove();
                        return false;
                    })
                );
            }
            if (!Books.IsExpenses && !Books.IsReview && !Transaction.TransactionTypeMismatch) {
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "/books/duplicatetransaction/?databaseid=" + Books.DatabaseID + "&id=" + Transaction.ID + "&currentbatchid=" + Books.BatchID)
                    .attr("disabled", IsEmptyRow ? "disabled" : null)
                    .append('<span class="menu-icon icon-sumit-duplicate"></span>העתקה למנה אחרת')
                );
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "/books/stornotransaction/?databaseid=" + Books.DatabaseID + "&id=" + Transaction.ID + "&currentbatchid=" + Books.BatchID)
                    .attr("disabled", IsEmptyRow ? "disabled" : null)
                    .append('<span class="menu-icon icon-sumit-close"></span>יצירת תנועה נגדית (סטורנו)')
                );
            }
            if (!Books.IsExpenses && !Books.IsReview && !Books.BatchClosed && $(".og-books-batch thead .icon-down, .og-books-batch thead .icon-up").length == 0) {
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "#")
                    .append('<span class="menu-icon icon-sumit-plus"></span>הוספת תנועה מתחת')
                    .on("click", function () {
                        $Menu.remove();
                        var NewTransaction = <any>Books.GetEmptyTransaction();
                        NewTransaction.BatchTransactionNumber = Books.GetTransactionFromRow($Row).BatchTransactionNumber + 1;
                        for (var i = 0; i < Books.TransactionsArray.length; i++)
                            if (Books.TransactionsArray[i].BatchTransactionNumber >= NewTransaction.BatchTransactionNumber)
                                Books.TransactionsArray[i].BatchTransactionNumber++;
                        Books.TransactionsArray.splice($Row.index() + 1, 0, NewTransaction);
                        var $NewRow = Books.RenderTransaction($(".og-books-batch").find("tbody"), NewTransaction, true, false, false);
                        $NewRow.insertAfter($Row).addClass("og-books-batch-unsaved");
                        Books.BatchReindexNumbers(); // Inefficient
                        Books.SaveTransaction($NewRow);
                        return false;
                    })
                );
            }
            if (Books.IsExpenses && !IsAdditionalExpense) {
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "#")
                    .append('<span class="menu-icon icon-sumit-plus"></span>הוספת שורה')
                    .on("click", function () {
                        $Menu.remove();
                        var OriginalTransaction = Books.GetTransactionFromRow($Row);
                        var NewTransaction = Books.GetEmptyTransaction();
                        NewTransaction.FileGuid = OriginalTransaction.FileGuid;
                        NewTransaction.FileName = OriginalTransaction.FileName;
                        NewTransaction.FileHTML = OriginalTransaction.FileHTML;
                        NewTransaction.FilePDF = OriginalTransaction.FilePDF;
                        NewTransaction.FileRotate = OriginalTransaction.FileRotate;
                        NewTransaction.InsertDate = OriginalTransaction.InsertDate;

                        Books.TransactionsArray.push(NewTransaction);
                        var $NewRow = Books.RenderTransaction($(".og-books-batch").find("tbody"), NewTransaction, true, false, false);
                        $NewRow.appendTo($Row.parent()).addClass("og-books-batch-unsaved");
                        //Books.BatchReindexNumbers(); // Inefficient
                        Books.SaveTransaction($NewRow);
                        return false;
                    })
                );
            }
            if (!Books.BatchClosed) {
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "#")
                    .addClass('red')
                    .attr("disabled", IsEmptyRow ? "disabled" : null)
                    .append('<span class="menu-icon icon-sumit-trash"></span>מחיקה')
                    .on("click", function () {
                        $Menu.remove();
                        Books.ShowDeleteTransaction([$Row]);
                        return false;
                    })
                );
            }
            if (Transaction.FileGuid) {
                var $DownloadButton = $(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "#")
                    .attr("target", "_blank")
                    .on("click", function () {
                        window.open("/crm/downloadfile/" + Transaction.FileGuid + "/");
                        $Menu.remove();
                        return false;
                    });
                if (Books.IsExpenses) {
                    $DownloadButton.append('<span class="menu-icon icon-richtext-picture"></span>הורדת הקובץ (' + OfficeGuy.Common.ShortWithDots(Transaction.FileName, 20) + ') <span class="icon-sumit-external"></span>');
                    if (Transaction.FileName.length > 20) {
                        $DownloadButton.addClass("using-tooltip");
                        $DownloadButton.attr("title", Transaction.FileName);
                    }
                }
                else
                    $DownloadButton.append('<span class="menu-icon icon-richtext-picture"></span>הצגת תמונה מקושרת לתנועה <span class="icon-sumit-external"></span>');
                $Menu.append($DownloadButton);
            }
            else if (Transaction.ID != 0) {
                $Menu.append($
                    (document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon")
                        .attr("href", "/books/uploadtransactionfile/?databaseid=" + Books.DatabaseID + "&transactionid=" + Transaction.ID))
                    .append('<span class="menu-icon icon-richtext-picture"></span>העלאת צילום שיקושר לתנועה')
                );
            }
            if (Transaction.FileID && (Books.IsExpenses || Books.IsReview) && !Books.BatchClosed && !IsAdditionalExpense) {
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "/books/fileexpensereject/?databaseid=" + Books.DatabaseID + "&fileid=" + Transaction.ID)
                    .append('<span class="menu-icon icon-sumit-close"></span>החזרת הוצאה ללקוח/ה')
                );
            }
            if (Books.IsExpenses && !IsAdditionalExpense) {
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "/books/expensetoadditionalfiles/?databaseid=" + Books.DatabaseID + "&fileid=" + Transaction.ID)
                    .append('<span class="menu-icon icon-reports"></span>תיוק מסמך לדוח שנתי')
                );

                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "/books/fileexpensesplit/?databaseid=" + Books.DatabaseID + "&fileid=" + Transaction.ID)
                    .append('<span class="menu-icon icon-flow-merge icon-rotate-180"></span>שכפול צילום עם הוצאות מרובות')
                );
                if (Transaction.FilePDF) {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .attr("href", "/books/fileexpensesplitpdfpages/?databaseid=" + Books.DatabaseID + "&fileid=" + Transaction.ID)
                        .append('<span class="menu-icon icon-flow-merge icon-rotate-180"></span>פיצול הוצאה לפי עמודים')
                    );
                }
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "/books/mergeexpenses/?databaseid=" + Books.DatabaseID)
                    .append('<span class="menu-icon icon-flow-merge"></span>איחוד קבצים מתיוק הוצאות')
                );
            }
            if (!Books.IsExpenses) {
                if (Transaction.DocumentID != null) {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .attr("href", "#")
                        .attr("target", "_blank")
                        .append('<span class="menu-icon icon-doc"></span>צפייה במסמך המקושר לתנועה <span class="icon-sumit-external"></span>')
                        .on("click", function () {
                            window.open("/c" + Transaction.DocumentID + "/");
                            $Menu.remove();
                            return false;
                        })
                    );
                }
                else {
                    $Menu.append($
                        (document.createElement('div').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon")
                            .addClass("disabled")
                            .attr("title", "לא קיים קשר למסמך מקורי"))
                        .append('<span class="menu-icon icon-doc"></span>צפייה במסמך המקושר לתנועה')
                    );
                }
                if (Transaction.ID != 0) {
                    $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                        .attr("href", "#")
                        .attr("target", "_blank")
                        .append('<span class="menu-icon icon-richtext-list"></span>צפייה בפירוט תנועות <span class="icon-sumit-external"></span>')
                        .on("click", function () {
                            if (Row.hasClass("og-books-batch-unsaved")) {
                                Books.SaveTransaction($Row, function () {
                                    window.open("/books/showtransaction/?databaseid=" + Books.DatabaseID + "&id=" + Transaction.ID);
                                });
                            }
                            else
                                window.open("/books/showtransaction/?databaseid=" + Books.DatabaseID + "&id=" + Transaction.ID);
                            $Menu.remove();
                            return false;
                        })
                    );
                }
            }

            if (Books.BatchClosed) {
                $Menu.append($(document.createElement('a').addClass("teva-dropdown-menu-item", "teva-dropdown-menu-item-withicon"))
                    .attr("href", "#")
                    .attr("target", "_blank")
                    .append('<span class="menu-icon icon-history"></span>מעקב אחר שינויים <span class="icon-sumit-external"></span>')
                    .on("click", function () {
                        if (Row.hasClass("og-books-batch-unsaved")) {
                            Books.SaveTransaction($Row, function () {
                                Modals.ShowURLModal("/changetracking/entity/?EntityID=" + Transaction.ID + "&hidewarning=true");
                            });
                        }
                        else
                            Modals.ShowURLModal("/changetracking/entity/?EntityID=" + Transaction.ID + "&hidewarning=true");
                        $Menu.remove();
                        return false;
                    })
                );
            }

            $Menu.appendTo(document.body);
            Teva.Dropdown.DropdownButtonClick($Link)
            return false;
        }
        static ReplaceCurrentTransaction(Transactions) {
            var Index = Books.VisibleStartIndex;
            for (var i = 0; i < Transactions.length; i++)
                Books.InsertTransactionToTransactionsArray(Transactions[i], Index++);
            Books.RemoveTransactionFromArray(null, true);
        }

        static ShowDeleteTransaction(Rows) {
            Modals.ShowConfirmDialog({
                Title: "מחיקת תנועה",
                Message: "האם ברצונך למחוק את תנועה זו?",
                ConfirmEvent: function () {
                    for (var i = 0; i < Rows.length; i++)
                        Books.DeleteTransaction(Rows[i]);
                    return false;
                }
            });
        }

        static EnableClosedBatchEdit($Link) {
            $Link.closest(".og-notification-fixed").text("מנה זו סגורה וחסומה לעריכה. עריכת תאריכים, מספרי אסמכתא, פרטים ומספר עוסק מאופשרת.");
            Books.BatchClosedEdit = true;
            $(".og-books-batch tbody").empty();
            for (var i = 0; i < Books.TransactionsArray.length; i++)
                Books.TransactionsArray[i].$Row = null;

            Books.RenderTransactions(true);
            return false;
        }

        static FormatNumber(Value: number | null) {
            if (Value == null)
                return null;
            return Value.toLocaleString('he-IL', { maximumFractionDigits: 2 });
        }

        static UpdateTransactionAmounts($Row) {
            var Transaction = Books.GetTransactionFromRow($Row);
            Transaction.CalculatedVATAmountILS = Books.CalculateAccountTypeAmountFromTransaction(Transaction, Books.IsVATAccount);
            Transaction.VATAmountILS = Transaction.CalculatedVATAmountILS;
            Transaction.TaxWithholdingAmountILS = Books.CalculateAccountTypeAmountFromTransaction(Transaction, Books.IsTaxWithholdingAccount);
            Transaction.ProfitAmountILS = null;
            Transaction.IncomeExpenseAmountILS = null;

            Transaction.$AmountILS.val(Books.FormatNumber(Transaction.AmountILS));
            Transaction.$AmountForeign.val(Books.FormatNumber(Transaction.AmountForeign));
            Transaction.$VATAmountILS
                .val(Books.FormatNumber(Transaction.VATAmountILS))
                .attr("readonly", Books.TransactionTypeSupportsVAT(Transaction.Type) ? null : "readonly");
            Transaction.$ProfitAmountILS.val(Books.FormatNumber(Transaction.ProfitAmountILS));
            Transaction.$IncomeExpenseAmountILS.val(Books.FormatNumber(Transaction.IncomeExpenseAmountILS));
            Transaction.$TaxWithholdingAmountILS
                .val(Books.FormatNumber(Transaction.TaxWithholdingAmountILS))
                .attr("readonly", Transaction.BankSupported || Books.TransactionTypeSupportsTaxWithholding(Transaction.Type) ? null : "readonly");
        }

        static CalculateAccountTypeAmountFromTransaction(Transaction, AccountTypeMethod) {
            if (Transaction.Type == null || Transaction.Type.length == "") {
                var ToReturn = 0;
                var AccountFound = false;
                if (Transaction.DebitAccount != 0) {
                    var Account = Books.AccountPickerDictionary[Transaction.DebitAccount];
                    if (Account != null && AccountTypeMethod(Account.Type)) {
                        ToReturn -= Transaction.AmountILS;
                        AccountFound = true;
                    }
                }
                if (Transaction.CreditAccount != null) {
                    var Account = Books.AccountPickerDictionary[Transaction.CreditAccount];
                    if (Account != null && AccountTypeMethod(Account.Type)) {
                        ToReturn += Transaction.AmountILS;
                        AccountFound = true;
                    }
                }
                if (!AccountFound)
                    return null;

                return OfficeGuy.Common.RoundTwoPoints(Math.abs(ToReturn) * (Transaction.AmountILS < 0 ? -1 : 1));
            }
            else
                return Books.CalculateAccountTypeAmountFromTransactionType(Transaction.Type, Transaction.AmountILS, AccountTypeMethod, Transaction.DebitAccount, Transaction.CreditAccount);
        }
        static CalculateAccountTypeAmountFromTransactionType(TransactionTypeCode, AmountILS, AccountTypeMethod, PrimaryDebitAccount, PrimaryCreditAccount) {
            if (AmountILS == null || AmountILS.length == 0)
                return null;

            if (TransactionTypeCode == null || TransactionTypeCode.length == 0)
                return null;

            var TransactionType = Books.TransactionTypePickerDictionary[TransactionTypeCode];
            if (TransactionType == null)
                return null;

            if (TransactionType.Debit == null && TransactionType.Credit == null)
                return null;

            var TransactionDetails = Books.GetTransactionDetails(AmountILS, PrimaryDebitAccount, PrimaryCreditAccount, TransactionType.DebitAccount, TransactionType.CreditAccount, TransactionType.Debit, TransactionType.Credit);

            var ToReturn = 0;
            var AccountFound = false;
            for (var i = 0; i < TransactionDetails.Debit.length; i++) {
                if (TransactionDetails.Debit[i].AccountType != null && AccountTypeMethod(TransactionDetails.Debit[i].AccountType)) {
                    ToReturn -= TransactionDetails.Debit[i].DebitAmountILS;
                    AccountFound = true;
                }
            }

            for (var i = 0; i < TransactionDetails.Credit.length; i++) {
                if (TransactionDetails.Credit[i].AccountType != null && AccountTypeMethod(TransactionDetails.Credit[i].AccountType)) {
                    ToReturn += TransactionDetails.Credit[i].CreditAmountILS;
                    AccountFound = true;
                }
            }

            if (!AccountFound)
                return null;

            return OfficeGuy.Common.RoundTwoPoints(Math.abs(ToReturn) * (AmountILS < 0 ? -1 : 1));
        }


        static GetTransactionDetails(TransactionAmountILS, TransactionDebitAccountID, TransactionCreditAccountID, TransactionTypePrimaryDebitAccountID, TransactionTypePrimaryCreditAccountID, TransactionTypeDetails_Debit, TransactionTypeDetails_Credit) {
            if (TransactionDebitAccountID == 0)
                TransactionDebitAccountID = TransactionTypePrimaryDebitAccountID;
            if (TransactionCreditAccountID == 0)
                TransactionCreditAccountID = TransactionTypePrimaryCreditAccountID;

            var TotalValue = 0;
            for (var i = 0; i < TransactionTypeDetails_Debit.length; i++)
                TotalValue += TransactionTypeDetails_Debit[i].Value;

            var TotalDebitAmountILS = 0;
            var DebitTransactionDetails = new Array();
            for (var i = 0; i < TransactionTypeDetails_Debit.length; i++) {
                var TransactionTypeDetailsRecord = TransactionTypeDetails_Debit[i];
                var DebitAmountILS = OfficeGuy.Common.RoundEven(TransactionAmountILS * (TransactionTypeDetailsRecord.Value / TotalValue), 2);
                TotalDebitAmountILS += DebitAmountILS;
                var AccountID = TransactionTypeDetailsRecord.IsPrimaryAccount ? TransactionDebitAccountID : TransactionTypeDetailsRecord.Account;
                if (!AccountID)
                    AccountID = 0;
                var Account = AccountID == 0 ? null : Books.AccountPickerDictionary[AccountID];
                DebitTransactionDetails.push({
                    AccountID: AccountID,
                    DebitAmountILS: DebitAmountILS,
                    AccountType: Account ? Account.Type : null
                });
            }
            if (TotalDebitAmountILS != TransactionAmountILS)
                DebitTransactionDetails[0].DebitAmountILS += TransactionAmountILS - TotalDebitAmountILS;

            var TotalCreditAmountILS = 0;
            var CreditTransactionDetails = new Array();
            for (var i = 0; i < TransactionTypeDetails_Credit.length; i++) {
                var TransactionTypeDetailsRecord = TransactionTypeDetails_Credit[i];
                var CreditAmountILS = OfficeGuy.Common.RoundEven(TransactionAmountILS * (TransactionTypeDetailsRecord.Value / TotalValue), 2);
                TotalCreditAmountILS += CreditAmountILS;
                var AccountID = TransactionTypeDetailsRecord.IsPrimaryAccount ? TransactionCreditAccountID : TransactionTypeDetailsRecord.Account;
                if (!AccountID)
                    AccountID = 0;
                var Account = AccountID == 0 ? null : Books.AccountPickerDictionary[AccountID];
                CreditTransactionDetails.push({
                    AccountID: AccountID,
                    CreditAmountILS: CreditAmountILS,
                    AccountType: Account ? Account.Type : null
                });
            }
            if (TotalCreditAmountILS != TransactionAmountILS)
                CreditTransactionDetails[0].CreditAmountILS += TransactionAmountILS - TotalCreditAmountILS;
            return {
                Debit: DebitTransactionDetails,
                Credit: CreditTransactionDetails
            };
        }

        static UpdateTransactionFileGuid(TransactionID, FileGuid) {
            for (var i = 0; i < Books.TransactionsArray.length; i++)
                if (Books.TransactionsArray[i].ID == TransactionID)
                    Books.TransactionsArray[i].FileGuid = FileGuid;
            Modals.HideAll(true);
            return false;
        }

        static IsVATAccount(AccountType: AccountTypeEnum) {
            return AccountType == AccountTypeEnum.IncomeVAT
                || AccountType == AccountTypeEnum.ExpenseVAT
                || AccountType == AccountTypeEnum.AssetExpenseVAT
                || AccountType == AccountTypeEnum.ExpenseImportVAT
                || AccountType == AccountTypeEnum.ExpenseOtherDocumentVAT;
        }
        static IsTaxWithholdingAccount(AccountType: AccountTypeEnum) {
            return AccountType == AccountTypeEnum.TaxWithholdingFromCustomers
                || AccountType == AccountTypeEnum.TaxWithholdingToSuppliers;
        }
        static IsCustomerSupplierAccount(AccountType: AccountTypeEnum) {
            return AccountType == AccountTypeEnum.Customer
                || AccountType == AccountTypeEnum.Supplier
                || AccountType == AccountTypeEnum.CustomerSupplier;
        }
        static IsIncomeAccount(AccountType: AccountTypeEnum) {
            return AccountType == AccountTypeEnum.Income
                || AccountType == AccountTypeEnum.IncomeNoIncomeTax
                || AccountType == AccountTypeEnum.ExemptIncome
                || AccountType == AccountTypeEnum.ExemptIncomeNoIncomeTax
                || AccountType == AccountTypeEnum.ExemptIncomeNoVAT
                || AccountType == AccountTypeEnum.ExemptIncomeNoVATNoIncomeTax
                || AccountType == AccountTypeEnum.AssetIncome
                || AccountType == AccountTypeEnum.ExemptAssetIncome;
        }
        static IsExpenseAccount(AccountType: AccountTypeEnum) {
            return AccountType == AccountTypeEnum.Expense
                || AccountType == AccountTypeEnum.ExpenseNonDeductable
                || AccountType == AccountTypeEnum.Asset
                || AccountType == AccountTypeEnum.PropertyNonDeductable
                || AccountType == AccountTypeEnum.BalanceCancellation;
        }
        static IsProfitAccount(AccountType: AccountTypeEnum) {
            return Books.IsIncomeAccount(AccountType)
                || AccountType == AccountTypeEnum.Expense
                || AccountType == AccountTypeEnum.Asset
                || AccountType == AccountTypeEnum.BalanceCancellation;
        }
        static IsIncomeExpenseAccount(AccountType: AccountTypeEnum) {
            return Books.IsIncomeAccount(AccountType)
                || Books.IsExpenseAccount(AccountType);
        }

        static TransactionTypeSupportsVAT(TransactionTypeCode) {
            if (TransactionTypeCode == null || TransactionTypeCode.length == 0)
                return false;

            var TransactionType = Books.TransactionTypePickerDictionary[TransactionTypeCode];
            if (TransactionType == null)
                return false;

            return TransactionType.AllowVAT;
        }
        static TransactionTypeSupportsTaxWithholding(TransactionTypeCode) {
            if (TransactionTypeCode == null || TransactionTypeCode.length == 0)
                return false;

            var TransactionType = Books.TransactionTypePickerDictionary[TransactionTypeCode];
            if (TransactionType == null)
                return false;

            return TransactionType.AllowTaxWithholding;
        }
        static TransactionTypeSupportsCustomerSupplier(TransactionTypeCode) {
            if (TransactionTypeCode == null || TransactionTypeCode.length == 0)
                return false;

            var TransactionType = Books.TransactionTypePickerDictionary[TransactionTypeCode];
            if (TransactionType == null)
                return false;

            return TransactionType.AllowCustomer || TransactionType.AllowSupplier;
        }

        static TransactionTypeSupportsBank(TransactionTypeCode) {
            if (TransactionTypeCode == null || TransactionTypeCode.length == 0)
                return false;

            var TransactionType = Books.TransactionTypePickerDictionary[TransactionTypeCode];
            if (TransactionType == null)
                return false;

            return TransactionType.AllowBank;
        }

        static InitAccountPickerArray(Callback?) {
            $(document).one("Teva.PageLoad", function () {
                Books.AccountPickerArray = null;
                Books.AccountPickerDictionary = null;
            });
            Books.AccountPickerArray = new Array();
            Books.AccountPickerDictionary = {};
            Common.AjaxRequest({
                URL: "/books/fetchdata/?databaseid=" + Books.DatabaseID + "&includeaccounts=true",
                SuccessMethod: function (Response) {
                    Books.InitPopulateAccounts(Response.Accounts);
                    if (Callback != null)
                        Callback();
                }
            });
        }
        static InitTransactionTypePickerArray(Callback?) {
            $(document).one("Teva.PageLoad", function () {
                Books.TransactionTypePickerArray = null;
                Books.TransactionTypePickerDictionary = null;
            });
            Books.TransactionTypePickerArray = new Array();
            Books.TransactionTypePickerDictionary = {};
            Common.AjaxRequest({
                URL: "/books/fetchdata/?databaseid=" + Books.DatabaseID + "&includetransactiontypes=true",
                SuccessMethod: function (Response) {
                    Books.InitPopulateTransactionTypes(Response.TransactionTypes);
                    if (Callback != null)
                        Callback();
                }
            });
        }
        static InitTransactionTypePicker(Container?): void {
            Teva.SelectBox.Enable($("input.og-books-transactiontypepicker", Container), {
                //FixedPosition: true,
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    if (Books.TransactionTypePickerArray == null) {
                        Books.InitTransactionTypePickerArray(function () {
                            var Data = {
                                results: Books.TransactionTypePickerArray,
                                more: false
                            };
                            Data.results = Teva.SelectBox.FilterResults(Data.results, Query, QueryByID);
                            if (!QueryByID && Query.length > 0)
                                Books.SortAccountsSelectBoxResults(Data.results, Query);
                            Callback(Data, Query);
                        });
                    }
                    else {
                        var Data = {
                            results: Books.TransactionTypePickerArray,
                            more: false
                        };
                        Data.results = Teva.SelectBox.FilterResults(Data.results, Query, QueryByID);
                        if (!QueryByID && Query.length > 0)
                            Books.SortAccountsSelectBoxResults(Data.results, Query);
                        Callback(Data, Query);
                    }
                },
                AllowManualValues: true,
                SelectFirstOnClose: true,
                OnChange: function (Value: string, Text: string, Data: any, SelectBox: Teva.SelectBox) {
                    if (SelectBox.$Input.closest(".og-books-batch").length == 0) {
                        SelectBox.$Input.closest(".og-accordion-content").find(".og-expenses-quick-remarks input").val(Data == null ? null : Data.Details).trigger("change");
                        return;
                    }
                    var $Row = SelectBox.$Input.closest("tr");
                    if (Data == null) {
                        if (Value != "") {
                            SelectBox.ClearValue();
                            Notifications.Show([{
                                Text: "סוג התנועה שהוזן אינו תקין",
                            }]);
                            return;
                        }
                    }
                    else {
                        Books.RefreshTransactionDetailsPlaceholder($Row);
                        var Transaction = Books.GetTransactionFromRow($Row);
                        var DebitAccountInstance = Teva.SelectBox.GetInstance(Transaction.$DebitAccount);
                        var CreditAccountInstance = Teva.SelectBox.GetInstance(Transaction.$CreditAccount);
                        if (Books.IsExpenses && Books.ExpensesReference2) {
                            var $OCRRow = $Row.next();
                            if (Data.AllowCustomer) {
                                $OCRRow.find("td.og-books-batch-reference").append($OCRRow.find(".og-books-batch-reference-ocr"));
                                if (!Transaction.$Reference1.val() && Transaction.$Reference2.val()) {
                                    Transaction.$Reference1.val(Transaction.$Reference2.val()).trigger('change');
                                    Transaction.$Reference2.val('').trigger('change');
                                }
                            }
                            else {
                                $OCRRow.find("td.og-books-batch-reference2").append($OCRRow.find(".og-books-batch-reference-ocr"));
                                if (Transaction.$Reference1.val() && !Transaction.$Reference2.val()) {
                                    Transaction.$Reference2.val(Transaction.$Reference1.val()).trigger('change');
                                    Transaction.$Reference1.val('').trigger('change');
                                }
                            }
                        }
                        if (Books.IsExpenses && Books.DoubleEntrySystem) {
                            var $OCRRow = $Row.next();
                            $OCRRow.find(".og-books-batch-customersupplier").append($OCRRow.find(".og-books-batch-customersupplier-ocr"));
                        }

                        if (Books.IsExpenses && (Data.AllowCustomer == DebitCreditEnum.Debit || Data.AllowSupplier == DebitCreditEnum.Debit)) {
                            var CustomerSupplierAccountInstance = Teva.SelectBox.GetInstance(Transaction.$CustomerSupplierAccount);
                            if (CustomerSupplierAccountInstance.SelectedValue == null || CustomerSupplierAccountInstance.SelectedValue == "" || CustomerSupplierAccountInstance.SelectedValue == "0") {
                                var $Link = $Row.next().find(".og-books-batch-image-ocr-customersupplier:first");
                                if ($Link.length == 0 && Data.DebitAccount == 0)
                                    DebitAccountInstance.ClearValue();
                            }
                        }
                        else if (Data.DebitAccount == 0)
                            DebitAccountInstance.ClearValue();
                        if (Books.IsExpenses && (Data.AllowCustomer == DebitCreditEnum.Credit || Data.AllowSupplier == DebitCreditEnum.Credit)) {
                            var CustomerSupplierAccountInstance = Teva.SelectBox.GetInstance(Transaction.$CustomerSupplierAccount);
                            if (CustomerSupplierAccountInstance.SelectedValue == null || CustomerSupplierAccountInstance.SelectedValue == "" || CustomerSupplierAccountInstance.SelectedValue == "0") {
                                var $Link = $Row.next().find(".og-books-batch-image-ocr-customersupplier:first");
                                if ($Link.length == 0 && Data.CreditAccount == 0)
                                    CreditAccountInstance.ClearValue();
                            }
                        }
                        else if (Data.CreditAccount == 0)
                            CreditAccountInstance.ClearValue();

                        if (Books.IsExpenses && (Data.AllowCustomer == DebitCreditEnum.Debit || Data.AllowSupplier == DebitCreditEnum.Debit)) {
                            var CustomerSupplierAccountInstance = Teva.SelectBox.GetInstance(Transaction.$CustomerSupplierAccount);
                            if (CustomerSupplierAccountInstance.SelectedValue == null || CustomerSupplierAccountInstance.SelectedValue == "" || CustomerSupplierAccountInstance.SelectedValue == "0") {
                                var $Link = $Row.next().find(".og-books-batch-image-ocr-customersupplier:first");
                                if ($Link.length > 0)
                                    $Link.trigger("click");
                                else if (Data.DebitAccount != 0)
                                    DebitAccountInstance.SetValueFromQueryMethod(Data.DebitAccount);
                            }
                            else
                                DebitAccountInstance.SetValue(CustomerSupplierAccountInstance.SelectedValue, CustomerSupplierAccountInstance.SelectedText, CustomerSupplierAccountInstance.SelectedData);
                            if (Books.DoubleEntrySystem) {
                                var $OCRRow = $Row.next();
                                $OCRRow.find(".og-books-batch-debit").append($OCRRow.find(".og-books-batch-customersupplier-ocr"));
                            }
                        }
                        else if (Data.DebitAccount != 0)
                            DebitAccountInstance.SetValueFromQueryMethod(Data.DebitAccount);
                        if (Books.IsExpenses && (Data.AllowCustomer == DebitCreditEnum.Credit || Data.AllowSupplier == DebitCreditEnum.Credit)) {
                            var CustomerSupplierAccountInstance = Teva.SelectBox.GetInstance(Transaction.$CustomerSupplierAccount);
                            if (CustomerSupplierAccountInstance.SelectedValue == null || CustomerSupplierAccountInstance.SelectedValue == "" || CustomerSupplierAccountInstance.SelectedValue == "0") {
                                var $Link = $Row.next().find(".og-books-batch-image-ocr-customersupplier:first");
                                if ($Link.length > 0)
                                    $Link.trigger("click");
                                else if (Data.CreditAccount != 0)
                                    CreditAccountInstance.SetValueFromQueryMethod(Data.CreditAccount);
                            }
                            else
                                CreditAccountInstance.SetValue(CustomerSupplierAccountInstance.SelectedValue, CustomerSupplierAccountInstance.SelectedText, CustomerSupplierAccountInstance.SelectedData);
                            if (Books.DoubleEntrySystem) {
                                var $OCRRow = $Row.next();
                                $OCRRow.find(".og-books-batch-credit").append($OCRRow.find(".og-books-batch-customersupplier-ocr"));
                            }
                        }
                        else if (Data.CreditAccount != 0)
                            CreditAccountInstance.SetValueFromQueryMethod(Data.CreditAccount);
                    }
                    Books.UpdateTransactionAmounts($Row);
                },

                FooterCreateText: "יצירת סוג תנועה",
                FooterCreate: function (Instance: Teva.SelectBox) {
                    var Code = Instance.SelectedText == Instance.$SearchTermsInput.val() ? "" : Instance.$SearchTermsInput.val();
                    var $Modal = Modals.ShowHTMLGetDialog({
                        URL: "/f" + Books.TransactionTypesSchemaID + "/new/?layout=pickermodal&code=" + Code,
                        FullURL: "/f" + Books.TransactionTypesSchemaID + "/new/?layout=pickermodal&code=" + Code,
                        ReplaceModal: true,
                        ConvertToAjax: true,
                        ConvertToAjax_PreRenderEvent: function (ResultData) {
                            if (typeof (ResultData) != "string" && ResultData.EntityID != null && ResultData.EntityID != 0) {
                                if (ResultData.Notifications != null) {
                                    setTimeout(function () {
                                        Notifications.Show(ResultData.Notifications);
                                    }, 200);
                                }
                                var TransactionTypeCode = ResultData.EntityName;

                                Common.AjaxRequest({
                                    URL: "/books/fetchdata/?databaseid=" + Books.DatabaseID + "&includeaccounts=true&includetransactiontypes=true",
                                    SuccessMethod: function (Response) {
                                        if (Books.AccountPickerArray != null) {
                                            Books.AccountPickerArray = new Array();
                                            Books.AccountPickerDictionary = {};
                                            Books.InitPopulateAccounts(Response.Accounts);
                                        }
                                        Books.InitPopulateTransactionTypes(Response.TransactionTypes);
                                        Instance.SetValueFromQueryMethod(TransactionTypeCode);
                                    }
                                });

                                Modals.Hide($Modal);
                                Instance.$Label.trigger('focus');
                                return true;
                            }
                            return false;
                        }
                    });
                    return true;
                },

                ThrottleTimeout: 50,
                EnableCaching: false,
                CtrlClickEvent: function (Value, Data) {
                    if (Data == null)
                        return true;

                    window.open("/f" + Books.TransactionTypesSchemaID + "/c" + Data.ID + "/");
                    return false;
                },
                PlaceHolderText: Books.BatchID == null ? "" : function (SelectBox: Teva.SelectBox) {
                    var Transaction = Books.GetTransactionFromRow(SelectBox.$Input.closest("tr"));
                    return Transaction == null || Transaction.ImportedTransactionType == null ? "" : Transaction.ImportedTransactionType;
                },
                Enabled: !Books.BatchClosed,
                EnabledMethod: function (Instance) {
                    var Transaction = Books.GetTransactionFromRow(Instance.$Input.closest("tr"));
                    return Transaction == null || !Transaction.TransactionTypeMismatch;
                },
                CustomEnterKeyEvent: Books.BatchID == null ? null : Books.BatchEnterKeyEvent
            });
        }
        static RefreshTransactionBankSupport($Row) {
            var Transaction = Books.GetTransactionFromRow($Row);

            var DebitAccountType: AccountTypeEnum = null;
            if (Transaction.DebitAccountType)
                DebitAccountType = Transaction.DebitAccountType;
            else if (Transaction.DebitAccount != 0)
                DebitAccountType = Books.AccountPickerDictionary[Transaction.DebitAccount].Type;

            var CreditAccountType: AccountTypeEnum = null;
            if (Transaction.CreditAccountType)
                CreditAccountType = Transaction.CreditAccountType;
            else if (Transaction.CreditAccount != 0)
                CreditAccountType = Books.AccountPickerDictionary[Transaction.CreditAccount].Type;

            Transaction.BankSupported = DebitAccountType != null
                && CreditAccountType != null
                &&
                (
                    (Books.IsCustomerSupplierAccount(DebitAccountType) && Books.IsIncomeAccount(CreditAccountType))
                    || (Books.IsExpenseAccount(DebitAccountType) && Books.IsCustomerSupplierAccount(CreditAccountType))
                    || (DebitAccountType == AccountTypeEnum.Bank && CreditAccountType != AccountTypeEnum.Bank)
                    || (DebitAccountType != AccountTypeEnum.Bank && CreditAccountType == AccountTypeEnum.Bank)
                );

            var BankAccountSelectBox = Teva.SelectBox.GetInstance(Transaction.$BankAccount);
            BankAccountSelectBox.Toggle(Transaction.BankSupported);
            Transaction.$TaxWithholdingAmountILS.attr("readonly", Transaction.BankSupported || Books.TransactionTypeSupportsTaxWithholding(Transaction.Type) ? null : "readonly")
            //AllowCustomTaxWithholding = true;
        }

        static RefreshTransactionDetailsPlaceholder($Row) {
            var Transaction = Books.GetTransactionFromRow($Row);
            var TransactionTypeDetails = null;
            if (Transaction.Type) {
                var TransactionType = Books.TransactionTypePickerDictionary[Transaction.Type];
                if (TransactionType)
                    TransactionTypeDetails = TransactionType.Details;
            }
            Transaction.DetailsPlaceholder = TransactionTypeDetails;
            if (Books.AutomaticDetailsCustomer || Books.AutomaticDetailsExpense) {
                var CustomerSupplierAccount = null, ExpenseAccount = null;
                if (Transaction.DebitAccount) {
                    var DebitAccount = Books.AccountPickerDictionary[Transaction.DebitAccount];
                    if (Books.IsCustomerSupplierAccount(DebitAccount.Type))
                        CustomerSupplierAccount = DebitAccount;
                    else if (DebitAccount.Type == AccountTypeEnum.Expense || DebitAccount.Type == AccountTypeEnum.ExpenseNonDeductable || DebitAccount.Type == AccountTypeEnum.Asset || DebitAccount.Type == AccountTypeEnum.PropertyNonDeductable)
                        ExpenseAccount = DebitAccount;
                }
                else if (Transaction.DebitAccountName)
                    CustomerSupplierAccount = { Name: Transaction.DebitAccountName };
                if (Transaction.CreditAccount) {
                    var CreditAccount = Books.AccountPickerDictionary[Transaction.CreditAccount];
                    if (Books.IsCustomerSupplierAccount(CreditAccount.Type))
                        CustomerSupplierAccount = CreditAccount;
                    else if (CreditAccount.Type == AccountTypeEnum.Expense || CreditAccount.Type == AccountTypeEnum.ExpenseNonDeductable || CreditAccount.Type == AccountTypeEnum.Asset || CreditAccount.Type == AccountTypeEnum.PropertyNonDeductable)
                        ExpenseAccount = CreditAccount;
                }
                else if (Transaction.CreditAccountName)
                    CustomerSupplierAccount = { Name: Transaction.CreditAccountName };
                if (CustomerSupplierAccount && Books.AutomaticDetailsCustomer && TransactionTypeDetails != CustomerSupplierAccount.Name) {
                    if (Transaction.DetailsPlaceholder)
                        Transaction.DetailsPlaceholder += " / " + CustomerSupplierAccount.Name;
                    else
                        Transaction.DetailsPlaceholder = CustomerSupplierAccount.Name;
                }
                if (ExpenseAccount && Books.AutomaticDetailsExpense && TransactionTypeDetails != ExpenseAccount.Name) {
                    if (Transaction.DetailsPlaceholder)
                        Transaction.DetailsPlaceholder += " / " + ExpenseAccount.Name;
                    else
                        Transaction.DetailsPlaceholder = ExpenseAccount.Name;
                }
            }
            Transaction.$Details.attr('placeholder', Transaction.DetailsPlaceholder);
        }

        static SortAccountsSelectBoxResults(Results, Query) {
            Results.sort(function (a, b) {
                if (a.data.Code == Query)
                    return -1;
                else if (b.data.Code == Query)
                    return 1;

                var StartsA = a.data.Code.startsWith(Query);
                var StartsB = b.data.Code.startsWith(Query);
                if (StartsA && !StartsB)
                    return -1;
                if (!StartsA && StartsB)
                    return 1;

                var CodeA = a.data.Code.padStart(15, '0');
                var CodeB = b.data.Code.padStart(15, '0');
                if (CodeA < CodeB)
                    return -1;
                else if (CodeA > CodeB)
                    return 1;
                else
                    return 0;
            });
        }
        static InitAccountPicker(Container?): void {
            Teva.SelectBox.Enable($("input.og-books-accountpicker", Container), {
                //FixedPosition: true,
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    var Instance = this;
                    var Results = new Array();
                    if (Instance.$Input.parents("td").hasClass("og-books-batch-customersupplier")) {
                        for (var i = 0; i < Books.AccountPickerArray.length; i++) {
                            if (Books.IsCustomerSupplierAccount(Books.AccountPickerArray[i].data.Type))
                                Results.push(Books.AccountPickerArray[i]);
                        }
                    }
                    else if (Instance.$Input.parents("td").hasClass("og-books-batch-bank")) {
                        for (var i = 0; i < Books.AccountPickerArray.length; i++) {
                            if (Books.AccountPickerArray[i].data.Type == AccountTypeEnum.Bank)
                                Results.push(Books.AccountPickerArray[i]);
                        }
                    }
                    else
                        Results = Books.AccountPickerArray;

                    Results = Teva.SelectBox.FilterResults(Results, Query, QueryByID);
                    if (!QueryByID && Query.length > 0)
                        Books.SortAccountsSelectBoxResults(Results, Query);

                    var Data = {
                        more: Results.length > (PageIndex + 1) * 100,
                        results: Results
                    };

                    if (Results.length > 100) {
                        Data.results = new Array();
                        for (var i = PageIndex * 100; i < (PageIndex + 1) * 100 && i < Results.length; i++)
                            Data.results.push(Results[i]);
                    }

                    Callback(Data, Query);
                },
                EnableCaching: false,
                OnChange: function (Value: string, Text: string, Data: any, SelectBox: Teva.SelectBox) {
                    if (Data == null && (Value != "" && Value != "0"))
                        SelectBox.ClearValue();
                    else if (Data && Data.CompanyNumber) {
                        var Transaction = Books.GetTransactionFromRow(SelectBox.$Input.closest('tr'));
                        Transaction.$CompanyNumber.val(Data.CompanyNumber).trigger('change');
                    }
                },
                FooterCreateText: "יצירת כרטיס חשבון",
                FooterCreate: function (Instance: Teva.SelectBox) {
                    var AccountType;
                    var Type = Books.GetTransactionFromRow(Instance.$Input.parents("tr")).Type;
                    if (Type) {
                        var TransactionType = Books.TransactionTypePickerDictionary[Type];
                        if (Instance.$Input.parents("td").hasClass("og-books-batch-customersupplier")) {
                            if (TransactionType.AllowCustomer)
                                AccountType = AccountTypeEnum.Customer;
                            else if (TransactionType.AllowSupplier)
                                AccountType = AccountTypeEnum.Supplier;
                        }
                        else if (Instance.$Input.attr('name') == 'DebitAccount') {
                            if (TransactionType.DebitAccount)
                                AccountType = Books.AccountPickerDictionary[TransactionType.DebitAccount].Type
                        }
                        else if (Instance.$Input.attr('name') == 'CreditAccount') {
                            if (TransactionType.CreditAccount)
                                AccountType = Books.AccountPickerDictionary[TransactionType.CreditAccount].Type
                        }
                    }
                    //if (AccountType == "" && Books.IsExpenses)
                    //    AccountType = "Supplier";
                    var Code = Instance.SelectedText == Instance.$SearchTermsInput.val() ? "" : Instance.$SearchTermsInput.val();

                    var URL = "/f" + Books.AccountsSchemaID + "/new/?layout=pickermodal&" + (isNaN(Number(Code)) ? "name" : "code") + "=" + Code + (AccountType ? "&type=" + AccountType : "");
                    var $Modal = Modals.ShowHTMLGetDialog({
                        URL: URL,
                        FullURL: URL,
                        ReplaceModal: true,
                        ConvertToAjax: true,
                        ConvertToAjax_PreRenderEvent: function (ResultData) {
                            if (typeof (ResultData) != "string" && ResultData.EntityID != null && ResultData.EntityID != 0) {
                                if (ResultData.Notifications != null) {
                                    setTimeout(function () {
                                        Notifications.Show(ResultData.Notifications);
                                    }, 200);
                                }
                                Common.AjaxRequest({
                                    URL: "/books/fetchdataaccount/?databaseid=" + Books.DatabaseID + "&accountid=" + ResultData.EntityID,
                                    SuccessMethod: function (Response) {
                                        Books.AppendAccount(Response.Accounts[0], null, true);
                                        Instance.SetValueFromQueryMethod(ResultData.EntityID);
                                        Modals.Hide($Modal);
                                        Instance.$Label.trigger('focus');
                                    }
                                });
                                return true;
                            }
                            return false;
                        }
                    });
                    return true;
                },
                ThrottleTimeout: 50,
                CtrlClickEvent: function (Value) {
                    if (Value == null || Value == "" || Value == "0" || Number(Value) < 0)
                        return true;

                    window.open("/f" + Books.AccountsSchemaID + "/c" + Value + "/");
                    return false;
                },
                EmptyValue: "0",
                SelectFirstOnClose: true,
                Enabled: !Books.BatchClosed,
                EnabledMethod: function (Instance) {
                    var Transaction = Books.GetTransactionFromRow(Instance.$Input.closest("tr"));
                    return Transaction == null || !Transaction.TransactionTypeMismatch;
                },
                CustomEnterKeyEvent: Books.BatchID == null ? null : Books.BatchEnterKeyEvent,
                FormatResultItem: function (Item) {
                    return $('<div>')
                        .addClass("teva-selectbox-search-results-result-withmenu")
                        .append($('<div>')
                            .addClass("teva-selectbox-search-results-result-withmenu-text")
                            .attr('title', Item.text)
                            .text(Item.text)
                        )
                        .append($('<a>')
                            .addClass('sumit-advancedmenulink teva-selectbox-search-results-result-withmenu-menu')
                            .on('click', function () {
                                Navigation.ShowLightbox('/books/accountpickermenu/?databaseid=' + Books.DatabaseID + '&id=' + Item.id, $(this));
                                return false;
                            })
                            .append($('<span>')
                                .addClass('icon-sumit-more-vertical')
                            )
                        );
                },
            });
        }
        static InitCurrencyPicker(Container?): void {
            Teva.SelectBox.Enable($("input.og-books-currencypicker", Container), {
                //FixedPosition: true,
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    var Data = {
                        results: Teva.SelectBox.FilterResults(Books.CurrenciesArray, Query, QueryByID),
                        more: false
                    };
                    Callback(Data, Query);
                },
                AllowClear: false,
                EnableCaching: false,
                ContainerCssClasses: "input-col-2",
                ThrottleTimeout: 50,
                Enabled: !Books.BatchClosed,
                EnabledMethod: function (Instance) {
                    var Transaction = Books.GetTransactionFromRow(Instance.$Input.closest("tr"));
                    return Transaction == null || !Transaction.TransactionTypeMismatch;
                },
                CustomEnterKeyEvent: Books.BatchID == null ? null : Books.BatchEnterKeyEvent
            });
        }

        static TransactionTypeDetailsDelete(Link, IsCredit) {
            var $Row = $(Link).closest('tr');
            if ($Row.index() == 0) {
                $Row.find("input[name$='.Value']").val("").trigger("change");
                Teva.SelectBox.GetInstance($Row.find("input[name$='.Account.ID']")).ClearValue();
            }
            else {
                OfficeGuy.Forms.NestedForm_Remove(IsCredit ? ".og-books-transactiontypedetails-credit" : ".og-books-transactiontypedetails-debit", IsCredit ? "TransactionTypeDetails_Credit" : "TransactionTypeDetails_Debit", $Row.index());
                $Row.remove();
            }
            return false;
        }

        static InitAccountEditor(DatabaseID) {
            Books.DatabaseID = DatabaseID;
            Books.InitAccountPickerArray();
            var OriginalAccountTypeString = $(".og-books-account-type input:hidden:last").val();
            var OriginalAccountType = <AccountTypeEnum>(OriginalAccountTypeString == "" ? null : OriginalAccountTypeString);
            $(".og-books-account-customer:not(.og-books-account-supplier)").toggle(OriginalAccountType == AccountTypeEnum.Customer || OriginalAccountType == AccountTypeEnum.CustomerSupplier);
            $(".og-books-account-supplier:not(.og-books-account-customer)").toggle(OriginalAccountType == AccountTypeEnum.Supplier || OriginalAccountType == AccountTypeEnum.CustomerSupplier);
            $(".og-books-account-customer.og-books-account-supplier").toggle(Books.IsCustomerSupplierAccount(OriginalAccountType));
            $(".og-books-account-expense:not(.og-books-account-asset)").toggle(OriginalAccountType == AccountTypeEnum.Expense || OriginalAccountType == AccountTypeEnum.ExpenseNonDeductable || OriginalAccountType == AccountTypeEnum.BalanceCancellation);
            $(".og-books-account-asset:not(.og-books-account-expense)").toggle(OriginalAccountType == AccountTypeEnum.Asset || OriginalAccountType == AccountTypeEnum.PropertyNonDeductable);
            $(".og-books-account-expense.og-books-account-asset").toggle(OriginalAccountType == AccountTypeEnum.Expense || OriginalAccountType == AccountTypeEnum.ExpenseNonDeductable || OriginalAccountType == AccountTypeEnum.BalanceCancellation || OriginalAccountType == AccountTypeEnum.Asset || OriginalAccountType == AccountTypeEnum.PropertyNonDeductable);

            $(".og-books-account-code input")
                .on("click input", function () {
                    var $Input = $(this);
                    var Values = Teva.SelectBox.FilterResults(Books.AccountPickerArray, $Input.val(), null);
                    var $Container = $(".og-books-account-code-existing");
                    $Container.empty().toggle(Values.length > 0);
                    for (var i = 0; i < Values.length; i++) {
                        $Container.append(document.createElement("div")
                            .addClass("teva-selectbox-search-results-result")
                            .setText(Values[i].text));
                    }
                })
                .on("focusout", function () {
                    $(".og-books-account-code-existing").hide();
                });

            $(".og-books-account-type input:hidden:last").on("change.books-account", function () {
                var AccountTypeString = $(this).val();
                var AccountType = <AccountTypeEnum>(AccountTypeString == "" ? null : AccountTypeString);

                Teva.SlideOrFade.Toggle($(".og-books-account-customer:not(.og-books-account-supplier)"), AccountType == AccountTypeEnum.Customer || AccountType == AccountTypeEnum.CustomerSupplier);
                Teva.SlideOrFade.Toggle($(".og-books-account-supplier:not(.og-books-account-customer)"), AccountType == AccountTypeEnum.Supplier || AccountType == AccountTypeEnum.CustomerSupplier);
                Teva.SlideOrFade.Toggle($(".og-books-account-customer.og-books-account-supplier"), Books.IsCustomerSupplierAccount(AccountType));
                Teva.SlideOrFade.Toggle($(".og-books-account-expense:not(.og-books-account-asset)"), AccountType == AccountTypeEnum.Expense || AccountType == AccountTypeEnum.ExpenseNonDeductable);
                Teva.SlideOrFade.Toggle($(".og-books-account-asset:not(.og-books-account-expense)"), AccountType == AccountTypeEnum.Asset || AccountType == AccountTypeEnum.PropertyNonDeductable);
                Teva.SlideOrFade.Toggle($(".og-books-account-expense.og-books-account-asset"), AccountType == AccountTypeEnum.Expense || AccountType == AccountTypeEnum.ExpenseNonDeductable || AccountType == AccountTypeEnum.Asset || AccountType == AccountTypeEnum.PropertyNonDeductable);

                if ($("#RenderedFields_EntityID").val() == "0")
                    Books.AccountEditorShowNextAccountCode();
                else if (AccountType != OriginalAccountType && OriginalAccountType != null)
                    Modals.ShowMessageDialog("שינוי סוג חשבון", "לתשומת הלב, עדכון סוג חשבון עלול להשפיע על הדוחות השונים המופקים מהמערכת, ביניהם דוח מע\"מ, מקדמות וכו'.");
            });
            if ($("#RenderedFields_EntityID").val() == "0" && $(".og-books-account-type input:hidden:last").val() != "")
                Books.AccountEditorShowNextAccountCode();
        }
        static AccountEditorShowNextAccountCode() {
            var AccountType = $(".og-books-account-type input:hidden:last").val();
            OfficeGuy.Common.AjaxRequest({
                URL: "/books/findnextaccountnumber/?databaseid=" + Books.DatabaseID + "&accounttype=" + AccountType,
                SuccessMethod: function (Response) {
                    if (Response.AccountType == $(".og-books-account-type input:hidden:last").val())
                        $(".og-books-account-code input").attr("placeholder", Response.NextAccountNumber).trigger("change");
                },
                ShowLoading: false
            });
        }

        static InitTransactionTypeEditor(DatabaseID) {
            Books.DatabaseID = DatabaseID;
            Books.InitTransactionTypePickerArray();

            var OriginalTransactionType = $(".og-books-transactiontype-singleentrytype input:hidden:last").val();
            $(".og-books-transactiontype-currentvatrate").toggle(OriginalTransactionType == "1" || OriginalTransactionType == "3" || OriginalTransactionType == "4" || OriginalTransactionType == "5" || OriginalTransactionType == "12");
            $(".og-books-transactiontype-singleentryexpensevatrate").toggle(OriginalTransactionType == "3" || OriginalTransactionType == "5");
            $(".og-books-transactiontype-singleentryincometaxdeductrate").toggle(OriginalTransactionType == "3" || OriginalTransactionType == "5" || OriginalTransactionType == "15" || OriginalTransactionType == "16");

            var HideFunction = function (Event) {
                if ($(Event.target).closest(".og-books-transactiontype-code input, .og-books-transactiontype-code-existing").length == 0) {
                    $(".og-books-transactiontype-code-existing").hide();
                    $(document).off("click", HideFunction);
                }
            };

            $(".og-books-transactiontype-code input")
                .on("click input", function () {
                    var $Input = $(this);
                    var Values = Teva.SelectBox.FilterResults(Books.TransactionTypePickerArray, $Input.val(), null);
                    var $Container = $(".og-books-transactiontype-code-existing");
                    $Container.empty().toggle(Values.length > 0);
                    for (var i = 0; i < Values.length; i++) {
                        $Container.append(document.createElement("div")
                            .addClass("teva-selectbox-search-results-result")
                            .setText(Values[i].text));
                    }
                    $(document)
                        .off("click", HideFunction)
                        .on("click", HideFunction);
                })
                .on("focusout", function () {
                    $(".og-books-transactiontype-code-existing").hide();
                    $(document).off("click", HideFunction);
                });

            $(".og-books-transactiontype-singleentrytype input:hidden").on("change.books-transactiontype", function () {
                var TransactionType = $(this).val();
                Teva.SlideOrFade.Toggle($(".og-books-transactiontype-currentvatrate"), TransactionType == "1" || TransactionType == "3" || TransactionType == "4" || TransactionType == "5" || TransactionType == "12");
                Teva.SlideOrFade.Toggle($(".og-books-transactiontype-singleentryexpensevatrate"), TransactionType == "3" || TransactionType == "5");
                Teva.SlideOrFade.Toggle($(".og-books-transactiontype-singleentryincometaxdeductrate"), TransactionType == "3" || TransactionType == "5" || TransactionType == "15" || TransactionType == "16");
            });
        }

        static SetActiveDatabase(ID, Name, CompanyName, DoubleEntry) {
            Books.DatabaseID = ID;
            Books.RefreshSideMenu(ID, Name, CompanyName, DoubleEntry);

            $(document).one("Teva.PageLoad", function () {
                Books.DatabaseID = null;
                Books.RefreshSideMenu(null, $(".sumit-sidemenu-item[data-applicationname=BooksCompany]").data("databasename"), CompanyName, $(".sumit-sidemenu-item[data-applicationname=BooksCompany]").data("doubleentry"));
            });
        }
        static RefreshSideMenu(ID, Name, CompanyName, DoubleEntry) {
            $(".sumit-sidemenu-books-doubleentry").toggle(DoubleEntry);
            var $SidebarItem = $(".sumit-sidemenu-item[data-applicationname=BooksCompany]");
            var $SidebarItemLink = $SidebarItem.find('.sumit-sidemenu-item-inner');
            if (ID == 0 || ID == null) {
                if (Name != null && Name != '') {
                    if ($(".sumit-sidemenu-item[data-applicationname=BooksCompany]").data("databaseid")) {
                        $SidebarItemLink
                            .attr("href", "/books/database/?databaseid=" + $(".sumit-sidemenu-item[data-applicationname=BooksCompany]").data("databaseid"))
                            .text("תיק: " + Name);
                    }
                    else {
                        $SidebarItemLink
                            .attr("href", "/books/?companyid=" + $(".sumit-sidemenu-item[data-applicationname=BooksHome]").data("bookscompanyid"))
                            .text("תיק: " + Name);
                    }
                }
                else if (Common.LoggedCompanyID == $(".sumit-sidemenu-item[data-applicationname=BooksHome]").data("bookscompanyid")) {
                    $SidebarItemLink
                        .attr("href", "/books/?companyid=" + Common.LoggedCompanyID)
                        .text("תיק: " + CompanyName);
                }
                else {
                    $SidebarItemLink
                        .attr("href", "/books/createdatabase/?companyid=" + Common.LoggedCompanyID)
                        .text("יצירת תיק לקוח/ה");
                }
            }
            else {
                $SidebarItemLink
                    .attr("href", "/books/database/?databaseid=" + ID)
                    .text("תיק: " + Name);

                var $BooksCompany = $(".sumit-sidemenu-item[data-applicationname=BooksCompany]");
                if ($BooksCompany.length == 0)
                    return;

                if (Books.DatabaseID) {
                    $('.sumit-sidemenu-item-active').removeClass('sumit-sidemenu-item-active');
                    $BooksCompany.addClass("sumit-sidemenu-item-active");
                }
            }
        }

        static VAT_Init(VATRate) {
            $(".og-books-vat-income, .og-books-vat-exemptincome, .og-books-vat-expense, .og-books-vat-assetexpense").find("thead input:checkbox").on("change", function () {
                var $this = $(this);
                $this.closest('table').find('input[type=checkbox]').prop('checked', $this.prop('checked'));
                Books.VAT_Calculate(VATRate, false);
            });
            $(".og-books-vat-income, .og-books-vat-exemptincome, .og-books-vat-expense, .og-books-vat-assetexpense").find("tbody input:checkbox").on("change", function () {
                Books.VAT_Calculate(VATRate, false);
                return false;
            });
            Books.VAT_Calculate(VATRate, false);
        }
        static VAT_Calculate(VATRate, IncludeDifference: boolean) {
            var Income = 0, ExemptIncome = 0, IncomeVAT = 0, ExpenseVAT = 0, AssetExpenseVAT = 0;
            $(".og-books-vat-income tbody input:checked").each(function () {
                var $this = $(this);
                Income += Number($this.closest("tr").data("amount"));
                IncomeVAT += Number($this.closest("tr").data("vat"));
            });

            // Rounding is required for CPA Assist
            var CalculatedIncomeVAT = OfficeGuy.Common.RoundEven(OfficeGuy.Common.RoundEven(Income, 0) * (VATRate / 100), 0);
            if (IncomeVAT != CalculatedIncomeVAT && Math.abs(CalculatedIncomeVAT - IncomeVAT) < 10)
                IncomeVAT = CalculatedIncomeVAT;

            $(".og-books-vat-exemptincome tbody input:checked").each(function () {
                ExemptIncome += Number($(this).closest("tr").data("amount"));
            });
            $(".og-books-vat-expense tbody input:checked").each(function () {
                ExpenseVAT += Number($(this).closest("tr").data("vat"));
            });
            $(".og-books-vat-assetexpense tbody input:checked").each(function () {
                AssetExpenseVAT += Number($(this).closest("tr").data("vat"));
            });

            Income = OfficeGuy.Common.RoundEven(Income, 0);
            ExemptIncome = OfficeGuy.Common.RoundEven(ExemptIncome, 0);
            IncomeVAT = OfficeGuy.Common.RoundEven(IncomeVAT, 0);
            ExpenseVAT = Math.floor(ExpenseVAT);
            AssetExpenseVAT = Math.floor(AssetExpenseVAT);
            var Total = OfficeGuy.Common.RoundEven(IncomeVAT - ExpenseVAT - AssetExpenseVAT, 0);

            $(".og-books-vat-summary-income").text(Income.toLocaleString("en-US"));
            $(".og-books-vat-summary-exemptincome").text(ExemptIncome.toLocaleString("en-US"));
            $(".og-books-vat-summary-incomevat").text(IncomeVAT.toLocaleString("en-US"));
            $(".og-books-vat-summary-expensevat").text(ExpenseVAT.toLocaleString("en-US"));
            $(".og-books-vat-summary-assetexpensevat").text(AssetExpenseVAT.toLocaleString("en-US"));
            $(".og-books-vat-summary-total").text(Total.toLocaleString("en-US"));

            if (IncludeDifference) {
                IncomeVAT = Books.VAT_AddDifference($(".og-books-vat-createtransaction-incomevat"), IncomeVAT);
                ExpenseVAT = Books.VAT_AddDifference($(".og-books-vat-createtransaction-expensevat"), ExpenseVAT);
                AssetExpenseVAT = Books.VAT_AddDifference($(".og-books-vat-createtransaction-assetexpensevat"), AssetExpenseVAT);
            }
            Total = OfficeGuy.Common.RoundTwoPoints(IncomeVAT - ExpenseVAT - AssetExpenseVAT);

            $(".og-books-vat-createtransaction-income input").val(Income);
            $(".og-books-vat-createtransaction-exemptincome input").val(ExemptIncome);
            $(".og-books-vat-createtransaction-incomevat input").val(IncomeVAT);
            $(".og-books-vat-createtransaction-expensevat input").val(ExpenseVAT);
            $(".og-books-vat-createtransaction-assetexpensevat input").val(AssetExpenseVAT);
            $(".og-books-vat-createtransaction-total input").val(Total);
        }
        static VAT_AddDifference($Field, Value) {
            var Difference = Number($Field.data("difference"));
            if (Difference == 0)
                return Value;

            Value = OfficeGuy.Common.RoundEven(Difference + Value, 2);
            var $Label = $Field.find(".sumit-field-value");
            $Label.find(".sumit-field-display-error").remove();
            if (Difference < 0)
                $Label.append($('<div>').addClass('sumit-field-display-error').text("כולל הפחתה של " + (-Difference).toLocaleString("en-US") + " ש\"ח עקב הפרשים"));
            else
                $Label.append($('<div>').addClass('sumit-field-display-error').text("כולל תוספת של " + Difference.toLocaleString("en-US") + " ש\"ח עקב הפרשים"));
            return Value;
        }

        static TaxWithholding_Calculate() {
            var Payment = 0, TaxWithholding = 0, SurplusExpenses = 0, SurplusAdvance = 0, IncomeTaxTaxWithholding = 0, SalaryExpense = 0;
            var SuppliersDictionary = {};
            $(".og-books-taxwithholding-taxwithholdingtransactions tbody input:checked").each(function () {
                var $Row = $(this).closest("tr");
                var SupplierID = $Row.data("supplierid");
                Payment += Number($Row.data("payment"));
                TaxWithholding += Number($Row.data("taxwithholding"));
                SuppliersDictionary[SupplierID] = 1;
            });
            $(".og-books-taxwithholding-surplusexpensestransactions tbody input:checked").each(function () {
                var $Row = $(this).closest("tr");
                SurplusExpenses += Number($Row.data("surplusexpense"));
                SurplusAdvance += Number($Row.data("surplusadvance"));
            });
            $(".og-books-taxwithholding-incometaxtaxwithholdingtransactions tbody input:checked").each(function () {
                var $Row = $(this).closest("tr");
                IncomeTaxTaxWithholding += Number($Row.data("incometaxtaxwithholding"));
            });
            $(".og-books-taxwithholding-salaryexpensetransactions tbody input:checked").each(function () {
                var $Row = $(this).closest("tr");
                SalaryExpense += Number($Row.data("salaryexpense"));
            });

            var Suppliers = Object.keys(SuppliersDictionary).length;
            Payment = OfficeGuy.Common.RoundEven(Payment, 0);
            TaxWithholding = OfficeGuy.Common.RoundEven(TaxWithholding, 0);
            IncomeTaxTaxWithholding = OfficeGuy.Common.RoundEven(IncomeTaxTaxWithholding, 0);
            SalaryExpense = OfficeGuy.Common.RoundEven(SalaryExpense, 0);
            SurplusExpenses = OfficeGuy.Common.RoundEven(SurplusExpenses, 0);
            SurplusAdvance = OfficeGuy.Common.RoundEven(SurplusAdvance, 0);
            var Total = OfficeGuy.Common.RoundEven(TaxWithholding + IncomeTaxTaxWithholding + SurplusAdvance, 0);

            $(".og-books-taxwithholding-summary-suppliers").text(Suppliers.toLocaleString("en-US"));
            $(".og-books-taxwithholding-summary-payment").text(Payment.toLocaleString("en-US"));
            $(".og-books-taxwithholding-summary-taxwithholding").text(TaxWithholding.toLocaleString("en-US"));
            $(".og-books-taxwithholding-summary-incometaxtaxwithholding").text(IncomeTaxTaxWithholding.toLocaleString("en-US"));
            $(".og-books-taxwithholding-summary-salaryexpense").text(SalaryExpense.toLocaleString("en-US"));
            $(".og-books-taxwithholding-summary-surplusexpenses").text(SurplusExpenses.toLocaleString("en-US"));
            $(".og-books-taxwithholding-summary-surplusadvance").text(SurplusAdvance.toLocaleString("en-US"));
            $(".og-books-taxwithholding-summary-total").text(Total.toLocaleString("en-US"));
            $(".og-books-taxwithholding-createtransaction-suppliers input").val(Suppliers);
            $(".og-books-taxwithholding-createtransaction-payment input").val(Payment);
            $(".og-books-taxwithholding-createtransaction-taxwithholding input").val(TaxWithholding);
            $(".og-books-taxwithholding-createtransaction-incometaxtaxwithholding input").val(IncomeTaxTaxWithholding);
            $(".og-books-taxwithholding-createtransaction-salaryexpense input").val(SalaryExpense);
            $(".og-books-taxwithholding-createtransaction-surplusexpenses input").val(SurplusExpenses);
            $(".og-books-taxwithholding-createtransaction-surplusadvance input").val(SurplusAdvance);
            $(".og-books-taxwithholding-createtransaction-total input").val(Total);
        }

        static VAT_CalculateCreateTransaction() {
            var IncomeVAT = Number($('.modal .og-books-vat-createtransaction-incomevat input').val());
            var ExpenseVAT = Number($('.modal .og-books-vat-createtransaction-expensevat input').val());
            var AssetExpenseVAT = Number($('.modal .og-books-vat-createtransaction-assetexpensevat input').val());

            $('.modal .og-books-vat-createtransaction-total input').val(OfficeGuy.Common.RoundTwoPoints(IncomeVAT - ExpenseVAT - AssetExpenseVAT));
        }

        static IncomeTax_Calculate() {
            var Income = 0;
            $(".og-books-incometax-income tbody input:checked").each(function () {
                Income += Number($(this).closest("tr").data("amountils"));
            });

            var DownPayment = 0;
            $(".og-books-incometax-income tbody input:checked").each(function () {
                DownPayment += Number($(this).closest("tr").data("downpayment"));
            });

            var TaxWithholding = 0;
            $(".og-books-incometax-taxwithholding tbody input:checked").each(function () {
                TaxWithholding += Number($(this).closest("tr").data("amountils"));
            });

            var SurplusAdvance = 0;
            $(".og-books-incometax-surplusadvance tbody input:checked").each(function () {
                SurplusAdvance += Number($(this).closest("tr").data("amountils"));
            });

            Income = OfficeGuy.Common.RoundEven(Income, 0);
            DownPayment = OfficeGuy.Common.RoundEven(DownPayment, 0);
            TaxWithholding = OfficeGuy.Common.RoundEven(TaxWithholding, 0)
            SurplusAdvance = OfficeGuy.Common.RoundEven(SurplusAdvance, 0);
            var Payment = OfficeGuy.Common.RoundEven(DownPayment - TaxWithholding - SurplusAdvance, 0);

            $(".og-books-incometax-createtransaction-income input").val(Income.toLocaleString("en-US"));
            $(".og-books-incometax-createtransaction-downpayment input").val(DownPayment.toLocaleString("en-US"));
            $(".og-books-incometax-createtransaction-payment input").val(Payment.toLocaleString("en-US"));

            $(".og-books-incometax-summary-income").text(Income.toLocaleString("en-US"));
            $(".og-books-incometax-summary-downpayment").text(DownPayment.toLocaleString("en-US"));
            $(".og-books-incometax-summary-taxwithholding").text(TaxWithholding.toLocaleString("en-US"));
            $(".og-books-incometax-summary-surplusadvance").text(SurplusAdvance.toLocaleString("en-US"));
            $(".og-books-incometax-summary-payment, .og-books-incometax-createtransaction-payment .input-Decimal div").text(Payment.toLocaleString("en-US"));

            $(".og-books-incometax-createtransaction-taxwithholding input").val(TaxWithholding);
            $(".og-books-incometax-createtransaction-surplusadvance input").val(SurplusAdvance);
        }

        static IncomeTax_CalculateCreateTransaction() {
            var DownPayment = Number($('.modal .og-books-incometax-createtransaction-downpayment input').text());
            var TaxWithholding = Number($('.modal .og-books-incometax-createtransaction-taxwithholding input').val());
            var SurplusAdvance = Number($('.modal .og-books-incometax-createtransaction-surplusadvance input').val());
            if (isNaN(SurplusAdvance))
                SurplusAdvance = 0;

            $('.modal .og-books-incometax-createtransaction-payment .input-Decimal div').text(OfficeGuy.Common.RoundTwoPoints(DownPayment - TaxWithholding - SurplusAdvance).toLocaleString("en-US"));
        }

        static Upload_FileChanged($Input, UploadURL): void {
            var Input = <HTMLInputElement>$Input[0];
            if (!Input.files || !Input.files[0])
                return;

            var PendingCount = Input.files.length;
            var Valid = 0;
            var Invalid = 0;
            $(".sumit-books-file-upload-remarks").removeClass("hide");
            var $Container = $(".sumit-books-file-upload-container").empty();
            var Process = function (File, $Item) {
                var Data = new FormData();
                Data.append('Files', File);

                if ($Item == null) {
                    $Item = $('<div class="sumit-field sumit-field-display">')
                        .append($('<div class="sumit-field-value">')
                            .append($('<div class="sumit-books-file-upload">')
                                .append($('<div class="sumit-books-file-upload-filename">').text(File.name))
                                .append($('<div class="sumit-books-file-upload-status sumit-books-file-upload-status-loading"></div>')
                                )
                            )
                        )
                        .appendTo($Container);
                }
                var ShowCompleteNotification = function () {
                    if (Valid != 0 && Invalid == 0)
                        OfficeGuy.Notifications.Show([{ Text: 'הקבצים הועלו בהצלחה' }]);
                    else if (Valid != 0 && Invalid != 0)
                        OfficeGuy.Notifications.Show([{ Text: 'לתשומת הלב, חלק מהקבצים לא עלו! אפשר לנסות להעלות אותם מחדש' }]);
                    else
                        OfficeGuy.Notifications.Show([{ Text: 'הקבצים לא עלו! אפשר לנסות שוב' }]);

                };

                Common.AjaxRequest({
                    URL: UploadURL,
                    Data: Data,
                    ContentType: false,
                    ProcessData: false,
                    ShowLoading: false,
                    SuccessMethod: function () {
                        PendingCount--;
                        Valid++;
                        $Item.find(".sumit-books-file-upload-status").removeClass("sumit-books-file-upload-status-loading");
                        $Item.find(".sumit-books-file-upload").addClass("sumit-books-file-upload-valid");
                        if (PendingCount == 0)
                            ShowCompleteNotification();
                    },
                    ErrorMethod: function () {
                        PendingCount--;
                        Invalid++;
                        $Item.find(".sumit-books-file-upload-status").removeClass("sumit-books-file-upload-status-loading");
                        $Item.find(".sumit-books-file-upload").addClass("sumit-books-file-upload-error");
                        $Item.find('.sumit-field-value')
                            .append($('<a class="sumit-field-display-error">הקובץ לא עלה! לניסיון חוזר לחצו כאן.</a>')
                                .one("click", function () {
                                    PendingCount++;
                                    Invalid--;
                                    $Item.find(".sumit-field-display-error").remove();
                                    $Item.find(".sumit-books-file-upload").removeClass("sumit-books-file-upload-error");
                                    $Item.find(".sumit-books-file-upload-status").addClass("sumit-books-file-upload-status-loading");
                                    Process(File, $Item);
                                })
                            );
                        if (PendingCount == 0)
                            ShowCompleteNotification();
                    },
                    RetriesPending: 3
                });
            };
            for (var i = 0; i < Input.files.length; i++) {
                var File = Input.files[i];
                Process(File, null);
            }
            Input.val('');
            $Input.trigger('change');
        }

        static DatabaseCorporateTypeSelected(CorporateType) {
            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-socialsecurity-container'), CorporateType == 1 || CorporateType == 2 || CorporateType == 4 || CorporateType == 10);
            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-incometaxdownpaymentrate, .og-books-databasesettings-monthlysocialsecurityamount'), CorporateType != 4);
            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-partnership'), CorporateType == 4);
        }
        static DatabaseVATIntervalSelected(Interval) {
            const ExemptInterval = 1;
            const MonthlyInterval = 2;
            const BimonthlyInterval = 3;

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-vat-monthly'), Interval != BimonthlyInterval);
            $('.og-books-databasesettings-vat-monthly input').attr("disabled", Interval == BimonthlyInterval ? "disabled" : null);

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-vat-bimonthly'), Interval == BimonthlyInterval);
            $('.og-books-databasesettings-vat-bimonthly input').attr("disabled", Interval != BimonthlyInterval ? "disabled" : null);

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-vat'), Interval != ExemptInterval);
        }
        static DatabaseIncomeTaxIntervalSelected(Interval) {
            const MonthlyInterval = 1;
            const BimonthlyInterval = 2;
            const ExemptInterval = 3;

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-incometax-monthly'), Interval != BimonthlyInterval);
            $('.og-books-databasesettings-incometax-monthly input').attr("disabled", Interval == BimonthlyInterval ? "disabled" : null);

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-incometax-bimonthly'), Interval == BimonthlyInterval);
            $('.og-books-databasesettings-incometax-bimonthly input').attr("disabled", Interval != BimonthlyInterval ? "disabled" : null);

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-incometax'), Interval != ExemptInterval);
        }
        static DatabaseTaxWithholdingIntervalSelected(Interval) {
            const ExemptInterval = 1;
            const MonthlyInterval = 2;
            const BimonthlyInterval = 3;
            const HalfYearInterval = 4;
            const YearInterval = 5;

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-taxwithholding-monthly'), Interval == MonthlyInterval);
            $('.og-books-databasesettings-taxwithholding-monthly input').attr("disabled", Interval != MonthlyInterval ? "disabled" : null);

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-taxwithholding-bimonthly'), Interval == BimonthlyInterval);
            $('.og-books-databasesettings-taxwithholding-bimonthly input').attr("disabled", Interval != BimonthlyInterval ? "disabled" : null);

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-taxwithholding-halfyear'), Interval == HalfYearInterval);
            $('.og-books-databasesettings-taxwithholding-halfyear input').attr("disabled", Interval != HalfYearInterval ? "disabled" : null);

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-taxwithholding-yearly'), Interval == YearInterval);
            $('.og-books-databasesettings-taxwithholding-yearly input').attr("disabled", Interval != YearInterval ? "disabled" : null);

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-taxwithholding'), Interval != ExemptInterval);
        }
        static DatabaseSocialSecurityIntervalSelected(Interval) {
            const ExemptInterval = 1;

            Teva.SlideOrFade.Toggle($('.og-books-databasesettings-socialsecurity'), Interval != ExemptInterval);
        }

        static InitManualMatch() {
            $(".og-books-manualmatch-matchamount").on("change", function () {
                var $this = $(this);
                var Value = Number($this.val());
                if (Value < Number($this.attr("min")))
                    $this.val($this.attr("min"));
                else if (Value > Number($this.attr("max")))
                    $this.val($this.attr("max"));
                Books.CalculateManualMatch();
            });
            $(".og-books-manualmatch-selected").on("change", Books.CalculateManualMatch);
            Books.CalculateManualMatch();
        }
        static InitAutoMatch() {
            $(".og-books-automatch-selected").on("change", function () {
                OfficeGuy.CRM.EntitiesList.ToggleSelectedMenu($("tbody .og-books-automatch-selected:checked").length > 0);
            });
            OfficeGuy.CRM.EntitiesList.ToggleSelectedMenu($("tbody .og-books-automatch-selected:checked").length > 0);
        }
        static CalculateManualMatch(): void {
            var SupportMatchAmount = $('.og-books-manualmatch-matchamount').length > 0;
            var Debit = 0, Credit = 0, Checked = false;
            $(".manualmatch tbody input:checkbox:checked").each(function () {
                var $Row = $(this).closest('tr');
                var RowTotal = Number($Row.attr("data-total"));
                var RowDebit = RowTotal < 0 ? -RowTotal : 0;
                var RowCredit = RowTotal >= 0 ? RowTotal : 0;
                if (SupportMatchAmount) {
                    var MatchAmount = Number($Row.find('.og-books-manualmatch-matchamount').val());
                    if (RowDebit > 0)
                        RowDebit = -MatchAmount;
                    else
                        RowCredit = MatchAmount;
                }
                Debit += RowDebit;
                Credit += RowCredit;
                Checked = true;
            });
            Debit = Common.RoundTwoPoints(Debit);
            Credit = Common.RoundTwoPoints(Credit);
            var Total = Common.RoundTwoPoints(Credit - Debit);
            $(".og-bankreconciliation-manual-summary")
                .toggle(Checked)
                .toggleClass("og-bankreconciliation-manual-summary-valid", Total == 0);
            $(".og-books-manualmatch-summary-debit").text(Books.FormatNumber(Debit));
            $(".og-books-manualmatch-summary-credit").text(Books.FormatNumber(Credit));
            $(".og-books-manualmatch-summary-total").text(Books.FormatNumber(Total));

            $("tr.og-books-matching-highlight").removeClass("og-books-matching-highlight");
            $("tr[data-total='" + (-Total) + "']").addClass("og-books-matching-highlight");

            OfficeGuy.CRM.EntitiesList.ToggleSelectedMenu(Checked);
        }

        static InitBooksCounter() {
            var Remaining = 60;
            var $Counters = $(".og-books-bankaccounts-counter");
            var Counter = setInterval(function () {
                Remaining--;
                if (Remaining != 0 && $Counters.is(':visible')) {
                    $('.og-books-bankaccounts-active-counter').text(Remaining);
                }
                else {
                    clearInterval(Counter);
                    $('.og-books-bankaccounts-counter-active').hide();
                    $('.og-books-bankaccounts-counter-complete').show();
                }
            }, 1000);
        }

        static ShowColumnsMenu() {
            OfficeGuy.Modals.ShowHTMLDialog({
                HTML: $('.og-books-columnsmenu'),
                Title: 'בחירת שדות לתצוגה',
                ShowSubmitButton: true
            });
            return false;
        }

        static UpdateVATTransactionReference1(TransactionID, Reference1) {
            Modals.HideAll();
            $("input[name$='.TransactionID'][value='" + TransactionID + "']").closest("tr").find(".og-books-vat-reference1").text(Reference1);
            return false;
        }
        static UpdateVATTransactionCompanyNumber(TransactionID, CompanyNumber) {
            Modals.HideAll();
            $("input[name$='.TransactionID'][value='" + TransactionID + "']").closest("tr").find(".og-books-vat-companynumber").text(CompanyNumber);
            return false;
        }
        static UpdateVATTransactionPCNAccountType(TransactionID, AccountType) {
            Modals.HideAll();
            $("input[name$='.TransactionID'][value='" + TransactionID + "']").closest("tr").find(".og-books-vat-pcnaccounttype").text(AccountType);
            return false;
        }

        static DatabaseRedirect(URL) {
            if ((<any>window.event).ctrlKey || (<any>window.event).shiftKey)
                window.open(URL + "?databaseid=" + Books.DatabaseID);
            else
                Navigation.Redirect(URL + "?databaseid=" + Books.DatabaseID);
            return false;
        }

        static ManualMatchSave() {
            $('#ScrollY').val(Math.floor(window.scrollY));
            if ($('.og-books-manualmatch-summary-total').text() == '0') {
                var SkipManualMatchConfirmation = Teva.Storage.LocalStorage_Get("SkipManualMatchConfirmation", true);
                if (SkipManualMatchConfirmation != null)
                    SkipManualMatchConfirmation = new Date(SkipManualMatchConfirmation);
                if (SkipManualMatchConfirmation == null || SkipManualMatchConfirmation < new Date()) {
                    var $Message = $("<div>");
                    $Message.append($('<div>').text("האם ברצונך לבצע התאמה בין התנועות שסומנו?"));
                    $Message.append($('<div class="sumit-field sumit-field-boolean sumit-field-populated"><div class="sumit-field-label"><div><label for="SkipManualMatchConfirmation">אני רוצה לבצע התאמות מדויקות בשעה הקרובה ללא חלון אישור</label></div></div><div class="sumit-field-value"><input id="SkipManualMatchConfirmation" name="SkipManualMatchConfirmation" type="checkbox" value="false"></div></div>'));
                    var $Modal = OfficeGuy.Modals.ShowConfirmDialog({
                        Title: "ביצוע ההתאמות שנבחרו",
                        Message: $Message,
                        ConfirmEvent: function () {
                            $('#Action').val('Match');
                            if ($Message.find("input:checked").length > 0) {
                                var SkipManualMatchConfirmation = new Date();
                                SkipManualMatchConfirmation.setHours(SkipManualMatchConfirmation.getHours() + 1);
                                Teva.Storage.LocalStorage_Set("SkipManualMatchConfirmation", SkipManualMatchConfirmation);
                            }
                            return OfficeGuy.Forms.SubmitForm($('#Action').closest('form'));
                        },
                        CancelAllowed: true,
                        CancelEvent: function () {
                            Modals.Hide($Modal);
                            return false;
                        },
                        Simple: false
                    });
                }
                else {
                    $('#Action').val('Match');
                    return OfficeGuy.Forms.SubmitForm($('#Action').closest('form'));
                }
            }
            else {
                var Descriptions = "";
                var DescriptionColumnIndex = $(".manualmatch").length == 2 ? 3 : 6;
                $(".manualmatch tbody input:checked").closest("tr").each(function () {
                    if ($(this).find("td")[DescriptionColumnIndex].innerHTML)
                        Descriptions += '<div>' + $(this).find("td")[DescriptionColumnIndex].innerHTML + '</div>';
                })
                $(".og-books-manualmatch-createtransaction-contraaccount .sumit-field-value .sumit-field-display-info").remove();
                $(".og-books-manualmatch-createtransaction-contraaccount .sumit-field-value")
                    .append($("<div>")
                        .addClass("sumit-field-display-info")
                        .html(Descriptions));

                OfficeGuy.Modals.ShowHTMLDialog({
                    Title: 'יצירת תנועת הפרשים',
                    HTML: $('.og-books-manualmatch-createtransaction'),
                    Buttons: [
                        $(document.createElement('input')).attr('type', 'button').addClass('og-button-ui-action og-button-color-submit').val('אישור').on('click', function () {
                            OfficeGuy.Modals.Hide($(this).closest('.modal'));
                            $('#Action').val('CreateTransaction').closest('form').submit();
                            $('#Action').val(null);
                            return false;
                        })
                    ]
                });
            }
            return false;
        }

        static InitMoveVATBetweenMonths() {
            var CurrentVAT = Number($(".og-books-vat-createtransaction-expensevat input").val());

            $(".og-books-vat-movebetweenmonths-updatedvat input")
                .off("input.books-vat")
                .on("input.books-vat", function () {
                    var UpdatedVAT = Number($(this).val());
                    $(".og-books-vat-movebetweenmonths-fromamount input").val(Common.RoundTwoPoints(UpdatedVAT - CurrentVAT));
                    $(".og-books-vat-movebetweenmonths-toamount input").val(Common.RoundTwoPoints(CurrentVAT - UpdatedVAT));
                });
            $(".og-books-vat-movebetweenmonths-fromamount input")
                .off("input.books-vat")
                .on("input.books-vat", function () {
                    var FromAmount = Number($(this).val());
                    var UpdatedVAT = CurrentVAT + FromAmount;
                    $(".og-books-vat-movebetweenmonths-updatedvat input").val(Common.RoundTwoPoints(UpdatedVAT));
                    $(".og-books-vat-movebetweenmonths-toamount input").val(Common.RoundTwoPoints(CurrentVAT - UpdatedVAT));
                });

            $(".og-books-vat-movebetweenmonths-currentvat input, .og-books-vat-movebetweenmonths-updatedvat input")
                .val(CurrentVAT)
                .trigger("change");
        }

        static FieldCalculator($Input) {
            var Value = <string>$Input.val();
            if (Value == "")
                return;
            var ToReturn = Number(Value);
            if (!isNaN(ToReturn))
                return;

            for (var i = 0; i < Value.length; i++)
                if (!((Value[i] >= '0' && Value[i] <= '9') || Value[i] == '.' || Value[i] == '+' || Value[i] == '-' || Value[i] == '*' || Value[i] == '/' || Value[i] == '(' || Value[i] == ')'))
                    return;

            try {
                ToReturn = eval(Value);
            }
            catch {
                return;
            }
            if (isNaN(ToReturn))
                return;
            $Input.val(ToReturn);
        }

        static UpdateBankAccountRefreshFromDate(Value) {
            if (Value) {
                Common.AjaxRequest({
                    URL: "/books/updatebankaccountgetfromdate/?databaseid=" + Books.DatabaseID + "&accountid=" + Value,
                    SuccessMethod: function (Response) {
                        $("input[name=FromDate]").attr("placeholder", Response.Date);
                    }
                });
            }
        }

        static ToggleExpensesFullScreen(FullScreen) {
            if (FullScreen) {
                document.body.requestFullscreen();
                $("#main-page").addClass("main-page-fullscreen");
                $("#main-content").attr("style", "padding-right: 0 !important");
                $(".og-books-fullscreenexitnotification").show();
                $(document).on("fullscreenchange.books", function () {
                    if (!document.fullscreenElement) {
                        Books.ToggleExpensesFullScreen(false);
                        $(document).off("fullscreenchange.books");
                    }
                });
            }
            else {
                if (document.fullscreenElement) {
                    var d = <any>document;
                    if (d.exitFullscreen)
                        d.exitFullscreen();
                    else if (d.mozCancelFullScreen) /* Firefox */
                        d.mozCancelFullScreen();
                    else if (d.webkitExitFullscreen)  /* Chrome, Safari and Opera */
                        d.webkitExitFullscreen();
                    else if (d.msExitFullscreen) /* IE/Edge */
                        d.msExitFullscreen();
                }
                $("#main-page").removeClass("main-page-fullscreen");
                $("#main-content").removeAttr("style");
                $(".og-books-fullscreenexitnotification").hide();
            }
            return false;
        }

        static SendMessageToCustomer(Link, DatabaseID) {
            var Template = $("input[name='MessageTemplate.ID']").val();
            if (Template != "0")
                window.open("/books/sendmessage/?databaseid=" + DatabaseID + "&templateid=" + Template);
            else
                Navigation.Redirect("/books/sendmessage/?databaseid=" + DatabaseID + "&templateid=" + Template);
            $(Link).text("שליחה חוזרת »").attr("title", "המערכת זוכרת שלחצת על הכפתור בדקות האחרונות, אבל אין בעיה ללחוץ עליו שוב").addClass("using-tooltip");
            return false;
        }

        static StoreField(FieldIndex, Value, SerializedValues) {
            var $Container = $(".og-books-yearlyform-field-" + FieldIndex);
            $Container.find("input:visible").val(Value);
            $Container.find("input:hidden").val(SerializedValues);
            Modals.HideAll();
        }

        static ShowField($Link, FormID, FieldIndex) {
            var ValueInt64 = $Link.closest('td').find('input:visible').val();
            var SerializedValues = $Link.closest('td').find('input:hidden').val();
            Modals.ShowHTMLGetDialog({
                URL: '/books/formfield/?formid=' + FormID + '&fieldindex=' + FieldIndex,
                Method: 'POST',
                Data: {
                    IsGet: true,
                    "Field.Data.ValueInt64": ValueInt64,
                    "Field.Data.SerializedValues": SerializedValues
                },
                ReplaceModal: true,
                ConvertToAjax: true
            });
            return false;
        }

        static AdjustmentTypeChanged() {
            var TypeSelectBox = Teva.SelectBox.GetInstance($('.og-books-adjustment-type input.entitypicker'));
            if (!TypeSelectBox.ChangeEventFromInit) {
                var SelectedData = TypeSelectBox.SelectedData;
                $('.og-books-adjustment-rate input').val(SelectedData ? SelectedData.AdditionalFields['Books.AdjustmentTypes.Rate'] : '');
                Teva.SelectBox.GetInstance($('.og-books-adjustment-adjustmentaccount input.entitypicker')).SetValue(SelectedData ? SelectedData.AdditionalFields['Books.AdjustmentTypes.AdjustmentAccount'].ID : 0, SelectedData ? SelectedData.AdditionalFields['Books.AdjustmentTypes.AdjustmentAccount'].Name : '', SelectedData ? { schemaid: SelectedData.AdditionalFields['Books.AdjustmentTypes.AdjustmentAccount'].SchemaID } : null);
                Teva.SelectBox.GetInstance($('.og-books-adjustment-expenseaccount input.entitypicker')).SetValue(SelectedData ? SelectedData.AdditionalFields['Books.AdjustmentTypes.ExpenseAccount'].ID : 0, SelectedData ? SelectedData.AdditionalFields['Books.AdjustmentTypes.ExpenseAccount'].Name : '', SelectedData ? { schemaid: SelectedData.AdditionalFields['Books.AdjustmentTypes.ExpenseAccount'].SchemaID } : null);
                $(".og-books-adjustment-yearlylimit").text(SelectedData ? SelectedData.AdditionalFields['Books.AdjustmentTypes.YearlyLimit'] : '');
            }
        }

        static AdjustmentAccountChanged() {
            var Date = $(".og-books-adjustment-date input").val();
            var AdjustmentAccountID = $(".og-books-adjustment-adjustmentaccount input.entitypicker").val();

            OfficeGuy.Common.AjaxRequest({
                URL: "/books/getpreviouslyadjustedamount/?databaseid=" + Books.DatabaseID + "&date=" + Date + '&adjustmentaccountid=' + AdjustmentAccountID,
                SuccessMethod: function (Response) {
                    $(".og-books-adjustment-yearlyadjusted").text(Response.YearlyAdjustedAmount);
                },
                ShowLoading: false
            });
            return false;
        }


        static AdjustmentExpenseAccountChanged() {
            var Date = $(".og-books-adjustment-date input").val();
            var ExpenseAccountID = $(".og-books-adjustment-expenseaccount input.entitypicker").val();

            OfficeGuy.Common.AjaxRequest({
                URL: "/books/getadjustmentbalance/?databaseid=" + Books.DatabaseID + "&date=" + Date + '&expenseaccountid=' + ExpenseAccountID,
                SuccessMethod: function (Response) {
                    $(".og-books-adjustment-amountils input").attr('placeholder', Response.Balance).trigger('change');
                    $(".og-books-adjustment-hiddenamountils input").val(Response.Balance);
                    Books.AdjustmentAmountsRefresh();
                },
                ShowLoading: false
            });
            return false;
        }

        static AdjustmentAmountsRefresh() {
            var AmountILS = $(".og-books-adjustment-amountils input").val() ? Number($(".og-books-adjustment-amountils input").val()) : Number($(".og-books-adjustment-amountils input").attr('placeholder'));
            var Rate = Number($(".og-books-adjustment-rate input").val());
            var AdjustedAmountILS = Common.RoundTwoPoints(AmountILS * Rate / 100);

            $(".og-books-adjustment-adjustedamountils input").attr('placeholder', AdjustedAmountILS).trigger('change');
            $(".og-books-adjustment-hiddenadjustedamountils input").val(AdjustedAmountILS);
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Apps.Books.InitTransactionTypePicker(Container);
    OfficeGuy.Apps.Books.InitAccountPicker(Container);
    OfficeGuy.Apps.Books.InitCurrencyPicker(Container);
});

